var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable */
import { Dictionary } from '../../base/dictionary';
import { WAbstractList } from '../list/abstract-list';
import { WLevelOverride } from '../list/level-override';
import { WSectionFormat, WCharacterFormat, WParagraphFormat, WStyles, WColumnFormat } from '../format/index';
import { Layout } from './layout';
import { Renderer } from './render';
import { createElement, Browser, L10n, updateCSSText } from '@syncfusion/ej2-base';
import { Page, Rect, Widget, ListTextElementBox, FieldElementBox, ParagraphWidget, HeaderFooterWidget, Padding, DropDownFormField, TextFormField, CheckBoxFormField, ShapeElementBox, TextFrame, ContentControl, Footnote, FootnoteElementBox, FootNoteWidget, TextElementBox, ShapeBase, ImageElementBox, GroupShapeElementBox } from './page';
import { BodyWidget, LineWidget, TableWidget, TableRowWidget, BookmarkElementBox } from './page';
import { HelperMethods, Point } from '../editor/editor-helper';
import { TextHelper } from './text-helper';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { CommentReviewPane } from '../index';
import { Zoom } from './zooming';
import { Dialog, createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import { beforePaneSwitchEvent, keyDownEvent, beforeFormFieldFillEvent, afterFormFieldFillEvent } from '../../base/index';
import { RestrictEditing } from '../restrict-editing/restrict-editing-pane';
import { FormFieldPopUp } from '../dialogs/form-field-popup';
import { ContentControlPopUp } from '../dialogs/content-control-popup';
import { ChangesSingleView, TrackChangesPane } from '../track-changes/track-changes-pane';
import { Themes } from '../themes/themes';
import { beforeAutoResize, internalAutoResize, internalStyleCollectionChange } from '../../base/constants';
import { incrementalOps } from '../../base/index';
/**
 * @private
 */
export class DocumentHelper {
    //#endregion
    constructor(owner) {
        /**
         * @private
         */
        this.isCompleted = true;
        /**
         * @private
         * To set the copied content to the clipboard. Reserved for internal use.
         */
        this.isCopying = false;
        /**
         * @private
         */
        this.isSelectionCompleted = true;
        /**
         * @private
         */
        this.scrollbarWidth = 0;
        /**
         * @private
         */
        this.isWebPrinting = false;
        /**
         * @private
         */
        this.isDoubleTap = false;
        /**
         * @private
         */
        this.isHeaderFooter = false;
        /**
         * @private
         */
        this.isSpellCheckPending = false;
        /**
         * @private
         */
        this.triggerSpellCheckForHF = false;
        /**
         * @private
         */
        this.currentPage = undefined;
        this.selectionStartPageIn = undefined;
        this.selectionEndPageIn = undefined;
        /**
         * @private
         */
        this.fieldStacks = [];
        /**
         * @private
         */
        this.splittedCellWidgets = [];
        /**
         * @private
         */
        this.tableLefts = [];
        /**
         * @private
         */
        this.tapCount = 0;
        this.timer = -1;
        this.isTimerStarted = false;
        /**
         * @private
         */
        this.isFirstLineFitInShiftWidgets = false;
        /**
         * @private
         */
        this.preZoomFactor = 0;
        /**
         * @private
         */
        this.preDifference = -1;
        /**
         * @private
         */
        this.isDragging = false;
        /**
         * @private
         */
        this.fieldEndParagraph = undefined;
        /**
         * @private
         */
        this.fieldToLayout = undefined;
        /**
         * @private
         */
        this.backgroundColor = '#FFFFFF';
        // Event
        /**
         * @private
         */
        this.isMouseDown = false;
        this.isKeyPressEvent = false;
        this.isMouseEntered = false;
        this.isMouseLeaved = false;
        this.scrollMoveTimer = 0;
        /**
         * @private
         */
        this.isSelectionChangedOnMouseMoved = false;
        /**
         * @private
         */
        this.isControlPressed = false;
        /**
         * @private
         */
        this.isTouchInput = false;
        /**
         * @private
         */
        this.isTouchMoved = false;
        /**
         * @private
         */
        this.useTouchSelectionMark = false;
        /**
         * @private
         */
        this.touchDownOnSelectionMark = 0;
        /**
         * @private
         */
        this.isComposingIME = false;
        /**
         * @private
         */
        this.lastComposedText = '';
        /**
         * @private
         */
        this.isCompositionStart = false;
        /**
         * @private
         */
        this.isCompositionUpdated = false;
        /**
         * @private
         */
        this.isCompositionCanceled = false;
        /**
         * @private
         */
        this.isCompositionEnd = false;
        /**
         * @private
         */
        this.prefix = '';
        /**
         * @private
         */
        this.suffix = '';
        /**
         * @private
         */
        this.fields = [];
        /**
         * @private
         */
        this.heightInfoCollection = {};
        /**
         * @private
         */
        this.defaultTabWidth = 36;
        /**
         * @private
         */
        this.dontUseHtmlParagraphAutoSpacing = false;
        /**
         * @private
         */
        this.allowSpaceOfSameStyleInTable = false;
        /**
         * @private
         */
        this.alignTablesRowByRow = false;
        /**
         * @private
         */
        this.compatibilityMode = 'Word2013';
        /**
         * @private
         */
        this.lists = [];
        /**
         * @private
         */
        this.comments = [];
        /**
         * @private
         */
        this.authors = new Dictionary();
        /**
         * @private
         */
        this.revisionsInternal = new Dictionary();
        /**
         * @private
         */
        this.commentUserOptionId = 1;
        /**
         * @private
         */
        this.abstractLists = [];
        /**
         * @private
         */
        this.styles = new WStyles();
        /**
         * @private
         */
        this.stylesMap = new Dictionary();
        /**
         * @private
         */
        this.preDefinedStyles = undefined;
        /**
         * @private
         */
        this.isRowOrCellResizing = false;
        /**
         * @private
         */
        this.endBookmarksUpdated = [];
        /**
         * @private
         */
        this.formFields = [];
        this.isMouseDownInFooterRegion = false;
        this.pageFitTypeIn = 'None';
        /**
         * @private
         */
        this.fieldCollection = [];
        /**
         * @private
         */
        this.isPageField = false;
        /**
         * @private
         */
        this.mouseDownOffset = new Point(0, 0);
        this.zoomFactorInternal = 1;
        /**
         * If movecaretposition is 1, Home key is pressed
         * If moveCaretPosition is 2, End key is pressed
         *
         * @private
         */
        this.moveCaretPosition = 0;
        /**
         * @private
         */
        this.isTextInput = false;
        /**
         * @private
         */
        this.isScrollHandler = false;
        /**
         * @private
         */
        this.triggerElementsOnLoading = false;
        /**
         * @private
         */
        this.triggerSpellCheck = false;
        //Document Protection Properties Starts
        /**
         * preserve the format
         *
         * @private
         */
        this.restrictFormatting = false;
        /**
         * preserve the document protection type either readonly or no protection
         *
         * @private
         */
        this.protectionType = 'NoProtection';
        /**
         * Preserve the password protection is enforced or not
         *
         * @private
         */
        this.isDocumentProtected = false;
        /**
         * preserve the hash value of password
         *
         * @private
         */
        this.hashValue = '';
        /**
         * @private
         */
        this.saltValue = '';
        /**
         * @private
         */
        this.userCollection = [];
        /**
         * @private
         */
        this.cachedPages = [];
        /**
         * @private
         */
        this.skipScrollToPosition = false;
        /**
         * @private
         */
        this.isIosDevice = false;
        /**
         * @private
         */
        this.isMobileDevice = false;
        /**
         * @private
         */
        this.isLinuxOS = false;
        /**
         * @private
         */
        this.isFormFilling = false;
        /**
         * @private
         */
        this.fontSubstitutionTable = undefined;
        /**
         * @private
         */
        this.themes = new Themes();
        /**
         * @private
         */
        this.hasThemes = false;
        /**
         * @private
         */
        this.footnotes = new Footnote();
        /**
         * @private
         */
        this.endnotes = new Footnote();
        /**
         * @private
         */
        this.isFootnoteWidget = false;
        /**
         * @private
         */
        this.isDragStarted = false;
        /**
         * @private
         */
        this.isMouseDownInSelection = false;
        /**
         * @private
         */
        this.isSelectionActive = false;
        /**
         * @private
         */
        this.isBookmarkInserted = true;
        /**
         * @private
         */
        this.isUpdatedWhileLoadAsync = false;
        this.isMappedContentControlUpdated = true;
        this.isAutoResizeCanStart = false;
        this.isRestartNumbering = false;
        this.isKeySelection = false;
        /**
         * @private
         * Indicates whether the composition end event has been triggered.
         */
        this.isCompositionEndTriggered = false;
        /**
         * @private
         */
        this.currentDocumentLoadId = 0;
        this.scheduledTimeouts = {};
        /**
         * @private
         */
        this.isDocumentLoadAsynchronously = false;
        /**
        * @private
        */
        this.resizerBoundaryWidth = 0;
        /**
         * @private
         * @param {TextEvent} event - Specifies text event.
         * @returns {void}
         */
        this.onTextInput = (event) => {
            if (!this.isComposingIME && !this.isCompositionEndTriggered) {
                event.preventDefault();
                const text = event.data;
                this.owner.editorModule.handleTextInput(text);
            }
        };
        //#region Composition Event
        /**
         * Fires when composition starts.
         *
         * @private
         * @returns {void}
         */
        this.compositionStart = () => {
            if (!Browser.isDevice && !this.owner.isReadOnlyMode) {
                this.isComposingIME = true;
                this.positionEditableTarget();
                if (this.owner.editorHistoryModule) {
                    this.owner.editorModule.initComplexHistory('IMEInput');
                }
                if (this.editableDiv && this.editableDiv.innerHTML != "") {
                    this.editableDiv.innerHTML = "";
                }
            }
            this.isCompositionStart = true;
            this.isCompositionEndTriggered = false;
        };
        /**
         * Fires on every input during composition.
         *
         * @private
         * @returns {void}
         */
        this.compositionUpdated = () => {
            if (this.isComposingIME && !this.owner.isReadOnlyMode) {
                setTimeout(() => {
                    this.owner.editorModule.insertIMEText(this.getEditableDivTextContent(), true);
                }, 0);
            }
            this.isCompositionUpdated = true;
        };
        /**
         * Fires when user selects a character/word and finalizes the input.
         *
         * @private
         * @param {CompositionEvent} event - Specifies text compisition event.
         * @returns {void}
         */
        this.compositionEnd = (event) => {
            if (this.isComposingIME && !this.owner.isReadOnlyMode) {
                this.isCompositionEndTriggered = true;
                const text = this.getEditableDivTextContent();
                if (text !== '') {
                    this.owner.editorModule.insertIMEText(text, false);
                }
                this.isComposingIME = false;
                this.lastComposedText = '';
                const cssText = 'pointer-events:none;position:absolute;left:' + this.owner.viewer.containerLeft + 'px;top:' + this.owner.viewer.containerTop + 'px;outline:none;background-color:transparent;width:0px;height:0px;overflow:hidden';
                updateCSSText(this.iframe, cssText);
                this.editableDiv.innerHTML = '';
                if (this.owner.editorHistoryModule) {
                    if (text !== '') {
                        this.owner.editorModule.isSkipOperationsBuild = this.owner.enableCollaborativeEditing;
                    }
                    this.owner.editorHistoryModule.updateComplexHistory();
                    if (text === '') {
                        //When the composition in live. The Undo operation will terminate the composition and empty text will be return from text box.
                        //At that time the the history should be updated. Undo the operation and clear the redo stack. This undo operation will not be saved for redo operation.
                        this.owner.editorModule.isSkipOperationsBuild = this.owner.enableCollaborativeEditing;
                        this.owner.editorHistoryModule.undo();
                        this.owner.editorHistoryModule.redoStack.pop();
                    }
                    this.owner.editorModule.isSkipOperationsBuild = false;
                }
            }
            event.preventDefault();
            this.isCompositionUpdated = false;
            this.isCompositionEnd = true;
        };
        /* eslint-disable @typescript-eslint/no-explicit-any */
        this.onImageResizer = (args) => {
            if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.owner.imageResizerModule) &&
                this.owner.imageResizerModule.isImageResizerVisible && this.owner.imageResizerModule.isImageResizing) {
                if (args instanceof MouseEvent) {
                    this.onMouseUpInternal(args);
                }
                else if (args instanceof TouchEvent) {
                    this.onTouchUpInternal(args);
                }
            }
            if (this.scrollMoveTimer || this.isMouseLeaved) {
                this.isMouseLeaved = false;
                this.isMouseEntered = true;
                if (this.isMouseDown) {
                    this.isSelectionActive = false;
                    this.owner.fireSelectionChange();
                }
                clearInterval(this.scrollMoveTimer);
            }
        };
        /* eslint-enable @typescript-eslint/no-explicit-any */
        /**
         * @private
         * @param {KeyboardEvent} event - Specifies keyboard event
         * @returns {void}
         */
        this.onKeyPressInternal = (event) => {
            this.isKeyPressEvent = true;
            const key = HelperMethods.getLegacyKeyCode(event);
            this.triggerElementsOnLoading = false;
            let ctrl = (event.ctrlKey || event.metaKey) ? true : ((key === 17) ? true : false); // ctrl detection
            const alt = event.altKey ? event.altKey : ((key === 18) ? true : false); // alt key detection
            if (Browser.isIE && alt && ctrl) {
                ctrl = false;
            }
            // tslint:disable-next-line:max-line-length
            if (ctrl && event.key === 'v' || ctrl && event.key === 'a' || (ctrl || (this.isControlPressed && Browser.isIE)) && event.key === 'p') {
                if (Browser.isIE) {
                    this.isControlPressed = false;
                }
                return;
            }
            if (!this.owner.isReadOnlyMode && this.owner.editorModule.canEditContentControl || (this.owner.documentHelper.protectionType === 'FormFieldsOnly' && this.owner.editorModule.canEditContentControl && !isNullOrUndefined(this.owner.documentHelper.selection) && this.owner.documentHelper.selection.checkContentControlLocked()) || (!isNullOrUndefined(this.selection) && this.selection.isInlineFormFillMode())) {
                let char = '';
                // Prefer the actual printable character from event.key for keypress event
                if (event.key && event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey) {
                    char = event.key;
                }
                else {
                    const charCode = (event.charCode && event.charCode !== 0) ? event.charCode : key;
                    if (charCode) {
                        char = String.fromCharCode(charCode);
                    }
                    else if (event.key) {
                        char = event.key;
                    }
                }
                if (char !== ' ' && char !== '\r' && char !== '\b' && char !== String.fromCharCode(27) && !ctrl) {
                    this.triggerSpellCheck = false;
                    this.isSpellCheckPending = true;
                    this.triggerSpellCheckForHF = true;
                    this.owner.editorModule.handleTextInput(char);
                    this.triggerSpellCheckForHF = false;
                }
                else if (char === ' ') {
                    this.isSpellCheckPending = false;
                    this.triggerSpellCheck = true;
                    this.owner.editorModule.handleTextInput(' ');
                    this.triggerSpellCheck = false;
                }
                event.preventDefault();
            }
            this.owner.focusIn();
            this.isKeyPressEvent = false;
        };
        /**
         * @private
         * @param {KeyboardEvent} event - Specifies keyboard event
         * @returns {void}
         */
        this.onTextInputInternal = (event) => {
            if (!this.owner.isReadOnlyMode) {
                this.owner.editorModule.onTextInputInternal();
            }
            else {
                this.editableDiv.innerText = '';
            }
        };
        /**
         * Fired on copy.
         *
         * @private
         * @param {ClipboardEvent} event - Specifies clipboard event.
         * @returns {void}
         */
        this.onCopy = (event) => {
            if (this.isCopying && !isNullOrUndefined(this.selection) && !this.selection.isEmpty) {
                this.owner.selection.onCopy(event);
                event.preventDefault();
            }
        };
        /**
         * Fired on paste.
         *
         * @private
         * @param {ClipboardEvent} event - Specifies clipboard event.
         * @returns {void}
         */
        this.onPaste = (event) => {
            if ((!this.owner.isReadOnlyMode && this.owner.editorModule.canEditContentControl) || this.selection.isInlineFormFillMode()) {
                this.owner.editorModule.pasteInternal(event);
            }
            this.editableDiv.innerText = '';
            event.preventDefault();
        };
        /**
         * Fires when editable div loses focus.
         *
         * @private
         * @returns {void}
         */
        this.onFocusOut = () => {
            if (!isNullOrUndefined(this.selection)) {
                if (this.owner.contextMenuModule && this.owner.contextMenuModule.contextMenuInstance &&
                    this.owner.contextMenuModule.contextMenuInstance.element.style.display === 'block') {
                    return;
                }
                this.selection.hideCaret();
            }
        };
        /**
         * Updates focus to editor area.
         *
         * @private
         * @returns {void}
         */
        this.updateFocus = () => {
            if (this.owner.enableCollaborativeEditing && this.owner.editorModule.isRemoteAction) {
                return;
            }
            if (!isNullOrUndefined(this.currentSelectedComment) && !this.owner.commentReviewPane.commentPane.isEditMode) {
                if (this.owner.commentReviewPane && this.owner.commentReviewPane.commentPane.isEditMode) {
                    this.owner.commentReviewPane.commentPane.selectComment(this.currentSelectedComment);
                }
                this.selection.hideCaret();
                return;
            }
            if (this.selection && !(this.isMobileDevice && this.owner.isReadOnly)) {
                if (navigator !== undefined && !Browser.isDevice && !Browser.isIE && !navigator.userAgent.match('Edge')
                    && !isNullOrUndefined(this.iframe)) {
                    this.iframe.focus();
                }
                if (!isNullOrUndefined(this.editableDiv) && !isNullOrUndefined(this.viewerContainer)) {
                    if (this.isKeyPressEvent && !this.isScrollHandler) {
                        this.editableDiv.focus({ preventScroll: true });
                    }
                    else {
                        const currentScrollTop = this.viewerContainer.scrollTop;
                        const currentScrollLeft = this.viewerContainer.scrollLeft;
                        this.editableDiv.focus();
                        if (this.viewerContainer.scrollTop !== currentScrollTop) {
                            this.viewerContainer.scrollTop = currentScrollTop;
                        }
                        if (this.viewerContainer.scrollLeft !== currentScrollLeft) {
                            this.viewerContainer.scrollLeft = currentScrollLeft;
                        }
                    }
                }
                this.selection.showCaret();
            }
        };
        /**
         * Fires on scrolling.
         *
         * @returns {void}
         */
        this.scrollHandler = () => {
            if (this.scrollTimer) {
                clearTimeout(this.scrollTimer);
            }
            this.clearContent();
            this.isScrollHandler = true;
            if (!Browser.isDevice && !this.isComposingIME) {
                this.iframe.style.top = this.owner.viewer.containerTop + 'px';
                this.iframe.style.left = this.owner.viewer.containerLeft + 'px';
            }
            if (this.owner.hRuler) {
                this.hRuler = this.owner.element.querySelector('#' + this.owner.element.id + ('_hRulerBottom'));
                this.hRuler.style.top = this.viewerContainer.scrollTop + 'px';
                this.markIndicator = this.owner.element.querySelector('#' + this.owner.element.id + ('_markIndicator'));
                if (this.markIndicator) {
                    this.markIndicator.style.top = this.viewerContainer.scrollTop + 'px';
                }
            }
            if (this.owner.vRuler) {
                this.vRuler = this.owner.element.querySelector('#' + this.owner.element.id + ('_vRulerBottom'));
                this.vRuler.style.left = this.viewerContainer.scrollLeft + 'px';
                this.markIndicator = this.owner.element.querySelector('#' + this.owner.element.id + ('_markIndicator'));
                if (this.markIndicator) {
                    this.markIndicator.style.left = this.viewerContainer.scrollLeft + 'px';
                }
            }
            if (this.owner.rulerHelper && !isNullOrUndefined(this.owner.rulerHelper.vRulerBottom)) {
                this.owner.rulerHelper.vRulerBottom.style.height = this.pageContainer.offsetHeight + 'px';
            }
            this.owner.viewer.updateScrollBars();
            const vtHeight = this.owner.viewer.containerTop + this.visibleBounds.height - (this.owner.viewer.padding.top + this.owner.viewer.padding.bottom);
            if (vtHeight > this.pageContainer.offsetHeight) {
                this.viewerContainer.scrollTop = this.owner.viewer.containerTop - (vtHeight - this.pageContainer.offsetHeight);
            }
            if (this.isDocumentLoadAsynchronously) {
                const spinnerPane = this.viewerContainer.querySelector('.e-spinner-pane');
                if (spinnerPane) {
                    spinnerPane.style.top = this.viewerContainer.scrollTop + 'px';
                }
            }
            if (!isNullOrUndefined(this.owner) && this.owner.viewer instanceof PageLayoutViewer) {
                this.owner.fireViewChange();
            }
            this.isScrollHandler = false;
            this.scrollTimer = setTimeout(() => {
                if (!this.isScrollHandler && !isNullOrUndefined(this.owner) && this.owner.isSpellCheck) {
                    this.isScrollToSpellCheck = true;
                    this.owner.viewer.updateScrollBars();
                }
            }, 200);
        };
        /**
         * Fires when the window gets resized.
         *
         * @private
         * @returns {void}
         */
        this.onWindowResize = () => {
            if (!isNullOrUndefined(this.owner) && this.owner.isContainerResize) {
                this.owner.isContainerResize = false;
                return;
            }
            if (this.resizeTimer) {
                clearTimeout(this.resizeTimer);
            }
            this.resizeTimer = setTimeout(() => {
                if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.owner.element)) {
                    this.updateViewerSize();
                    if (this.owner.rulerHelper && this.owner.documentEditorSettings && this.owner.documentEditorSettings.showRuler) {
                        this.owner.rulerHelper.updateRuler(this.owner, true);
                    }
                    if (this.owner.enableCollaborativeEditing && this.owner.collaborativeEditingHandlerModule) {
                        this.owner.collaborativeEditingHandlerModule.updateCaretPosition();
                    }
                    this.clearContent();
                    this.owner.viewer.updateScrollBars();
                    if (!isNullOrUndefined(this.selection)) {
                        this.selection.updateCaretPosition();
                    }
                    this.updateTouchMarkPosition();
                    if (this.owner.contextMenuModule && this.owner.contextMenuModule.contextMenuInstance) {
                        this.owner.contextMenuModule.contextMenuInstance.close();
                    }
                    if (this.resizeTimer) {
                        clearTimeout(this.resizeTimer);
                    }
                }
            }, 200);
        };
        /**
         * @private
         * @param {MouseEvent} event - Specified mouse event.
         * @returns {void}
         */
        this.onContextMenu = (event) => {
            if (this.owner.contextMenuModule) {
                if (this.isIosDevice) {
                    this.onMouseUpInternal(event);
                }
                if (this.isMouseDown) {
                    this.isMouseDown = false;
                }
                this.owner.contextMenuModule.onContextMenuInternal(event);
                this.updateFocus();
            }
        };
        /**
         * Called on mouse down.
         *
         * @private
         * @param {MouseEvent} event - Specifies mouse event.
         * @returns {void}
         */
        this.onMouseDownInternal = (event) => {
            const target = event.target;
            this.owner.focusIn();
            if ((!isNullOrUndefined(target) && target !== this.viewerContainer) || this.owner.isTableMarkerDragging || this.isTouchInput ||
                event.offsetX > (this.visibleBounds.width - (this.visibleBounds.width - this.viewerContainer.clientWidth))
                || event.offsetY > (this.visibleBounds.height - (this.visibleBounds.height - this.viewerContainer.clientHeight))) {
                return;
            }
            this.isFootnoteWidget = false;
            if (!isNullOrUndefined(this.selection)) {
                this.updateCursor(event);
                if (this.formFillPopup) {
                    this.formFillPopup.hidePopup();
                }
                if (this.contentDropDown) {
                    this.contentDropDown.hidePopup();
                }
                if (this.isLeftButtonPressed(event) && !this.owner.isReadOnlyMode && this.owner.enableImageResizerMode && !isNullOrUndefined(this.owner.imageResizerModule.selectedResizeElement)) {
                    if (this.selection.isInShape) {
                        const textFram = this.owner.selectionModule.getCurrentTextFrame();
                        const shape = textFram.containerShape;
                        this.selection.selectShape(shape);
                    }
                    this.owner.imageResizerModule.isImageResizing = true;
                }
                event.preventDefault();
                if (!this.isTouchInput) {
                    this.selection.hideCaret();
                }
                const cursorPoint = new Point(event.offsetX, event.offsetY);
                const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, true, true);
                this.mouseDownOffset.x = touchPoint.x;
                this.mouseDownOffset.y = touchPoint.y;
                this.isMouseDownInFooterRegion = this.selection.isCursorInsidePageRect(cursorPoint, this.currentPage) && this.selection.isCursorInFooterRegion(cursorPoint, this.currentPage);
                this.isSelectionChangedOnMouseMoved = false;
                if (!this.owner.isReadOnlyMode && (this.owner.editorModule.tableResize.isInCellResizerArea(touchPoint) ||
                    this.owner.editorModule.tableResize.isInRowResizerArea(touchPoint))) {
                    this.selection.hideCaret();
                    this.isMouseDown = true;
                    this.isSelectionChangedOnMouseMoved = false;
                    if (this.isLeftButtonPressed(event)) {
                        this.owner.editorModule.tableResize.startingPoint.x = touchPoint.x;
                        this.owner.editorModule.tableResize.startingPoint.y = touchPoint.y;
                        this.owner.editorModule.tableResize.handleResize(touchPoint);
                    }
                    return;
                }
                if (event.ctrlKey) {
                    this.isControlPressed = true;
                }
                if (this.owner.selectionModule.isEmpty) {
                    this.useTouchSelectionMark = false;
                }
                const widget = this.getLineWidget(touchPoint);
                if (event.button === 2 && !this.owner.selectionModule.isEmpty
                    && this.selection.checkCursorIsInSelection(widget, touchPoint)) {
                    event.preventDefault();
                    return;
                }
                if (this.owner && this.owner.documentEditorSettings && this.owner.documentEditorSettings.allowDragAndDrop &&
                    !this.owner.selectionModule.isEmpty
                    && this.selection.checkCursorIsInSelection(widget, touchPoint)) {
                    this.isMouseDownInSelection = true;
                }
                this.isTouchInput = false;
                this.isMouseDown = true;
                this.updateFocus();
                /* eslint-disable @typescript-eslint/indent */
                this.timer = setTimeout(() => {
                    this.tapCount++;
                    if (this.tapCount > 1) {
                        this.tapCount = 1;
                    }
                    if (!this.isScrollHandler && !isNullOrUndefined(this.owner) && this.owner.isSpellCheck) {
                        this.isScrollToSpellCheck = true;
                        this.owner.viewer.updateScrollBars();
                    }
                }, 100);
            }
        };
        /**
         * Called on mouse move.
         *
         * @private
         * @param {MouseEvent} event - Specified mouse event.
         * @returns {void}
         */
        this.onMouseMoveInternal = (event) => {
            if (!isNullOrUndefined(event.target) && event.target !== this.viewerContainer || this.owner.isTableMarkerDragging) {
                return;
            }
            event.preventDefault();
            if (!isNullOrUndefined(this.selection)) {
                //For image Resizing
                if (!this.owner.isReadOnlyMode && this.owner.enableImageResizerMode
                    && this.owner.imageResizerModule.isImageResizing) {
                    if (!this.owner.imageResizerModule.isImageMoveToNextPage) {
                        this.owner.imageResizerModule.handleImageResizingOnMouse(event);
                    }
                    return;
                }
                const cursorPoint = new Point(event.offsetX, event.offsetY);
                const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, !this.owner.enableHeaderAndFooter);
                const widget = this.getLineWidget(touchPoint);
                const startWidget = this.getLineWidget(this.mouseDownOffset);
                if (this.isMouseDown
                    && this.isLeftButtonPressed(event)
                    && !this.isDragStarted
                    && isNullOrUndefined(startWidget)
                    && !this.isRowOrCellResizing) {
                    this.isSelectionChangedOnMouseMoved = true;
                    this.updateFocus();
                    return;
                }
                if (this.isMouseDown) {
                    if (!isNullOrUndefined(this.currentPage)) {
                        const xPosition = touchPoint.x;
                        const yPosition = touchPoint.y;
                        if (!this.owner.isReadOnlyMode && this.isRowOrCellResizing) {
                            const table = this.owner.editorModule.tableResize.currentResizingTable;
                            const startPosition = this.selection.setPositionForBlock(table, true);
                            const endPosition = this.selection.setPositionForBlock(table, false);
                            if (!(this.owner.documentHelper.isDocumentProtected) || this.selection.checkSelectionIsAtEditRegion(startPosition, endPosition)) {
                                this.owner.editorModule.tableResize.handleResizing(touchPoint);
                            }
                        }
                        else {
                            if ((!this.isDragStarted
                                && this.isMouseDownInSelection
                                && this.isLeftButtonPressed(event)
                                && !this.owner.selectionModule.isEmpty
                                && this.selection.checkCursorIsInSelection(widget, touchPoint)) || (!this.owner.isReadOnlyMode && this.owner.enableImageResizerMode && !this.isDragStarted && this.isLeftButtonPressed(event) && !this.owner.selectionModule.isEmpty && !isNullOrUndefined(widget) && this.owner.imageResizerModule.selectedImageWidget.containsKey(widget) && !this.owner.imageResizerModule.isImageResizing)) {
                                this.isDragStarted = true;
                                this.isMouseDownInSelection = false;
                                if (this.selection.isForward) {
                                    this.dragStartParaInfo = this.selection.getParagraphInfo(this.selection.start);
                                    this.dragEndParaInfo = this.selection.getParagraphInfo(this.selection.end);
                                }
                                else {
                                    this.dragStartParaInfo = this.selection.getParagraphInfo(this.selection.end);
                                    this.dragEndParaInfo = this.selection.getParagraphInfo(this.selection.start);
                                }
                                this.selection.caret.classList.remove("e-de-cursor-animation");
                            }
                            if (!(this.isTouchInput || this.isSelectionChangedOnMouseMoved || this.touchDownOnSelectionMark > 0 || this.isDragStarted)) {
                                this.updateTextPositionForSelection(touchPoint, 1);
                                if (!isNullOrUndefined(this.currentSelectedComment) && this.owner.commentReviewPane
                                    && !this.owner.commentReviewPane.commentPane.isEditMode) {
                                    this.currentSelectedComment = undefined;
                                }
                            }
                            if (this.isLeftButtonPressed(event) && !this.isDragStarted) {
                                event.preventDefault();
                                const touchY = yPosition;
                                const textPosition = this.owner.selectionModule.end;
                                const touchPoint = new Point(xPosition, touchY);
                                if (!this.owner.enableImageResizerMode || !this.owner.imageResizerModule.isImageResizerVisible
                                    || this.owner.imageResizerModule.isShapeResize) {
                                    this.isSelectionActive = true;
                                    this.isCompleted = false;
                                    this.owner.selectionModule.moveTextPosition(touchPoint, textPosition);
                                }
                                this.isSelectionChangedOnMouseMoved = true;
                            }
                            if (this.isDragStarted && this.isLeftButtonPressed(event)) {
                                this.autoScrollOnSelection(cursorPoint);
                                if (!isNullOrUndefined(widget)) {
                                    this.selection.updateTextPosition(widget, touchPoint);
                                }
                            }
                        }
                    }
                    this.selection.checkForCursorVisibility();
                }
                if (this.isDragStarted && this.isLeftButtonPressed(event) && this.owner.isReadOnlyMode) {
                    const div = this.viewerContainer;
                    div.style.cursor = 'not-allowed';
                }
                else if (!this.isRowOrCellResizing && !this.isSelectionChangedOnMouseMoved) {
                    this.updateCursor(event);
                }
                if (this.isRowOrCellResizing) {
                    this.selection.hideCaret();
                }
            }
        };
        /**
         * @private
         * @param {MouseEvent} event - Specifies mouse event
         * @returns {void}
         */
        this.onMouseLeaveInternal = (event) => {
            event.preventDefault();
            this.isMouseLeaved = true;
            if (this.isDragStarted) {
                this.selection.hideCaret();
                if (this.scrollMoveTimer) {
                    clearInterval(this.scrollMoveTimer);
                    this.scrollMoveTimer = 0;
                }
            }
        };
        /**
         * @private
         * @param {MouseEvent} event - Specifies mouse event
         * @returns {void}
         */
        this.onWindowMouseMoveInternal = (event) => {
            if (this.isMouseDown && this.isMouseLeaved) {
                this.isCompleted = false;
                clearInterval(this.scrollMoveTimer);
                let viewerTop = this.viewerContainer.getBoundingClientRect().top;
                let viewerLeft = this.viewerContainer.getBoundingClientRect().left;
                let hRulerHeight = this.owner.documentEditorSettings.showRuler ? this.owner.hRuler.thickness : 0;
                let pageLeft = this.pages[this.owner.selectionModule.endPage - 1].boundingRectangle.x;
                let textYPosition = this.owner.selectionModule.end.location.y;
                let textHeight = this.owner.selectionModule.end.currentWidget ? this.owner.selectionModule.end.currentWidget.height : 0;
                let cursorPoint = new Point(event.x - (pageLeft + viewerLeft), event.y - viewerTop);
                // Clamp visible container boundaries to the viewport.
                // When the container is taller than the viewport, clientHeight exceeds window.innerHeight,
                // so the mouse can never reach viewerTop + clientHeight. We use the actual visible bounds instead.
                let visibleContainerBottom = Math.min(viewerTop + this.viewerContainer.clientHeight, window.innerHeight);
                let visibleContainerTop = Math.max(viewerTop, 0);
                // Convert the selection-end content Y position to a viewport Y coordinate.
                let selectionEndViewportY = viewerTop + hRulerHeight + textYPosition - this.viewerContainer.scrollTop;
                if (event.y > visibleContainerBottom) {
                    // Mouse is below the visible container area — auto-scroll down.
                    this.scrollMoveTimer = setInterval(() => {
                        this.viewerContainer.scrollTop += this.owner.selectionModule.end.paragraph ? this.owner.selectionModule.end.paragraph.height : 0;
                        this.scrollForwardOnSelection(cursorPoint);
                    }, 100);
                }
                else if (event.y < visibleContainerTop && this.viewerContainer.scrollTop > 0) {
                    // Mouse is above the visible container area — auto-scroll up.
                    this.scrollMoveTimer = setInterval(() => {
                        this.viewerContainer.scrollTop -= this.owner.selectionModule.end.paragraph ? this.owner.selectionModule.end.paragraph.height : 0;
                        this.scrollBackwardOnSelection(cursorPoint);
                    }, 100);
                }
                else if (event.y > selectionEndViewportY + textHeight && !this.isRowOrCellResizing) {
                    // Mouse is inside container but below the current selection end — extend selection forward.
                    this.scrollForwardOnSelection(cursorPoint);
                }
                else if (event.y < selectionEndViewportY && !this.isRowOrCellResizing) {
                    // Mouse is inside container but above the current selection end — extend selection backward.
                    this.scrollBackwardOnSelection(cursorPoint);
                }
                if (this.isMouseEntered) {
                    this.isMouseEntered = false;
                }
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.onMouseEnterInternal = (event) => {
            if (!this.isMouseEntered) {
                this.owner.viewer.updateScrollBars();
            }
            this.isMouseEntered = true;
            this.isMouseLeaved = false;
            if (this.scrollMoveTimer) {
                clearInterval(this.scrollMoveTimer);
            }
            if (!this.isLeftButtonPressed(event) && this.isDragStarted) {
                if (!this.selection.caret.classList.contains("e-de-cursor-animation")) {
                    this.selection.caret.classList.add("e-de-cursor-animation");
                }
                this.isDragStarted = false;
            }
            if (!this.isLeftButtonPressed(event) && this.isMouseDown) {
                this.onMouseUpInternal(event);
            }
        };
        /**
         * Fired on double tap.
         *
         * @private
         * @param {MouseEvent} event - Specifies mouse event.
         * @returns {void}
         */
        this.onDoubleTap = (event) => {
            this.owner.focusIn();
            if (!isNullOrUndefined(event.target) && event.target !== this.viewerContainer) {
                return;
            }
            if (!isNullOrUndefined(this.selection)) {
                this.isTouchInput = false;
                const cursorPoint = new Point(event.offsetX, event.offsetY);
                const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, true);
                if (this.selection.checkAndEnableHeaderFooter(cursorPoint, this.owner.viewer.findFocusedPage(cursorPoint, true))) {
                    return;
                }
                const widget = this.getLineWidget(touchPoint);
                if (isNullOrUndefined(widget)) {
                    return;
                }
                let formField = this.selection.getHyperLinkFieldInCurrentSelection(widget, touchPoint, true);
                if (isNullOrUndefined(formField)) {
                    formField = this.selection.getCurrentFormField();
                }
                if (!this.isDocumentProtected && this.owner.enableFormField && !this.owner.isReadOnlyMode) {
                    const formatType = this.selection.getFormFieldType(formField);
                    if (formatType) {
                        if (formatType.toString() !== '') {
                            this.selection.selectField(formField);
                        }
                        switch (formatType) {
                            case 'Text':
                                this.owner.textFormFieldDialogModule.show();
                                break;
                            case 'CheckBox':
                                this.owner.checkBoxFormFieldDialogModule.show();
                                break;
                            case 'DropDown':
                                this.owner.dropDownFormFieldDialogModule.show();
                                break;
                        }
                    }
                }
                else if (this.isDocumentProtected && formField && formField.formFieldData instanceof TextFormField
                    && formField.formFieldData.type === 'Text') {
                    this.selection.selectField();
                }
                const startPosition = this.selection.start.clone();
                const endPosition = this.selection.end.clone();
                const inlineObj = startPosition.currentWidget.getInline(startPosition.offset, 0);
                const inline = inlineObj.element;
                if (this.owner.layoutType === 'Pages') {
                    if (inline instanceof FootnoteElementBox) {
                        if (inline.footnoteType === 'Footnote') {
                            const footnotes = this.currentPage.footnoteWidget;
                            let i;
                            for (i = 0; i <= footnotes.bodyWidgets.length; i++) {
                                const footnoteText = (footnotes.bodyWidgets[i]).footNoteReference;
                                if (inline.text === footnoteText.text) {
                                    break;
                                }
                            }
                            startPosition.setPositionParagraph(footnotes.bodyWidgets[i].childWidgets[0].childWidgets[0], 0);
                            endPosition.setPositionParagraph(footnotes.bodyWidgets[i].childWidgets[0].childWidgets[0], 0);
                            this.selection.selectRange(startPosition, endPosition);
                        }
                        else {
                            this.navigateToEndNote(inline, startPosition, endPosition);
                        }
                    }
                    else {
                        if (inline instanceof TextElementBox && (this.selection.isinEndnote || this.selection.isinFootnote)) {
                            this.selection.footnoteReferenceElement(startPosition, endPosition, inline);
                        }
                    }
                }
                if (this.selection.isEmpty && !isNullOrUndefined(this.currentPage) && !isNullOrUndefined(this.owner.selectionModule.start)) {
                    this.isDoubleTap = true;
                    this.owner.selectionModule.selectCurrentWord();
                    this.selection.checkForCursorVisibility();
                    this.tapCount = 2;
                }
            }
        };
        /**
         * Called on mouse up.
         *
         * @private
         * @param {MouseEvent} event - Specifies mouse event.
         * @return {void}
         */
        /* eslint-disable  */
        this.onMouseUpInternal = (event) => {
            if (!isNullOrUndefined(event.target) && event.target !== this.viewerContainer || this.owner.isTableMarkerDragging) {
                this.isMouseDown = false;
                return;
            }
            event.preventDefault();
            this.isListTextSelected = false;
            let cursorPoint = new Point(event.offsetX, event.offsetY);
            let touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, true);
            if (!isNullOrUndefined(this.selection)) {
                const startWidget = this.getLineWidget(this.mouseDownOffset);
                if (this.isMouseDown
                    && this.isLeftButtonPressed(event)
                    && isNullOrUndefined(startWidget)
                    && !this.isRowOrCellResizing) {
                    this.isSelectionChangedOnMouseMoved = true;
                    this.isMouseDown = false;
                    return;
                }
                let tapCount = 1;
                if (!Browser.isIE) {
                    if (event.detail > 2) {
                        tapCount = event.detail;
                    }
                }
                else {
                    tapCount = this.tapCount;
                }
                if (this.isRowOrCellResizing) {
                    this.owner.editorModule.tableResize.updateResizingHistory(touchPoint);
                }
                if (!isNullOrUndefined(this.owner.editor) && this.selection.checkContentControlLocked()) {
                    this.owner.editorModule.insertContentControlPlaceholder();
                }
                if (this.isMouseDown && !this.isSelectionChangedOnMouseMoved
                    && !isNullOrUndefined(this.currentPage) && !isNullOrUndefined(this.owner.selectionModule.start)
                    && (!this.owner.enableImageResizerMode || !this.owner.imageResizerModule.isImageResizing)) {
                    if (this.touchDownOnSelectionMark === 0 && !this.isRowOrCellResizing) {
                        let isShiftKeyPressed = event.shiftKey;
                        if (isShiftKeyPressed) {
                            const textPosition = this.owner.selectionModule.end;
                            this.owner.selectionModule.moveTextPosition(touchPoint, textPosition);
                        }
                        else {
                            this.updateTextPositionForSelection(touchPoint, tapCount);
                            // to check whether the image is selected
                            if (this.owner.selectionModule.isImageSelected) {
                                let contentControlImage = this.owner.getImageContentControl();
                                // to check whether selected image has content control and type as picture , then the dialog opens
                                if (contentControlImage instanceof ContentControl) {
                                    if (contentControlImage.contentControlProperties.type == 'Picture') {
                                        let picturePositionY = this.owner.picturePositionY;
                                        this.owner.renderPictureContentControlElement(this.owner, true, false, picturePositionY);
                                    }
                                }
                            }
                            else {
                                this.owner.renderPictureContentControlElement(this.owner, false, false);
                            }
                        }
                        if (Browser.isIE && tapCount === 2) {
                            this.selection.checkAndEnableHeaderFooter(cursorPoint, touchPoint);
                        }
                    }
                    this.selection.checkForCursorVisibility();
                    if (!isNullOrUndefined(this.currentSelectedComment) && this.owner.commentReviewPane
                        && !this.owner.commentReviewPane.commentPane.isEditMode) {
                        this.currentSelectedComment = undefined;
                    }
                }
                let isCtrlkeyPressed = this.isIosDevice ? event.metaKey : event.ctrlKey;
                if (!isNullOrUndefined(this.owner.editorModule) && !isNullOrUndefined(this.owner.selectionModule)) {
                    let contentControl = this.owner.selection.currentContentControl;
                    let iscontentControl = this.owner.selectionModule.checkContentControlLocked();
                    if ((!isNullOrUndefined(contentControl) && !contentControl.contentControlProperties.lockContents && iscontentControl && event.button === 0) || (!isNullOrUndefined(contentControl) && !contentControl.contentControlProperties.lockContents && this.protectionType == 'FormFieldsOnly' && event.button === 0)) {
                        if (!this.owner.isReadOnly) {
                            if (this.isDocumentProtected) {
                                if ((this.selection.checkSelectionIsAtEditRegion() || this.isFormFillProtectedMode) && contentControl.contentControlProperties.type === 'CheckBox') {
                                    this.owner.editor.toggleContentControlCheckBox(contentControl, !contentControl.contentControlProperties.isChecked);
                                    if (contentControl.contentControlProperties.isTemporary) {
                                        this.owner.editor.removeContentControl();
                                    }
                                }
                            }
                            else {
                                if (contentControl.contentControlProperties.type === 'CheckBox') {
                                    this.owner.editor.toggleContentControlCheckBox(contentControl, !contentControl.contentControlProperties.isChecked);
                                    if (contentControl.contentControlProperties.isTemporary) {
                                        this.owner.editor.removeContentControl();
                                    }
                                }
                            }
                        }
                    }
                    if (contentControl) {
                        this.selection.selectPlaceHolderText(contentControl);
                    }
                }
                if (!isNullOrUndefined(this.currentPage) && !isNullOrUndefined(this.owner.selectionModule.start)
                    && (this.owner.selectionModule.isEmpty || this.owner.selectionModule.isImageSelected) &&
                    (((isCtrlkeyPressed && this.owner.useCtrlClickToFollowHyperlink ||
                        !this.owner.useCtrlClickToFollowHyperlink) && this.isLeftButtonPressed(event) === true))) {
                    this.selection.navigateHyperLinkOnEvent(touchPoint, false);
                }
                if (this.isMouseDown && this.isLeftButtonPressed(event) && this.isDocumentProtected
                    && this.protectionType === 'FormFieldsOnly' && this.selection) {
                    let widget = this.getLineWidget(touchPoint);
                    if (isNullOrUndefined(widget)) {
                        this.isMouseDown = false;
                        return;
                    }
                    let formField = this.selection.getHyperLinkFieldInCurrentSelection(widget, touchPoint, true);
                    if (isNullOrUndefined(formField)) {
                        formField = this.selection.getCurrentFormField(true);
                    }
                    if (formField && formField.formFieldData && formField.formFieldData.enabled && !this.selection.isInlineFormFillMode(formField)) {
                        let data = { 'fieldName': formField.formFieldData.name };
                        if (formField.formFieldData instanceof TextFormField) {
                            data.value = formField.resultText;
                        }
                        else if (formField.formFieldData instanceof CheckBoxFormField) {
                            data.value = formField.formFieldData.checked;
                        }
                        else {
                            data.value = formField.formFieldData.selectedIndex;
                        }
                        data.isCanceled = false;
                        if (this.owner.documentEditorSettings.formFieldSettings.formFillingMode === 'Popup' && this.selection.previousSelectedFormField !== this.selection.getCurrentFormField()) {
                            this.owner.trigger(beforeFormFieldFillEvent, data);
                        }
                        else {
                            this.owner.trigger(beforeFormFieldFillEvent, data);
                        }
                        if (!data.isCanceled) {
                            if (this.owner.documentEditorSettings.formFieldSettings.formFillingMode === 'Popup' && !(formField.formFieldData instanceof CheckBoxFormField)
                                || (formField.formFieldData instanceof TextFormField && !(formField.formFieldData.type === 'Text'))
                                || formField.formFieldData instanceof DropDownFormField) {
                                const currentFormField = this.selection.getCurrentFormField(true);
                                if (this.selection.isEmpty || !isNullOrUndefined(currentFormField)) {
                                    this.formFillPopup.showPopUp(formField);
                                }
                            }
                            else {
                                if (this.selection.isEmpty) {
                                    this.owner.editorModule.toggleCheckBoxFormField(formField);
                                    data.value = formField.formFieldData.checked;
                                    data.isCanceled = false;
                                    this.owner.trigger(afterFormFieldFillEvent, data);
                                }
                            }
                        }
                    }
                    if (!formField && this.isFormFillProtectedMode) {
                        let contentControl = this.owner.selection.currentContentControl;
                        let canEditContentControl = false;
                        if ((!isNullOrUndefined(contentControl) && contentControl instanceof ContentControl && !contentControl.contentControlProperties.lockContentControl)) {
                            canEditContentControl = true;
                        }
                        if (!canEditContentControl) {
                            this.selection.navigateToNextFormField();
                        }
                    }
                }
                else if (this.isMouseDown) {
                    if (this.formFields.length > 0) {
                        let formField = this.selection.getCurrentFormField(true);
                        if (formField && formField.formFieldData instanceof TextFormField) {
                            this.selection.selectField();
                        }
                        else if (this.isLeftButtonPressed(event) && formField && formField.formFieldData instanceof DropDownFormField) {
                            let offset = formField.line.getOffset(formField, 0);
                            let point = this.selection.getPhysicalPositionInternal(formField.line, offset, false);
                            this.selection.selectInternal(formField.line, formField, 0, point);
                        }
                    }
                    if (this.contentControlCollection.length > 0) {
                        this.selection.triggerContentControlFillEvent();
                    }
                    if (this.isSelectionChangedOnMouseMoved) {
                        this.isSelectionActive = false;
                        this.selection.fireSelectionChanged(true);
                    }
                }
                if (!this.owner.isReadOnlyMode && this.isSelectionInListText(touchPoint)) {
                    this.selection.selectListText();
                }
                if (!this.owner.isReadOnlyMode && this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizing) {
                    this.owner.imageResizerModule.mouseUpInternal();
                    this.scrollToPosition(this.owner.selectionModule.start, this.owner.selectionModule.end);
                    this.owner.imageResizerModule.isImageResizing = false;
                }
                if (this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizerVisible && !isNullOrUndefined(this.selection.caret)) {
                    this.selection.caret.style.display = 'none';
                }
                if (this.isDragStarted) {
                    if (this.selection.selectedWidgets.length === 0 && !isNullOrUndefined(this.dragStartParaInfo) && !isNullOrUndefined(this.dragEndParaInfo) && this.dragEndParaInfo.paragraph.equals(this.dragStartParaInfo.paragraph)) {
                        let currentInline = this.dragStartParaInfo.paragraph.getInline(this.dragEndParaInfo.offset, 0);
                        if (!isNullOrUndefined(currentInline.element) && currentInline.element instanceof ImageElementBox && currentInline.element.textWrappingStyle !== "Inline") {
                            this.isDragStarted = false;
                        }
                    }
                    else if (this.selection.selectedWidgets.length > 0) {
                        for (let i = 0; i < this.selection.selectedWidgets.values.length; i++) {
                            let selectedWidgetInfo = this.selection.selectedWidgets.values[i];
                            if (!isNullOrUndefined(selectedWidgetInfo.floatingItems) && selectedWidgetInfo.floatingItems.length > 0) {
                                for (let j = 0; j < selectedWidgetInfo.floatingItems.length; j++) {
                                    if (selectedWidgetInfo.floatingItems[j] instanceof ImageElementBox && selectedWidgetInfo.floatingItems[j].textWrappingStyle !== "Inline") {
                                        this.isDragStarted = false;
                                        break;
                                    }
                                }
                            }
                            if (!this.isDragStarted) {
                                break;
                            }
                        }
                    }
                    if (!this.isDragStarted) {
                        this.dragStartParaInfo = undefined;
                        this.dragEndParaInfo = undefined;
                        this.selection.caret.classList.add("e-de-cursor-animation");
                    }
                }
                if (this.isDragStarted) {
                    this.isDragging = true;
                    this.moveSelectedContent();
                    this.isDragging = false;
                }
                if (this.isMouseDown) {
                    this.updateFocus();
                }
                this.isMouseDownInSelection = false;
                this.isMouseDown = false;
                this.isFootnoteWidget = false;
                this.isSelectionChangedOnMouseMoved = false;
                this.isTouchInput = false;
                this.useTouchSelectionMark = true;
                this.isControlPressed = false;
                if (this.isListTextSelected) {
                    this.selection.hideCaret();
                }
                if (this.owner.enableImageResizerMode) {
                    let imageResizer = this.owner.imageResizerModule;
                    imageResizer.isImageResizing = false;
                    imageResizer.isImageMoveToNextPage = false;
                    imageResizer.leftValue = undefined;
                    imageResizer.topValue = undefined;
                }
                this.isMouseDownInFooterRegion = false;
            }
            if (this.selection) {
                this.selection.isCellPrevSelected = false;
            }
            if (this.owner.documentHelper.contentControlCollection.length > 0) {
                //Need to work on these
                this.clearContent();
                this.owner.documentHelper.viewer.updateScrollBars();
            }
        };
        /**
         * Fired on touch start.
         *
         * @private
         * @param {TouchEvent} event - Specifies touch event.
         * @returns {void}
         */
        this.onTouchStartInternal = (event) => {
            if (this.selection) {
                this.isTouchMoved = false;
                this.isCompositionStart = false;
                this.isCompositionEnd = false;
                this.isCompositionUpdated = false;
                this.isCompositionCanceled = true;
                this.isTouchInput = true;
                if (this.isTimerStarted) {
                    if (this.tapCount === 1) {
                        this.tapCount = 2;
                    }
                    else {
                        this.tapCount = 3;
                        this.isTimerStarted = false;
                    }
                }
                else {
                    this.isTimerStarted = true;
                    this.tapCount = 1;
                }
                if (event.touches.length === 1) {
                    this.zoomX = event.touches[0].clientX;
                    this.zoomY = event.touches[0].clientY;
                    if (this.owner.selectionModule.isEmpty) {
                        this.useTouchSelectionMark = false;
                    }
                    this.isMouseDown = true;
                    this.isSelectionChangedOnMouseMoved = false;
                    let point;
                    if (this.isMouseDown) {
                        point = this.getTouchOffsetValue(event);
                    }
                    point = this.owner.viewer.findFocusedPage(point, true, true);
                    if (this.owner.enableImageResizerMode) {
                        let resizeObj = this.owner.imageResizerModule.getImagePointOnTouch(point);
                        this.owner.imageResizerModule.selectedResizeElement = resizeObj.selectedElement;
                    }
                    if (this.owner.enableImageResizerMode && !isNullOrUndefined(this.owner.imageResizerModule.selectedResizeElement)) {
                        this.owner.imageResizerModule.isImageResizing = true;
                    }
                    if (Browser.isDevice) {
                        this.editableDiv.contentEditable = this.owner.isReadOnlyMode ? 'false' : 'true';
                    }
                    let x = this.owner.selectionModule.end.location.x;
                    let y = this.selection.getCaretBottom(this.owner.selectionModule.end, this.owner.selectionModule.isEmpty) + 9;
                    //TouchDownOnSelectionMark will be 2 when touch end is pressed
                    this.touchDownOnSelectionMark = ((point.y <= y && point.y >= y - 20 || point.y >= y && point.y <= y + 20)
                        && (point.x <= x && point.x >= x - 20 || point.x >= x && point.x <= x + 20)) ? 1 : 0;
                    if (!this.owner.selectionModule.isEmpty && this.touchDownOnSelectionMark === 0) {
                        x = this.owner.selectionModule.start.location.x;
                        y = this.selection.getCaretBottom(this.owner.selectionModule.start, false) + 9;
                        //TouchDownOnSelectionMark will be 1 when touch start is pressed
                        this.touchDownOnSelectionMark = ((point.y <= y && point.y >= y - 20 || point.y >= y && point.y <= y + 20)
                            && (point.x <= x && point.x >= x - 20 || point.x >= x && point.x <= x + 20)) ? 2 : 0;
                    }
                }
                if (!isNullOrUndefined(this.owner.contextMenuModule) && this.owner.contextMenuModule.contextMenuInstance) {
                    this.owner.contextMenuModule.contextMenuInstance.close();
                }
                if (this.touchDownOnSelectionMark || event.touches.length > 1) {
                    event.preventDefault();
                }
                this.longTouchTimer = setTimeout(this.onLongTouch, 500, event);
                this.timer = setTimeout(() => {
                    this.isTimerStarted = false;
                }, 200);
                this.owner.focusIn();
            }
        };
        /**
         * Fired on long touch
         *
         * @private
         * @param {TouchEvent} event - Specifies touch event.
         * @returns {void}
         */
        this.onLongTouch = (event) => {
            if (isNullOrUndefined(this.owner) || isNullOrUndefined(this.viewerContainer) || this.isTouchMoved || event.touches.length !== 1) {
                return;
            }
            let point = this.getTouchOffsetValue(event);
            let pointRelToPage = this.owner.viewer.findFocusedPage(point, true);
            let selStart = this.selection.start;
            let selEnd = this.selection.end;
            let updateSel = false;
            if (!this.selection.isForward) {
                selStart = this.selection.end;
                selEnd = this.selection.start;
            }
            let selStartPt = selStart.location;
            let selEndPt = selEnd.location;
            if (selStart.currentWidget !== selEnd.currentWidget) {
                updateSel = !(pointRelToPage.x >= selStartPt.x && pointRelToPage.x <= selEndPt.x)
                    && !(pointRelToPage.y >= selStartPt.y && pointRelToPage.y <= selEndPt.y);
            }
            else {
                updateSel = !(pointRelToPage.x >= selStartPt.x && pointRelToPage.x <= selEndPt.x)
                    || !(pointRelToPage.y >= selStartPt.y && pointRelToPage.y <= selEndPt.y);
            }
            if (event.changedTouches.length === 1 && updateSel) {
                this.updateSelectionOnTouch(point, pointRelToPage);
                this.isMouseDown = false;
                this.touchDownOnSelectionMark = 0;
                this.useTouchSelectionMark = true;
                this.isSelectionChangedOnMouseMoved = false;
            }
            if (this.selection.isEmpty) {
                this.selection.selectCurrentWord();
            }
            if (!isNullOrUndefined(this.owner.contextMenuModule) && this.owner.contextMenuModule.contextMenuInstance) {
                this.owner.contextMenuModule.onContextMenuInternal(event);
            }
        };
        /**
         *
         * @private
         * @param {TouchEvent} event - Specifies touch event.
         * @returns {void}
         */
        this.onTouchMoveInternal = (event) => {
            this.isTouchMoved = true;
            let touch = event.touches;
            let cursorPoint;
            if (!isNullOrUndefined(this.selection)) {
                if (this.owner.editorModule && this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizing) {
                    event.preventDefault();
                    if (!this.owner.imageResizerModule.isImageMoveToNextPage) {
                        this.owner.imageResizerModule.handleImageResizingOnTouch(event);
                        this.selection.caret.style.display = 'none';
                    }
                    return;
                }
                if (this.isMouseDown) {
                    cursorPoint = this.getTouchOffsetValue(event);
                    let touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, true);
                    if (this.touchDownOnSelectionMark > 0 /*|| !this.useTouchSelectionMark*/) {
                        this.isSelectionActive = true;
                        this.isCompleted = false;
                        event.preventDefault();
                        let touchY = touchPoint.y;
                        let textPosition = this.owner.selectionModule.end;
                        let touchPointer;
                        if (touchPoint.y <= 26) {
                            touchY -= touchPoint.y < 0 ? 0 : touchPoint.y + 0.5;
                        }
                        else {
                            touchY -= 36.5;
                        }
                        textPosition = this.touchDownOnSelectionMark === 2 ? this.selection.start : this.selection.end;
                        touchPoint = new Point(touchPoint.x, touchY);
                        this.owner.selectionModule.moveTextPosition(touchPoint, textPosition);
                        this.isSelectionChangedOnMouseMoved = true;
                    }
                    this.selection.checkForCursorVisibility();
                    this.updateTouchMarkPosition();
                }
            }
            if (touch.length > 1) {
                event.preventDefault();
                this.isMouseDown = false;
                this.zoomX = (touch[0].clientX + touch[1].clientX) / 2;
                this.zoomY = (touch[0].clientY + touch[1].clientY) / 2;
                let currentDiff = Math.sqrt(Math.pow((touch[0].clientX - touch[1].clientX), 2) + Math.pow((touch[0].clientY - touch[1].clientY), 2));
                if (this.preDifference > -1) {
                    if (currentDiff > this.preDifference) {
                        this.onPinchOutInternal(event);
                    }
                    else if (currentDiff < this.preDifference) {
                        this.onPinchInInternal(event);
                    }
                }
                else if (this.zoomFactor < 2) {
                    if (this.preDifference !== -1) {
                        if (currentDiff > this.preDifference) {
                            this.onPinchInInternal(event);
                        }
                    }
                }
                else if (this.preDifference === -1) {
                    if (this.zoomFactor > 2) {
                        if (currentDiff > this.preDifference) {
                            this.onPinchInInternal(event);
                        }
                    }
                }
                this.preDifference = currentDiff;
            }
            if (this.longTouchTimer) {
                clearTimeout(this.longTouchTimer);
                this.longTouchTimer = undefined;
            }
        };
        /**
         * Fired on touch up.
         *
         * @private
         * @param {TouchEvent} event - Specifies touch event.
         * @returns {void}
         */
        this.onTouchUpInternal = (event) => {
            if (!isNullOrUndefined(this.selection)) {
                let point = this.getTouchOffsetValue(event);
                let touchPoint = this.owner.viewer.findFocusedPage(point, true);
                if (event.changedTouches.length === 1) {
                    if (!this.isTouchMoved || (this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizing)) {
                        this.updateSelectionOnTouch(point, touchPoint);
                        if (!isNullOrUndefined(this.currentPage) && !isNullOrUndefined(this.selection.start)
                            && !this.isSelectionChangedOnMouseMoved && (this.selection.isEmpty ||
                            this.selection.isImageField() && (!this.owner.enableImageResizerMode ||
                                this.owner.enableImageResizerMode && !this.owner.imageResizerModule.isImageResizing))) {
                            this.selection.navigateHyperLinkOnEvent(touchPoint, true);
                        }
                    }
                    if (this.isSelectionChangedOnMouseMoved) {
                        this.isSelectionActive = false;
                        this.selection.fireSelectionChanged(true);
                    }
                    this.isMouseDown = false;
                    this.touchDownOnSelectionMark = 0;
                    this.useTouchSelectionMark = true;
                    this.isSelectionChangedOnMouseMoved = false;
                }
                if (this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizing) {
                    this.owner.imageResizerModule.mouseUpInternal();
                    this.owner.imageResizerModule.isImageResizing = false;
                    this.owner.imageResizerModule.isImageMoveToNextPage = false;
                    this.scrollToPosition(this.owner.selectionModule.start, this.owner.selectionModule.end);
                }
                if (this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizerVisible && this.isTouchInput) {
                    this.touchStart.style.display = 'none';
                    this.touchEnd.style.display = 'none';
                }
                // if (!this.owner.isReadOnlyMode && this.isSelectionInListText(touchPoint)) {
                //     this.selection.selectListText();
                // }
                event.preventDefault();
            }
            this.preDifference = -1;
            this.isTouchInput = false;
            if (this.longTouchTimer) {
                clearTimeout(this.longTouchTimer);
                this.longTouchTimer = undefined;
            }
            if (!this.isTimerStarted) {
                this.tapCount = 1;
            }
            if (this.isListTextSelected) {
                this.selection.hideCaret();
            }
            this.owner.focusIn();
        };
        /**
         * Fired on keyup event.
         *
         * @private
         * @param {KeyboardEvent} event - Specifies keyboard event.
         * @returns {void}
         */
        this.onKeyUpInternal = (event) => {
            if (Browser.isDevice && event.target === this.editableDiv) {
                if (window.getSelection().anchorOffset !== this.prefix.length) {
                    this.selection.setEditableDivCaretPosition(this.editableDiv.innerText.length);
                }
            }
            const key = HelperMethods.getLegacyKeyCode(event);
            if (event.ctrlKey || key === 17) {
                this.isControlPressed = false;
            }
        };
        /**
         * Fired on keyup event.
         *
         * @private
         * @param {KeyboardEvent} event - Specifies keyboard event.
         * @returns {void}
         */
        this.onViewerKeyUpInternal = (event) => {
            let key = HelperMethods.getLegacyKeyCode(event);
            let shift = event.shiftKey ? event.shiftKey : ((key === 16) ? true : false);
            if (shift && (key >= 33 && key <= 40)) {
                this.isKeySelection = true;
            }
            if (this.isKeySelection && shift && key === 16) {
                this.owner.fireSelectionChange();
                this.isKeySelection = false;
            }
        };
        /**
         * Fired on keydown.
         *
         * @private
         * @param {KeyboardEvent} event - Specifies keyboard event.
         * @returns {void}
         */
        this.onKeyDownInternal = (event) => {
            const pasteElement = !isNullOrUndefined(this.selection) && !isNullOrUndefined(this.selection.pasteElement) ? this.selection.pasteElement : undefined;
            if (!isNullOrUndefined(event.target) && event.target !== this.editableDiv && event.target !== pasteElement
                && event.target.id !== this.owner.containerId + '_iconsplitbtn') {
                return;
            }
            this.owner.focusIn();
            let isHandled = false;
            let canSkipScrollbarUpdate = false;
            let keyEventArgs = { 'event': event, 'isHandled': false, source: this.owner };
            this.owner.trigger(keyDownEvent, keyEventArgs);
            if (keyEventArgs.isHandled) {
                return;
            }
            let key = HelperMethods.getLegacyKeyCode(event);
            let ctrl = (event.ctrlKey || event.metaKey) ? true : ((key === 17) ? true : false); // ctrl detection       
            let shift = event.shiftKey ? event.shiftKey : ((key === 16) ? true : false); // Shift Key detection        
            let alt = event.altKey ? event.altKey : ((key === 18) ? true : false); // alt key detection
            if (ctrl && !shift && !alt) {
                switch (key) {
                    case 80:
                        event.preventDefault();
                        this.owner.print();
                        isHandled = true;
                        break;
                    case 83:
                        event.preventDefault();
                        this.owner.save(this.owner.documentName === '' ? 'sample' : this.owner.documentName, 'Sfdt');
                        isHandled = true;
                        break;
                }
            }
            if (key !== 8 && key !== 46 && !isNullOrUndefined(this.owner.editor) && this.selection.checkContentControlLocked()) {
                this.owner.editorModule.insertContentControlPlaceholder();
            }
            if (!isHandled && !isNullOrUndefined(this.selection)) {
                this.selection.caret.classList.remove("e-de-cursor-animation");
                this.isSpellCheckPending = true;
                canSkipScrollbarUpdate = true;
                this.selection.onKeyDownInternal(event, ctrl, shift, alt);
            }
            if (!isNullOrUndefined(this.owner.documentHelper) && this.owner.documentHelper.contentControlCollection.length > 0 && !canSkipScrollbarUpdate) {
                //Need to work on these
                this.clearContent();
                this.owner.documentHelper.viewer.updateScrollBars();
            }
            if (isHandled) {
                event.preventDefault();
            }
            this.timer = setTimeout(() => {
                if (!this.isScrollHandler && !isNullOrUndefined(this.owner) && this.owner.isSpellCheck && !canSkipScrollbarUpdate) {
                    this.isScrollToSpellCheck = true;
                    this.owner.viewer.updateScrollBars();
                }
            }, 100);
            if (!isNullOrUndefined(this.selection) && !this.selection.caret.classList.contains("e-de-cursor-animation")) {
                this.selection.caret.classList.add("e-de-cursor-animation");
            }
        };
        this.owner = owner;
        this.pages = [];
        this.lists = [];
        this.abstractLists = [];
        this.render = new Renderer(this);
        this.characterFormat = new WCharacterFormat(this, this.owner);
        this.themeFontLanguage = new WCharacterFormat(this, this.owner);
        this.paragraphFormat = new WParagraphFormat(this);
        this.renderedLists = new Dictionary();
        this.renderedLevelOverrides = [];
        this.headersFooters = [];
        this.styles = new WStyles();
        this.stylesMap = new Dictionary();
        if (this.owner) {
            this.L10n = new L10n('documenteditor', this.owner.defaultLocale);
            this.L10n.setLocale(this.owner.locale);
        }
        this.preDefinedStyles = new Dictionary();
        this.initalizeStyles();
        this.bookmarks = new Dictionary();
        this.editRanges = new Dictionary();
        this.isIosDevice = typeof window !== 'undefined' ? /Mac|iPad|iPod/i.test(navigator.userAgent) : false;
        this.isMobileDevice = typeof window !== 'undefined' ? /Android|Windows Phone|webOS/i.test(navigator.userAgent) : false;
        this.isLinuxOS = typeof window !== 'undefined' ? /Linux/i.test(navigator.userAgent) : false;
        this.formFillPopup = new FormFieldPopUp(this.owner);
        this.contentDropDown = new ContentControlPopUp(this.owner);
        this.customXmlData = new Dictionary();
        this.fontSubstitutionTable = new Dictionary();
        this.contentControlCollection = [];
        this.footnoteCollection = [];
        this.endnoteCollection = [];
        this.themes = new Themes();
        this.images = new Dictionary();
    }
    /**
     * Gets visible bounds.
     *
     * @private
     * @returns {Rect} - Returns visible bounds.
     */
    get visibleBounds() {
        return this.visibleBoundsIn;
    }
    /**
     * @private
     */
    get viewer() {
        return this.owner.viewer;
    }
    //Document Protection Properties Ends
    //#region Properties
    /**
     * Gets container canvas.
     *
     * @private
     * @returns {HTMLCanvasElement} - Returns page canvas.
     */
    get containerCanvas() {
        if (isNullOrUndefined(this.containerCanvasIn)) {
            this.containerCanvasIn = document.createElement('canvas');
            this.containerCanvasIn.getContext('2d').save();
        }
        if (!isNullOrUndefined(this.pageContainer)
            && this.containerCanvasIn.parentElement !== this.pageContainer) {
            this.pageContainer.appendChild(this.containerCanvasIn);
        }
        return this.containerCanvasIn;
    }
    /**
     * @private
     * @param {string} text - Specifies the text string.
     */
    openTextFile(text) {
        return __awaiter(this, void 0, void 0, function* () {
            this.layout.isTextFormat = true;
            let arr = [];
            text = text.replace(/\r\n/g, '\n');
            arr = text.split('\n');
            let widget = [];
            let bodyWidget = new BodyWidget();
            bodyWidget.sectionFormat = new WSectionFormat(bodyWidget);
            bodyWidget.childWidgets = widget;
            let paragraph1 = new ParagraphWidget();
            let line1 = new LineWidget(paragraph1);
            for (let i = 0; i < arr.length; i++) {
                if (i === arr.length - 1 && arr[i].length === 0) {
                    paragraph1.childWidgets.push(line1);
                    paragraph1.index = i;
                    paragraph1.containerWidget = bodyWidget;
                    bodyWidget.childWidgets.push(paragraph1);
                    continue;
                }
                let paragraph = new ParagraphWidget();
                let line = new LineWidget(paragraph);
                if (arr[i].length > 0) {
                    let singleLineLength = 90;
                    if (arr[i].length > singleLineLength) {
                        let start = 0;
                        let increment = singleLineLength;
                        let split;
                        let lineLength = (arr[i].length / singleLineLength) + 1;
                        let count = 0;
                        while (count < lineLength) {
                            if (lineLength - 1 != count) {
                                split = arr[i].substring(start, increment);
                            }
                            else {
                                increment = arr[i].length % singleLineLength;
                                split = arr[i].substring(start, increment);
                            }
                            let textElement = new TextElementBox();
                            textElement.text = split;
                            line.children.push(textElement);
                            textElement.line = line;
                            count++;
                            increment += singleLineLength;
                            start += singleLineLength;
                        }
                    }
                    else {
                        let textElement = new TextElementBox();
                        textElement.text = arr[i];
                        line.children.push(textElement);
                        textElement.line = line;
                    }
                }
                paragraph.childWidgets.push(line);
                paragraph.index = i;
                paragraph.containerWidget = bodyWidget;
                bodyWidget.childWidgets.push(paragraph);
            }
            if (this.owner.documentEditorSettings.openAsyncSettings.enable) {
                yield this.owner.documentHelper.onDocumentChanged([bodyWidget], undefined, true);
            }
            else {
                this.owner.documentHelper.onDocumentChanged([bodyWidget], undefined, false);
            }
            this.layout.isTextFormat = false;
        });
    }
    /**
     * Gets selection canvas.
     *
     * @private
     * @returns {HTMLCanvasElement} - Returns selection canvas.
     */
    get selectionCanvas() {
        if (isNullOrUndefined(this.selectionCanvasIn)) {
            this.selectionCanvasIn = document.createElement('canvas');
            this.selectionCanvas.getContext('2d').save();
        }
        if (!isNullOrUndefined(this.pageContainer)
            && this.selectionCanvasIn.parentElement !== this.pageContainer) {
            this.pageContainer.appendChild(this.selectionCanvasIn);
        }
        return this.selectionCanvasIn;
    }
    /**
     * Gets container context.
     *
     * @private
     * @returns {CanvasRenderingContext2D} - Returns page canvas context.
     */
    get containerContext() {
        return this.containerCanvas.getContext('2d');
    }
    /**
     * Gets selection context.
     *
     * @private
     * @returns {CanvasRenderingContext2D} - Returns selection canvas context.
     */
    get selectionContext() {
        return this.selectionCanvas.getContext('2d');
    }
    /**
     * Gets the current rendering page.
     *
     * @returns {Page} - Returns current rendering page.
     */
    get currentRenderingPage() {
        if (this.pages.length === 0) {
            return undefined;
        }
        return this.pages[this.pages.length - 1];
    }
    /**
     * Gets or sets zoom factor.
     *
     * @private
     * @returns {number} - Returns zoom factor value.
     */
    get zoomFactor() {
        return this.zoomFactorInternal;
    }
    set zoomFactor(value) {
        if (this.zoomFactorInternal !== value) {
            this.preZoomFactor = this.zoomFactor;
            this.zoomFactorInternal = value;
            this.zoomModule.setZoomFactor();
            this.owner.zoomFactor = value;
        }
    }
    /**
     * Gets the selection.
     *
     * @private
     * @returns {Selection} - Returns selection module.
     */
    get selection() {
        return this.owner.selectionModule;
    }
    /**
     * Gets or sets selection start page.
     *
     * @private
     * @returns {Page} - Return selection start page.
     */
    get selectionStartPage() {
        return this.selectionStartPageIn;
    }
    set selectionStartPage(value) {
        this.selectionStartPageIn = value;
    }
    /**
     * Gets or sets selection end page.
     *
     * @private
     * @returns {Page} - Return selection end page.
     */
    get selectionEndPage() {
        return this.selectionEndPageIn;
    }
    set selectionEndPage(value) {
        this.selectionEndPageIn = value;
    }
    /**
     * Gets the initialized default dialog.
     *
     * @private
     * @returns {Dialog} - Returns dialog instance.
     */
    get dialog() {
        if (!this.dialogInternal) {
            this.initDialog(this.owner.enableRtl);
        }
        return this.dialogInternal;
    }
    /**
     * Gets the initialized default dialog.
     *
     * @private
     * @returns {Dialog} - Returns dialog instance.
     */
    get dialog2() {
        if (!this.dialogInternal2) {
            this.initDialog2(this.owner.enableRtl);
        }
        return this.dialogInternal2;
    }
    /**
     * Gets the initialized default dialog.
     *
     * @private
     * @returns {Dialog} - Returns dialog instance.
     */
    get dialog3() {
        if (!this.dialogInternal3) {
            this.initDialog3(this.owner.enableRtl);
        }
        return this.dialogInternal3;
    }
    /**
     * @private
     * @returns {void}
     */
    get currentSelectedComment() {
        return this.currentSelectedCommentInternal;
    }
    set currentSelectedComment(value) {
        if (this.owner && this.owner.commentReviewPane) {
            this.owner.commentReviewPane.previousSelectedComment = this.currentSelectedCommentInternal;
        }
        this.currentSelectedCommentInternal = value;
    }
    /**
     * @private
     * @returns {void}
     */
    get currentSelectedRevision() {
        return this.currentSelectedRevisionInternal;
    }
    set currentSelectedRevision(value) {
        // if (this.owner && this.owner.commentReviewPane) {
        //     this.owner.commentReviewPane.previousSelectedComment = this.currentSelectedCommentInternal;
        // }
        this.currentSelectedRevisionInternal = value;
    }
    /**
     * @private
     * @returns {void}
     */
    get isInlineFormFillProtectedMode() {
        return this.isFormFillProtectedMode && this.owner.documentEditorSettings.formFieldSettings.formFillingMode === 'Inline';
    }
    /**
     * @private
     * @returns {void}
     */
    get isFormFillProtectedMode() {
        return this.isDocumentProtected && this.protectionType === 'FormFieldsOnly';
    }
    /**
     * @private
     * @returns {Boolean}
     */
    get isCommentOnlyMode() {
        return this.isDocumentProtected && this.protectionType === 'CommentsOnly';
    }
    get isTrackedOnlyMode() {
        return this.isDocumentProtected && this.protectionType === 'RevisionsOnly';
    }
    initalizeStyles() {
        this.preDefinedStyles.add('Normal', '{"type":"Paragraph","name":"Normal","next":"Normal"}');
        this.preDefinedStyles.add('Heading 1', '{"type":"Paragraph","name":"Heading 1","basedOn":"Normal","next":"Normal","link":"Heading 1 Char","characterFormat":{"fontSize":16.0,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":12.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level1"}}');
        this.preDefinedStyles.add('Heading 2', '{"type":"Paragraph","name":"Heading 2","basedOn":"Normal","next":"Normal","link":"Heading 2 Char","characterFormat":{"fontSize":13.0,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level2"}}');
        this.preDefinedStyles.add('Heading 3', '{"type":"Paragraph","name":"Heading 3","basedOn":"Normal","next":"Normal","link":"Heading 3 Char","characterFormat":{"fontSize":12.0,"fontFamily":"Calibri Light","fontColor":"#1F3763"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level3"}}');
        this.preDefinedStyles.add('Heading 4', '{"type":"Paragraph","name":"Heading 4","basedOn":"Normal","next":"Normal","link":"Heading 4 Char","characterFormat":{"italic":true,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level4"}}');
        this.preDefinedStyles.add('Heading 5', '{"type":"Paragraph","name":"Heading 5","basedOn":"Normal","next":"Normal","link":"Heading 5 Char","characterFormat":{"fontFamily":"Calibri Light","fontColor":"#2F5496"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level5"}}');
        this.preDefinedStyles.add('Heading 6', '{"type":"Paragraph","name":"Heading 6","basedOn":"Normal","next":"Normal","link":"Heading 6 Char","characterFormat":{"fontFamily":"Calibri Light","fontColor":"#1F3763"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level6"}}');
        this.preDefinedStyles.add('Heading 7', '{"type":"Paragraph","name":"Heading 7","basedOn":"Normal","next":"Normal","link":"Heading 7 Char","characterFormat":{"italic":true,"fontFamily":"Calibri Light","fontColor":"#1F3763"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level7"}}');
        this.preDefinedStyles.add('Heading 8', '{"type":"Paragraph","name":"Heading 8","basedOn":"Normal","next":"Normal","link":"Heading 8 Char","characterFormat":{"fontSize":10.5,"fontFamily":"Calibri Light","fontColor":"#333333"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level8"}}');
        this.preDefinedStyles.add('Heading 9', '{"type":"Paragraph","name":"Heading 9","basedOn":"Normal","next":"Normal","link":"Heading 9 Char","characterFormat":{"fontSize":10.5,"italic":true,"fontFamily":"Calibri Light","fontColor":"#333333"},"paragraphFormat":{"leftIndent":0.0,"rightIndent":0.0,"firstLineIndent":0.0,"beforeSpacing":2.0,"afterSpacing":0.0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","textAlignment":"Left","outlineLevel":"Level9"}}');
        this.preDefinedStyles.add('Default Paragraph Font', '{"type":"Character","name":"Default Paragraph Font"}');
        this.preDefinedStyles.add('Heading 1 Char', '{"type":"Character","name":"Heading 1 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontSize":16.0,"fontFamily":"Calibri Light","fontColor":"#2F5496"}}');
        this.preDefinedStyles.add('Heading 2 Char', '{"type":"Character","name":"Heading 2 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontSize":13.0,"fontFamily":"Calibri Light","fontColor":"#2F5496"}}');
        this.preDefinedStyles.add('Heading 3 Char', '{"type":"Character","name":"Heading 3 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontSize":12.0,"fontFamily":"Calibri Light","fontColor": "#1F3763"}}');
        this.preDefinedStyles.add('Heading 4 Char', '{"type":"Character","name":"Heading 4 Char","basedOn":"Default Paragraph Font","characterFormat":{"italic":true,"fontFamily":"Calibri Light","fontColor":"#2F5496"}}');
        this.preDefinedStyles.add('Heading 5 Char', '{"type":"Character","name":"Heading 5 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontFamily":"Calibri Light","fontColor":"#2F5496"}}');
        this.preDefinedStyles.add('Heading 6 Char', '{"type":"Character","name":"Heading 6 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontFamily":"Calibri Light","fontColor":"#1F3763"}}');
        this.preDefinedStyles.add('Heading 7 Char', '{"type":"Character","name":"Heading 7 Char","basedOn":"Default Paragraph Font","characterFormat":{"italic":true,"fontFamily":"Calibri Light","fontColor":"#1F3763"}}');
        this.preDefinedStyles.add('Heading 8 Char', '{"type":"Character","name":"Heading 8 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontSize":10.5,"fontFamily":"Calibri Light","fontColor":"#333333"}}');
        this.preDefinedStyles.add('Heading 9 Char', '{"type":"Character","name":"Heading 9 Char","basedOn":"Default Paragraph Font","characterFormat":{"fontSize":10.5,"italic":true,"fontFamily":"Calibri Light","fontColor":"#333333"}}');
        this.preDefinedStyles.add('Hyperlink', '{"type":"Character","name":"Hyperlink","basedOn":"Default Paragraph Font","next":"Normal","characterFormat":{"fontColor":"#0563C1","underline": "Single"}}');
        this.preDefinedStyles.add('TOC 1', '{"type":"Paragraph","name":"TOC 1","basedOn":"Normal","next":"Normal","paragraphFormat":{"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 2', '{"type":"Paragraph","name":"TOC 2","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :11.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 3', '{"type":"Paragraph","name":"TOC 3","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :22.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 4', '{"type":"Paragraph","name":"TOC 4","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :33.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 5', '{"type":"Paragraph","name":"TOC 5","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :44.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 6', '{"type":"Paragraph","name":"TOC 6","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :55.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 7', '{"type":"Paragraph","name":"TOC 7","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :66.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 8', '{"type":"Paragraph","name":"TOC 8","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :77.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('TOC 9', '{"type":"Paragraph","name":"TOC 9","basedOn":"Normal","next":"Normal","paragraphFormat":{"leftIndent" :88.0,"afterSpacing":5.0}}');
        this.preDefinedStyles.add('Header', '{"type":"Paragraph","name":"Header","basedOn":"Normal","next":"Header","paragraphFormat":{"afterSpacing":0,"lineSpacing":1,"lineSpacingType":"Multiple"}}');
        this.preDefinedStyles.add('Footer', '{"type":"Paragraph","name":"Footer","basedOn":"Normal","next":"Footer","paragraphFormat":{"afterSpacing":0,"lineSpacing":1,"lineSpacingType":"Multiple"}}');
    }
    /**
     * @private
     * @returns {void}
     */
    clearDocumentItems() {
        if (this.owner.editorModule) {
            this.owner.editorModule.clear();
        }
        if (this.owner.searchModule) {
            this.owner.searchModule.clearSearchHighlight();
        }
        if (this.owner.selectionModule) {
            this.owner.selectionModule.clear();
        }
        this.editRanges.clear();
        this.headersFooters = [];
        this.fields = [];
        this.layout.lastScrollUpdatePageIndex = -1;
        this.formFields = [];
        this.currentSelectedComment = undefined;
        this.currentSelectedRevision = undefined;
        for (let i = 0; i < this.comments.length; i++) {
            const commentStart = this.comments[i].commentStart;
            if (commentStart) {
                commentStart.destroy();
            }
        }
        this.comments = [];
        this.bookmarks.clear();
        this.endBookmarksUpdated = [];
        this.styles.clear();
        this.stylesMap.clear();
        if (this.pages && this.pages.length > 0) {
            for (let i = 0; i < this.pages.length; i++) {
                let page = this.pages[i];
                page.componentDestroy();
            }
            this.pages = [];
        }
        this.authors.clear();
        this.revisionsInternal.clear();
        this.owner.revisions.clear();
        this.characterFormat.clearFormat();
        this.themeFontLanguage.clearFormat();
        this.paragraphFormat.clearFormat();
        if (this.owner.trackChangesPane) {
            this.owner.trackChangesPane.clear();
        }
        if (this.owner.xmlPaneModule) {
            this.owner.xmlPaneModule.clear();
        }
        this.setDefaultCharacterValue(this.characterFormat);
        this.setDefaultParagraphValue(this.paragraphFormat);
        if (this.owner.commentReviewPane) {
            this.owner.commentReviewPane.clear();
        }
        this.isHeaderFooter = false;
        this.defaultTabWidth = 36;
        this.isDocumentProtected = false;
        this.isRowOrCellResizing = false;
        this.protectionType = 'NoProtection';
        this.restrictFormatting = false;
        this.hashValue = '';
        this.saltValue = '';
        this.userCollection = [];
        if (this.formFillPopup) {
            this.formFillPopup.hidePopup();
        }
        if (this.contentDropDown) {
            this.contentDropDown.hidePopup();
        }
        this.customXmlData.clear();
        this.fontSubstitutionTable.clear();
        this.images.clear();
        this.contentControlCollection = [];
        this.splittedCellWidgets = [];
        this.backgroundColor = '#FFFFFF';
        this.endnotes.clear();
        this.footnotes.clear();
        this.footnoteCollection = [];
        this.endnoteCollection = [];
        if (this.lists && this.lists.length > 0) {
            for (let i = 0; i < this.lists.length; i++) {
                let list = this.lists[i];
                list.clear();
            }
        }
        this.lists = [];
        this.abstractLists = [];
        this.themes = new Themes();
        this.hasThemes = false;
        this.isRestartNumbering = false;
        this.isUpdatedWhileLoadAsync = false;
        this.isDocumentLoadAsynchronously = false;
    }
    /**
     * @private
     * @returns {void}
     */
    setDefaultDocumentFormat() {
        this.owner.parser.parseCharacterFormat(0, this.owner.characterFormat, this.characterFormat);
        this.owner.parser.parseParagraphFormat(0, this.owner.paragraphFormat, this.paragraphFormat);
        if (!isNullOrUndefined(this.owner.documentCharacterFormat)) {
            this.owner.parser.parseCharacterFormat(0, this.owner.documentCharacterFormat, this.characterFormat);
        }
        if (!isNullOrUndefined(this.owner.documentParagraphFormat)) {
            this.owner.parser.parseParagraphFormat(0, this.owner.documentParagraphFormat, this.paragraphFormat);
        }
    }
    setDefaultCharacterValue(characterFormat) {
        characterFormat.bold = false;
        characterFormat.italic = false;
        characterFormat.fontFamily = 'Calibri';
        characterFormat.fontSize = 11;
        characterFormat.underline = 'None';
        characterFormat.strikethrough = 'None';
        characterFormat.fontSizeBidi = 11;
        characterFormat.fontFamilyBidi = 'Calibri';
        characterFormat.baselineAlignment = 'Normal';
        characterFormat.highlightColor = 'NoColor';
        characterFormat.allCaps = false;
    }
    setDefaultParagraphValue(paragraphFormat) {
        paragraphFormat.leftIndent = 0;
        paragraphFormat.rightIndent = 0;
        paragraphFormat.firstLineIndent = 0;
        paragraphFormat.textAlignment = 'Left';
        paragraphFormat.beforeSpacing = 0;
        paragraphFormat.afterSpacing = 0;
        paragraphFormat.lineSpacing = 1;
        paragraphFormat.lineSpacingType = 'Multiple';
        paragraphFormat.bidi = false;
        paragraphFormat.keepWithNext = false;
        paragraphFormat.keepLinesTogether = false;
        paragraphFormat.widowControl = true;
        paragraphFormat.outlineLevel = 'BodyText';
    }
    /**
     * @private
     * @param {number} id - Specfies abstract list id.
     * @returns {WAbstractList} - Returns abstract list.
     */
    getAbstractListById(id, isNsid) {
        if (isNullOrUndefined(this.abstractLists)) {
            return undefined;
        }
        for (let i = 0; i < this.abstractLists.length; i++) {
            const abstractList = this.abstractLists[i];
            if (!isNullOrUndefined(abstractList)) {
                if (isNsid && abstractList.nsid === id) {
                    return abstractList;
                }
                else if (abstractList.abstractListId === id) {
                    return abstractList;
                }
            }
        }
        return undefined;
    }
    /**
     * @private
     * @param {number} id - Specfies list id.
     * @returns {WAbstractList} - Returns list.
     */
    getListById(id, isNsid) {
        if (isNullOrUndefined(this.lists)) {
            return undefined;
        }
        for (let i = 0; i < this.lists.length; i++) {
            let list = this.lists[i];
            if (!isNullOrUndefined(list)) {
                if (isNsid && list.nsid === id) {
                    return list;
                }
                else if (list.listId === id) {
                    return list;
                }
            }
        }
        return undefined;
    }
    /**
     * @private
     * @param {WListLevel} listLevel - Specfies list level.
     * @returns {number} - Returns list level number.
     */
    static getListLevelNumber(listLevel) {
        if (listLevel.ownerBase instanceof WLevelOverride) {
            return listLevel.ownerBase.levelNumber;
        }
        else if (listLevel.ownerBase instanceof WAbstractList && !isNullOrUndefined(listLevel.ownerBase.levels)) {
            return listLevel.ownerBase.levels.indexOf(listLevel);
        }
        else {
            return -1;
        }
    }
    /**
    * @private
    * @param {ImageElementBox} image - Specfies image.
    * @returns {number} - Returns base64string.
    */
    getImageString(image) {
        let base64ImageString = this.images.get(parseInt(image.imageString));
        let imageStr;
        if (image.isMetaFile && HelperMethods.formatClippedString(base64ImageString[0]).extension !== ".svg") {
            imageStr = base64ImageString[1];
        }
        else if (HelperMethods.formatClippedString(base64ImageString[0]).extension === ".tif") {
            imageStr = base64ImageString[1];
        }
        else {
            imageStr = base64ImageString[0];
        }
        return imageStr;
    }
    /**
     * @private
     * @param {ImageElementBox} image - Specfies image.
     * @returns {number} - Returns key for specific image.
     */
    addBase64StringInCollection(image) {
        return __awaiter(this, void 0, void 0, function* () {
            let key = this.images.length > 0 ? Math.max(...this.images.keys) + 1 : 0;
            let addToCollection = true;
            let base64ImageString = [];
            for (let i = 0; i < this.images.length; i++) {
                let index = this.images.keys[parseInt(i.toString(), 10)];
                let imageStringCol = this.images.get(index);
                if (image.isMetaFile && image.metaFileImageString === imageStringCol[0]) {
                    key = index;
                    addToCollection = false;
                    break;
                }
                else if (image.imageString === imageStringCol[0]) {
                    key = index;
                    addToCollection = false;
                    break;
                }
            }
            if (addToCollection) {
                if (image.isMetaFile) {
                    base64ImageString.push(!isNullOrUndefined(image.metaFileImageString) ? image.metaFileImageString : image.imageString);
                    base64ImageString.push(image.imageString === "" ? image.metaFileImageString : image.imageString);
                }
                else {
                    base64ImageString.push(image.imageString);
                }
                this.images.add(key, base64ImageString);
            }
            if (image.isMetaFile && !isNullOrUndefined(image.metaFileImageString)) {
                image.metaFileImageString = key.toString();
            }
            image.imageString = key.toString();
        });
    }
    /**
     * Gets the bookmarks.
     *
     * @private
     * @param {boolean} includeHidden - Include hidden bookmark.
     * @returns {string[]} - Returns bookmars present in current document.
     */
    getBookmarks(includeHidden) {
        const bookmarks = [];
        for (let i = 0; i < this.bookmarks.keys.length; i++) {
            const bookmark = this.bookmarks.keys[i];
            if (includeHidden || bookmark.indexOf('_') !== 0) {
                bookmarks.push(bookmark);
            }
        }
        return bookmarks;
    }
    selectComment(comment) {
        if (this.owner.selectionModule && this.owner.commentReviewPane) {
            this.owner.showComments = true;
            setTimeout(() => {
                if (this.owner && this.owner.selectionModule) {
                    this.owner.selectionModule.selectComment(comment);
                }
            });
        }
    }
    showComments(show) {
        if (this.owner && show && this.owner.enableComment) {
            const eventArgs = { type: 'Comment' };
            this.owner.trigger(beforePaneSwitchEvent, eventArgs);
        }
        this.owner.commentReviewPane.reviewTab.hideTab(0, false);
        this.owner.commentReviewPane.reviewTab.hideTab(1, false);
        this.owner.commentReviewPane.showHidePane(show && this.owner.enableComment, 'Comments');
    }
    showRevisions(show) {
        let isCommentTabVisible = false;
        if (this.owner && show) {
            const eventArgs = { type: 'comment' };
            this.owner.trigger(beforePaneSwitchEvent, eventArgs);
        }
        if (!show && this.owner.showComments && this.owner.documentHelper.comments.length != 0) {
            this.owner.commentReviewPane.reviewTab.hideTab(0, false);
            this.owner.commentReviewPane.showHidePane(true, 'Comments');
        }
        else {
            this.owner.isUpdateTrackChanges = false;
            if (this.owner.showRevisions) {
                show = true;
            }
            this.owner.commentReviewPane.showHidePane(show, 'Changes');
            this.owner.isUpdateTrackChanges = true;
            if (!this.owner.enableComment) {
                isCommentTabVisible = true;
            }
            // this.owner.commentReviewPane.reviewTab.hideTab(0, isCommentTabVisible);
        }
        if (show && !this.owner.showRevisions) {
            this.owner.trackChangesPane.enableDisableButton(!this.owner.isReadOnly && !this.isDocumentProtected);
        }
    }
    /**
     * Initializes components.
     *
     * @private
     * @returns {void}
     */
    initializeComponents() {
        let element = this.owner.element;
        if (isNullOrUndefined(element)) {
            return;
        }
        //let viewer: LayoutViewer = this;
        this.optionsPaneContainer = createElement('div', {
            className: 'e-documenteditor-optionspane'
        });
        this.optionsPaneContainer.contentEditable = 'false';
        element.appendChild(this.optionsPaneContainer);
        const isRtl = this.owner.enableRtl;
        let viewerContainerStyle;
        if (isRtl) {
            viewerContainerStyle = 'direction:ltr;';
        }
        this.viewerContainer = createElement('div', { id: this.owner.containerId + '_viewerContainer' });
        this.viewerContainer.style.cssText = 'position:relative;backgroundColor:#FBFBFB;overflow:auto;' + viewerContainerStyle;
        this.optionsPaneContainer.appendChild(this.viewerContainer);
        this.viewerContainer.tabIndex = -1;
        this.viewerContainer.style.outline = 'none';
        this.pageContainer = createElement('div', { id: this.owner.containerId + '_pageContainer', className: 'e-de-background' });
        this.viewerContainer.appendChild(this.pageContainer);
        this.pageContainer.style.top = '0px';
        this.pageContainer.style.left = '0px';
        this.pageContainer.style.position = 'relative';
        this.pageContainer.style.pointerEvents = 'none';
        this.owner.readableDiv = createElement('div', {
            attrs: {
                'aria-live': 'assertive',
                'role': 'region',
                'tabindex': "0",
                'style': 'position:absolute;left:0px;top:-1px;height:0px;width:0px;overflow:hidden;z-index:-2;opacity:0;',
            },
            id: element.id + 'readableDiv'
        });
        element.appendChild(this.owner.readableDiv);
        if (Browser.isDevice) {
            this.createEditableDiv(element);
        }
        else {
            this.createEditableIFrame();
        }
        if (this.owner.enableImageResizerMode) {
            this.owner.imageResizerModule.initializeImageResizer();
        }
        this.updateViewerSizeInternal(element);
        this.layout = new Layout(this);
        this.textHelper = new TextHelper(this);
        this.zoomModule = new Zoom(this);
        this.initTouchEllipse();
        this.wireEvent();
        this.restrictEditingPane = new RestrictEditing(this);
        this.owner.commentReviewPane = new CommentReviewPane(this.owner);
        this.owner.trackChangesPane = new TrackChangesPane(this.owner, this.owner.commentReviewPane);
        createSpinner({ target: this.owner.element, cssClass: 'e-spin-overlay' });
    }
    measureScrollbarWidth(element) {
        const parentDiv = document.createElement('div');
        parentDiv.style.cssText = 'visibility:hidden;overflow:scroll;';
        element.appendChild(parentDiv);
        const childDiv = document.createElement('div');
        parentDiv.appendChild(childDiv);
        this.scrollbarWidth = (parentDiv.getBoundingClientRect().width - childDiv.getBoundingClientRect().width);
        parentDiv.parentNode.removeChild(parentDiv);
    }
    createEditableDiv(element) {
        this.editableDiv = document.createElement('div');
        this.editableDiv.contentEditable = this.owner.isReadOnlyMode ? 'false' : 'true';
        this.editableDiv.style.position = 'fixed';
        this.editableDiv.style.left = '-150em';
        this.editableDiv.style.width = '100%';
        this.editableDiv.style.height = '100%';
        this.editableDiv.id = element.id + '_editableDiv';
        document.body.appendChild(this.editableDiv);
    }
    createEditableIFrame() {
        this.iframe = createElement('iframe', {
            attrs: {
                'scrolling': 'no',
                'title': 'Document Editor',
                'style': 'pointer-events:none;position:absolute;left:0px;top:0px;outline:none;background-color:transparent;width:0px;height:0px;overflow:hidden',
                'tabindex': "0"
            },
            className: 'e-de-text-target'
        });
        this.viewerContainer.appendChild(this.iframe);
        this.initIframeContent();
    }
    initIframeContent() {
        const innerHtml = `<!DOCTYPE html>
            <html lang="${this.owner.locale}">
            <head></head>
            <body spellcheck="false">
                <div contenteditable="true" role="textbox"></div>
            </body>
            </html>`;
        if (!isNullOrUndefined(this.iframe.contentDocument)) {
            this.iframe.contentDocument.open();
            this.iframe.contentDocument.write(innerHtml);
            this.iframe.contentDocument.close();
            this.editableDiv = this.iframe.contentDocument.body.children[0];
            const cssText = 'background-color:transparent;width:100%;height:100%;padding: 0px; margin: 0px';
            updateCSSText(this.iframe.contentDocument.body, cssText);
            updateCSSText(this.editableDiv, cssText);
        }
    }
    /**
     * Wires events and methods.
     *
     * @returns {void}
     */
    wireEvent() {
        if (!isNullOrUndefined(this.owner.selectionModule)) {
            this.selection.initCaret();
        }
        this.wireInputEvents();
        if (!isNullOrUndefined(this.iframe)) {
            this.iframe.addEventListener('load', this.onIframeLoad.bind(this));
        }
        this.viewerContainer.addEventListener('scroll', this.scrollHandler);
        this.viewerContainer.addEventListener('mousedown', this.onMouseDownInternal);
        this.viewerContainer.addEventListener('keydown', this.onKeyDownInternal);
        this.viewerContainer.addEventListener('mousemove', this.onMouseMoveInternal);
        this.viewerContainer.addEventListener('mouseleave', this.onMouseLeaveInternal);
        this.viewerContainer.addEventListener('mouseenter', this.onMouseEnterInternal);
        this.viewerContainer.addEventListener('contextmenu', this.onContextMenu);
        this.viewerContainer.addEventListener('dblclick', this.onDoubleTap);
        this.viewerContainer.addEventListener('mouseup', this.onMouseUpInternal);
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('keyup', this.onKeyUpInternal);
        window.addEventListener('mouseup', this.onImageResizer);
        window.addEventListener('touchend', this.onImageResizer);
        window.addEventListener('copy', this.onCopy);
        window.addEventListener("mousemove", this.onWindowMouseMoveInternal);
        this.viewerContainer.addEventListener('touchstart', this.onTouchStartInternal);
        this.viewerContainer.addEventListener('touchmove', this.onTouchMoveInternal);
        this.viewerContainer.addEventListener('touchend', this.onTouchUpInternal);
        if (navigator !== undefined && navigator.userAgent.match('Firefox')) {
            this.viewerContainer.addEventListener('DOMMouseScroll', this.zoomModule.onMouseWheelInternal);
        }
        this.viewerContainer.addEventListener('mousewheel', this.zoomModule.onMouseWheelInternal);
    }
    wireInputEvents() {
        if (isNullOrUndefined(this.editableDiv)) {
            return;
        }
        this.editableDiv.addEventListener('paste', this.onPaste);
        if (!Browser.isDevice) {
            this.editableDiv.addEventListener('keypress', this.onKeyPressInternal);
            if (Browser.info.name === 'chrome') {
                this.editableDiv.addEventListener('textInput', this.onTextInput);
            }
        }
        else {
            this.editableDiv.addEventListener('input', this.onTextInputInternal);
        }
        this.editableDiv.addEventListener('blur', this.onFocusOut);
        this.editableDiv.addEventListener('keydown', this.onKeyDownInternal);
        this.editableDiv.addEventListener('keyup', this.onViewerKeyUpInternal);
        this.editableDiv.addEventListener('compositionstart', this.compositionStart);
        this.editableDiv.addEventListener('compositionupdate', this.compositionUpdated);
        this.editableDiv.addEventListener('compositionend', this.compositionEnd);
        this.editableDiv.addEventListener('focus', this.updateFocus);
    }
    onIframeLoad() {
        if (!isNullOrUndefined(this.iframe) && this.iframe.contentDocument.body.children.length === 0) {
            this.initIframeContent();
            this.wireInputEvents();
        }
    }
    getEditableDivTextContent() {
        return this.editableDiv.textContent;
    }
    updateAuthorIdentity() {
        const revisions = this.owner.revisions.changes;
        for (let i = 0; i < revisions.length; i++) {
            this.getAuthorColor(revisions[i].author);
        }
    }
    getAvatar(userInfo, userName, comment, revision) {
        let author;
        let userinitial;
        if (!isNullOrUndefined(comment)) {
            author = comment.author;
            userinitial = comment.initial;
        }
        else {
            author = revision.author;
        }
        if (!isNullOrUndefined(author)) {
            const avatarDiv = createElement('div', { className: 'e-de-cmt-avatar' });
            const avatar = createElement('div', { className: 'e-de-ff-cmt-avatar' });
            avatar.style.minWidth = "25px";
            avatar.style.backgroundColor = this.owner.documentHelper.getAuthorColor(author);
            if (userinitial === '' || isNullOrUndefined(userinitial)) {
                const authorName = author.split(' ');
                let initial = authorName[0].charAt(0);
                if (authorName.length > 1 && authorName[authorName.length - 1] !== '') {
                    initial += authorName[authorName.length - 1][0];
                }
                avatar.innerText = initial.toUpperCase();
            }
            else {
                if (userinitial.length > 2) {
                    avatar.innerText = userinitial.substring(0, 2);
                }
                else {
                    avatar.innerText = userinitial;
                }
            }
            avatarDiv.appendChild(avatar);
            avatarDiv.appendChild(userName);
            userInfo.appendChild(avatarDiv);
        }
    }
    /**
     * @private
     * @param {string} author - Specifies author name.
     * @returns {string} - Return autor color.
     */
    getAuthorColor(author) {
        if (this.authors.containsKey(author)) {
            return this.authors.get(author);
        }
        let color;
        if (this.authors.length === 0) {
            color = '#b5082e'; //dark red
        }
        else {
            color = this.generateRandomColor();
        }
        this.authors.add(author, color);
        return color;
    }
    generateRandomColor() {
        const userColors = ['#b5082e',
            '#2e97d3',
            '#bb00ff',
            '#f37e43',
            '#03a60b',
            '#881824',
            '#e09a2b',
            '#50565e']; //dark grey
        return userColors[(this.authors.length % 8)];
    }
    /**
     * @private
     * @returns {void}
     */
    positionEditableTarget() {
        const point = this.selection.getRect(this.selection.start);
        const page = this.selection.getSelectionPage(this.selection.start);
        // const caretInfo: CaretHeightInfo = this.selection.updateCaretSize(this.owner.selection.start);
        const sectionFormat = page.bodyWidgets[0].sectionFormat;
        const left = page.boundingRectangle.x + (HelperMethods.convertPointToPixel(sectionFormat.leftMargin) * this.zoomFactor);
        const top = point.y;
        const pageWidth = sectionFormat.pageWidth - sectionFormat.leftMargin - sectionFormat.rightMargin;
        let iframeStyle = 'left:' + left + 'px;';
        iframeStyle += 'top:' + top + 'px;';
        iframeStyle += 'width:' + (HelperMethods.convertPointToPixel(pageWidth) * this.zoomFactor) + 'px;';
        iframeStyle += 'height:250px;outline-style:none;position:absolute';
        updateCSSText(this.iframe, iframeStyle);
        let style = 'background-color:transparent;width:100%;height:250px;padding: 0px; margin: 0px;';
        style += 'text-indent:' + (point.x - left) + 'px;';
        style += 'color:transparent;pointer-events:none;outline-style:none;';
        style += 'font-size:' + (HelperMethods.convertPointToPixel(this.selection.characterFormat.fontSize) * this.zoomFactor) + 'px;';
        style += 'font-family' + this.selection.characterFormat.fontFamily + ';';
        style += 'overflow:hidden;text-decoration:none;white-space:normal;';
        updateCSSText(this.editableDiv, style);
    }
    initDialog(isRtl) {
        if (!this.dialogInternal) {
            this.dialogTarget1 = createElement('div', { className: 'e-de-dlg-target' });
            this.dialogTarget1.contentEditable = 'false';
            document.body.appendChild(this.dialogTarget1);
            if (isRtl) {
                this.dialogTarget1.classList.add('e-de-rtl');
            }
            this.dialogInternal = new Dialog({
                target: this.owner.documentEditorSettings.popupTarget, showCloseIcon: true,
                allowDragging: true, enableRtl: isRtl, visible: false,
                width: '1px', isModal: true, position: { X: 'center', Y: 'center' }, zIndex: this.owner.zIndex + 20,
                animationSettings: { effect: 'None' }
            });
            this.dialogInternal.isStringTemplate = true;
            this.dialogInternal.open = this.selection.hideCaret;
            this.dialogInternal.beforeClose = this.updateFocus;
            this.dialogInternal.appendTo(this.dialogTarget1);
        }
    }
    initDialog3(isRtl) {
        if (!this.dialogInternal3) {
            this.dialogTarget3 = createElement('div', { className: 'e-de-dlg-target' });
            this.dialogTarget3.contentEditable = 'false';
            document.body.appendChild(this.dialogTarget3);
            if (isRtl) {
                this.dialogTarget3.classList.add('e-de-rtl');
            }
            this.dialogInternal3 = new Dialog({
                target: this.owner.documentEditorSettings.popupTarget, showCloseIcon: true,
                allowDragging: true, enableRtl: isRtl, visible: false,
                width: '1px', isModal: true, position: { X: 'center', Y: 'center' }, zIndex: this.owner.zIndex,
                animationSettings: { effect: 'None' }
            });
            this.dialogInternal3.isStringTemplate = true;
            this.dialogInternal3.open = this.selection.hideCaret;
            this.dialogInternal3.beforeClose = this.updateFocus;
            this.dialogInternal3.appendTo(this.dialogTarget3);
        }
    }
    hideDialog() {
        this.dialog.hide();
        this.updateFocus();
    }
    initDialog2(isRtl) {
        if (!this.dialogInternal2) {
            this.dialogTarget2 = createElement('div', { className: 'e-de-dlg-target' });
            this.dialogTarget2.contentEditable = 'false';
            document.body.appendChild(this.dialogTarget2);
            if (isRtl) {
                this.dialogTarget2.classList.add('e-de-rtl');
            }
            this.dialogInternal2 = new Dialog({
                target: this.owner.documentEditorSettings.popupTarget, showCloseIcon: true,
                allowDragging: true, enableRtl: isRtl, visible: false,
                width: '1px', isModal: true, position: { X: 'center', Y: 'Top' }, zIndex: this.owner.zIndex + 10
            });
            this.dialogInternal2.isStringTemplate = true;
            this.dialogInternal2.appendTo(this.dialogTarget2);
        }
    }
    getBase64(base64String, width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const drawImage = new Image();
                drawImage.onload = () => {
                    const displayPixelRatio = Math.max(1, window.devicePixelRatio || 1);
                    const draw = document.createElement('canvas');
                    draw.width = drawImage.naturalWidth;
                    draw.height = drawImage.naturalHeight;
                    const context = draw.getContext('2d');
                    context.drawImage(drawImage, 0, 0, drawImage.naturalWidth, drawImage.naturalHeight);
                    const imageString = draw.toDataURL('image/png', 1);
                    resolve(imageString);
                };
                drawImage.onerror = () => {
                    reject();
                };
                if (base64String && (HelperMethods.startsWith(base64String, 'http://') || HelperMethods.startsWith(base64String, 'https://'))) {
                    fetch(base64String, { cache: 'no-cache' }).then((response) => {
                        return response.blob();
                    }).then((blob) => {
                        return new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () => { return resolve(reader.result); };
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                        });
                    }).then((dataUrl) => {
                        drawImage.src = dataUrl;
                    }).catch(() => {
                        reject();
                    });
                }
            });
        });
    }
    /**
     * Clears the context.
     *
     * @private
     * @returns {void}
     */
    clearContent() {
        this.containerContext.clearRect(0, 0, this.containerCanvas.width, this.containerCanvas.height);
        this.selectionContext.clearRect(0, 0, this.selectionCanvas.width, this.selectionCanvas.height);
        // Hide comment mark
        if (this.pageContainer) {
            const commentMarkElement = this.pageContainer.getElementsByClassName('e-de-cmt-mark');
            for (let i = 0; i < commentMarkElement.length; i++) {
                commentMarkElement[i].style.display = 'none';
            }
        }
        if (this.pageContainer) {
            const editRangeStart = this.pageContainer.getElementsByClassName('e-de-lock-mark');
            for (let i = 0; i < editRangeStart.length; i++) {
                editRangeStart[i].style.display = 'none';
            }
        }
    }
    /**
     * Stores the setTimeOut id when asynchronous process.
     *
     * @private
     * @returns {void}
     */
    storeTimeoutId(loadId, timeoutId) {
        if (!this.scheduledTimeouts[loadId]) {
            this.scheduledTimeouts[loadId] = [];
        }
        this.scheduledTimeouts[loadId].push(timeoutId);
    }
    /**
     * Clears the stored setTimeOut id when suspend the asynchronous process.
     *
     * @private
     * @returns {void}
     */
    clearScheduledTimeouts(loadId) {
        if (this.scheduledTimeouts[loadId]) {
            for (const id of this.scheduledTimeouts[loadId]) {
                clearTimeout(id);
            }
            delete this.scheduledTimeouts[loadId];
        }
    }
    /**
     * Fired when the document gets changed.
     *
     * @private
     * @param {BodyWidget[]} sections - Specified document content.
     * @returns {void}
     */
    onDocumentChanged(sections, iOps, isAsync) {
        if (Object.keys(this.scheduledTimeouts).length !== 0) {
            this.clearScheduledTimeouts(this.currentDocumentLoadId);
        }
        if (isAsync) {
            this.currentDocumentLoadId++;
        }
        this.clearContent();
        if (this.owner.editorModule) {
            this.owner.editorModule.tocStyles = {};
            this.owner.editorModule.tocBookmarkId = 0;
        }
        this.heightInfoCollection = {};
        this.owner.isDocumentLoaded = false;
        this.viewer.columnLayoutArea.clear();
        this.layout.isDocumentContainsRtl = false;
        this.layout.isMultiColumnDoc = false;
        this.isMappedContentControlUpdated = true;
        this.isSpellCheckPending = false;
        this.isDocumentLoadAsynchronously = false;
        this.isUpdatedWhileLoadAsync = false;
        this.updateAuthorIdentity();
        for (let i = 0; i < this.pages.length; i++) {
            for (let j = 0; j < this.pages[i].bodyWidgets.length; j++) {
                this.pages[i].bodyWidgets[j].destroy();
            }
        }
        this.pages = [];
        if (!isNullOrUndefined(this.renderedLists)) {
            this.renderedLists.clear();
        }
        if (!isNullOrUndefined(this.renderedLevelOverrides)) {
            this.renderedLevelOverrides = [];
        }
        if (!isNullOrUndefined(this.owner.editorHistoryModule)) {
            this.owner.editorHistoryModule.destroy();
        }
        this.owner.isDocumentLoaded = true;
        this.owner.isUpdateTrackChanges = false;
        this.layout.isInitialLoad = true;
        this.layout.footHeight = 0;
        this.layout.footnoteHeight = 0;
        // Core logic for both sync and async paths
        const executeAfterLayout = () => {
            if (this.owner.selectionModule) {
                this.selection.previousSelectedFormField = undefined;
                if (this.formFields.length > 0) {
                    this.owner.selectionModule.highlightFormFields();
                }
                this.owner.selectionModule.editRangeCollection = [];
                // Skip selection update if it has already been updated during asynchronous loading.
                if (!this.isUpdatedWhileLoadAsync) {
                    this.owner.selectionModule.selectRange(this.owner.documentStart, this.owner.documentStart);
                }
                if (this.isDocumentProtected && this.protectionType === 'FormFieldsOnly') {
                    this.owner.selectionModule.navigateToNextFormField();
                }
                if (this.isDocumentProtected) {
                    this.restrictEditingPane.showHideRestrictPane(true);
                }
            }
            if (!isNullOrUndefined(iOps) && this.owner.editorModule) {
                this.owner.editorModule.intializeDefaultStyles();
            }
            this.owner.skipStyleUpdate = false;
            if (this.owner.enableCollaborativeEditing && this.owner.collaborativeEditingHandlerModule && this.owner.enableEditor) {
                this.owner.editorModule.isRemoteAction = true;
                this.owner.editorModule.isIncrementalSave = true;
                if (iOps && !isNullOrUndefined(iOps[incrementalOps[0]]) && iOps[incrementalOps[0]].length > 0) {
                    for (let k = 0; k < iOps[incrementalOps[0]].length; k++) {
                        this.owner.collaborativeEditingHandlerModule.applyRemoteAction('action', iOps[incrementalOps[0]][k]);
                    }
                }
                this.owner.editorModule.isRemoteAction = false;
                this.owner.editorModule.isIncrementalSave = false;
                this.owner.selectionModule.selectRange(this.owner.documentStart, this.owner.documentStart);
            }
            if (!this.isUpdatedWhileLoadAsync) {
                this.performUpdateAfterLoad(isAsync, true);
            }
            else { // re update the track changes once document layout completed in async loading.
                this.owner.isUpdateTrackChanges = false;
                this.owner.trackChangesPane.updateTrackChanges();
                this.owner.isUpdateTrackChanges = true;
            }
            this.owner.notify(internalStyleCollectionChange, {});
            this.owner.documentHelper.isDocumentLoadAsynchronously = false;
            this.isUpdatedWhileLoadAsync = false;
            this.owner.fireDocumentChange();
            this.owner.showHideRulers();
            let picture_cc = this.owner.element.querySelector('#' + this.owner.element.id + 'PICTURE_CONTENT_CONTROL');
            if (!isNullOrUndefined(picture_cc)) {
                this.owner.renderPictureContentControlElement(this.owner, false, false);
            }
            this.layout.isInitialLoad = false;
        };
        // Handle synchronous path
        const synchronousExecution = () => {
            // Run layout synchronously
            this.layout.layoutItems(sections, false, undefined, isAsync);
            executeAfterLayout();
        };
        // Handle asynchronous path
        const asynchronousExecution = () => __awaiter(this, void 0, void 0, function* () {
            const layoutPromise = this.layout.layoutItems(sections, false, undefined, isAsync);
            if (this.owner.selectionModule) {
                this.selection.isModifyingSelectionInternally = true;
                this.owner.selectionModule.selectRange(this.owner.documentStart, this.owner.documentStart);
                this.selection.isModifyingSelectionInternally = false;
            }
            if (layoutPromise instanceof Promise) {
                yield layoutPromise;
            }
            executeAfterLayout();
        });
        if (isAsync) {
            return asynchronousExecution();
        }
        else {
            synchronousExecution();
            return;
        }
    }
    /**
 * To update after load
 *
 * @private
 * @returns {void}
 */
    performUpdateAfterLoad(isAsync, skipSelection) {
        if (isAsync) {
            hideSpinner(this.owner.element);
            createSpinner({ target: this.viewerContainer });
            showSpinner(this.viewerContainer);
            const spinnerPane = this.viewerContainer.querySelector('.e-spinner-pane');
            if (spinnerPane) {
                spinnerPane.style.pointerEvents = 'none';
            }
            if (!skipSelection && this.owner.selectionModule) {
                this.owner.selectionModule.selectRange(this.owner.documentStart, this.owner.documentStart);
            }
            this.layout.layoutComments(this.comments);
            if (this.owner.commentReviewPane) {
                createSpinner({ target: this.owner.commentReviewPane.reviewPane });
                showSpinner(this.owner.commentReviewPane.reviewPane);
            }
        }
        if (this.owner.selectionModule) {
            if (this.isDocumentProtected) {
                this.restrictEditingPane.showHideRestrictPane(true);
            }
        }
        if (this.owner.optionsPaneModule) {
            this.owner.optionsPaneModule.showHideOptionsPane(false);
        }
        if (this.restrictEditingPane.restrictPane && !this.isDocumentProtected) {
            this.restrictEditingPane.showHideRestrictPane(false);
        }
        if (this.owner.xmlPaneModule) {
            this.owner.editor.XMLFilesNameSpaceCount = 1;
            this.owner.xmlPaneModule.showXmlProperties(false);
            this.owner.xmlPaneModule.isXmlPaneShow = false;
        }
        if (!isNullOrUndefined(this.owner.selectionModule) && this.owner.selectionModule.isViewPasteOptions) {
            this.owner.selectionModule.isViewPasteOptions = false;
            this.owner.selectionModule.showHidePasteOptions(undefined, undefined);
        }
        if (!isNullOrUndefined(this.owner) && this.owner.showRevisions) {
            this.showRevisions(true);
            if (isAsync && this.owner.trackChangesPane) {
                createSpinner({ target: this.owner.trackChangesPane.trackChangeDiv });
                showSpinner(this.owner.trackChangesPane.trackChangeDiv);
            }
        }
        else {
            this.owner.trackChangesPane.changes = new Dictionary();
            this.owner.revisions.groupedView = new Dictionary();
            for (let i = 0; i < this.owner.revisions.changes.length; i++) {
                let revision = this.owner.revisions.changes[i];
                let previousRevision = this.owner.revisions.checkAndGetPreviousRevisionToCombine(revision);
                if (previousRevision) {
                    let changeSingleView = this.owner.trackChangesPane.changes.get(previousRevision);
                    this.owner.revisions.groupedView.get(changeSingleView).push(revision);
                    this.owner.trackChangesPane.changes.add(revision, changeSingleView);
                }
                else {
                    let currentChangeView = new ChangesSingleView(this.owner, this.owner.trackChangesPane);
                    this.owner.revisions.groupedView.add(currentChangeView, [revision]);
                    this.owner.revisions.revisions.push(revision);
                    this.owner.trackChangesPane.changes.add(revision, currentChangeView);
                }
            }
        }
        if (!isNullOrUndefined(this.owner)) {
            this.owner.isUpdateTrackChanges = true;
        }
    }
    /**
     * Initialize touch ellipse.
     *
     * @returns {void}
     */
    initTouchEllipse() {
        const style = 'height: 30px;width: 30px;position: absolute;background-color: transparent;margin: 0px;padding: 0px;z-index:5';
        const ellipse = ' height: 12px;width: 12px;border-radius: 50%;background-color: white;position: absolute;margin: 0px 6px 0px 6px;border-width: 2px;border-style: solid;border-color: #000000;box-sizing: unset;';
        this.touchStart = createElement('div', { className: 'e-touch-ellipse', styles: style });
        const start = createElement('div', { styles: ellipse });
        this.touchEnd = createElement('div', { className: 'e-touch-ellipse', styles: style });
        this.touchStart.style.display = 'none';
        const end = createElement('div', { styles: ellipse });
        this.touchStart.appendChild(start);
        this.touchEnd.appendChild(end);
        this.touchEnd.style.display = 'none';
        this.viewerContainer.appendChild(this.touchStart);
        this.viewerContainer.appendChild(this.touchEnd);
    }
    /**
     * Updates touch mark position.
     *
     * @private
     * @returns {void}
     */
    updateTouchMarkPosition() {
        if (this.touchStart.style.display !== 'none' && !isNullOrUndefined(this.selection)) {
            if (!this.selection.isEmpty) {
                let y = this.selection.getCaretBottom(this.selection.start, false);
                let page = this.selection.getPage(this.selection.start.paragraph);
                const pageTop = (page.boundingRectangle.y - (this.owner.viewer.pageGap * (this.pages.indexOf(page) + 1)) * this.zoomFactor + this.owner.viewer.pageGap * (this.pages.indexOf(page) + 1));
                this.touchStart.style.left = page.boundingRectangle.x + (Math.round(this.selection.start.location.x) * this.zoomFactor - 14) + 'px';
                this.touchStart.style.top = pageTop + ((y) * this.zoomFactor) + 'px';
                if (!this.selection.isEmpty) {
                    y = this.selection.getCaretBottom(this.selection.end, false);
                    page = this.selection.getPage(this.selection.end.paragraph);
                }
                this.touchEnd.style.left = page.boundingRectangle.x + (Math.round(this.selection.end.location.x) * this.zoomFactor - 14) + 'px';
                this.touchEnd.style.top = pageTop + (y * this.zoomFactor) + 'px';
            }
            else {
                this.selection.updateCaretPosition();
            }
        }
    }
    autoScrollOnSelection(cursorPoint) {
        //Auto scroll when mouse moved hold on the edge of the viewer container.
        if (this.scrollMoveTimer && (cursorPoint.y <= 0 || cursorPoint.y > 50 || cursorPoint.y < (this.viewerContainer.offsetHeight - 50))) {
            clearInterval(this.scrollMoveTimer);
            this.scrollMoveTimer = 0;
        }
        else if (cursorPoint.y < 60) {
            clearInterval(this.scrollMoveTimer);
            //Scroll up
            this.scrollMoveTimer = setInterval(() => {
                this.viewerContainer.scrollTop -= 20;
                setTimeout(() => {
                    const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, !this.owner.enableHeaderAndFooter);
                    const widget = this.getLineWidget(touchPoint);
                    if (!isNullOrUndefined(widget)) {
                        this.selection.updateTextPosition(widget, touchPoint);
                    }
                }, 200);
            }, 200);
        }
        else if (cursorPoint.y > (this.viewerContainer.offsetHeight - 70)) {
            clearInterval(this.scrollMoveTimer);
            //Scroll down
            this.scrollMoveTimer = setInterval(() => {
                this.viewerContainer.scrollTop += 20;
                setTimeout(() => {
                    const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, !this.owner.enableHeaderAndFooter);
                    const widget = this.getLineWidget(touchPoint);
                    if (!isNullOrUndefined(widget)) {
                        this.selection.updateTextPosition(widget, touchPoint);
                    }
                }, 200);
            }, 200);
        }
    }
    scrollForwardOnSelection(cursorPoint) {
        if (this.viewerContainer) {
            const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, !this.owner.enableHeaderAndFooter);
            const textPosition = this.owner.selectionModule.end;
            const startWidget = this.getLineWidget(this.mouseDownOffset);
            if ((!this.owner.enableImageResizerMode || !this.owner.imageResizerModule.isImageResizerVisible
                || this.owner.imageResizerModule.isShapeResize) && !isNullOrUndefined(startWidget)) {
                this.skipScrollToPosition = true;
                this.owner.selectionModule.moveTextPosition(touchPoint, textPosition, true);
            }
        }
    }
    scrollBackwardOnSelection(cursorPoint) {
        const touchPoint = this.owner.viewer.findFocusedPage(cursorPoint, !this.owner.enableHeaderAndFooter);
        const textPosition = this.owner.selectionModule.end;
        const startWidget = this.getLineWidget(this.mouseDownOffset);
        if ((!this.owner.enableImageResizerMode || !this.owner.imageResizerModule.isImageResizerVisible
            || this.owner.imageResizerModule.isShapeResize) && !isNullOrUndefined(startWidget)) {
            this.skipScrollToPosition = true;
            this.owner.selectionModule.moveTextPosition(touchPoint, textPosition, true);
        }
    }
    navigateToEndNote(inline, startPosition, endPosition) {
        let pageIndex = this.pages.length - 1;
        let endnotes;
        // Loop through pages starting from the last page and move backwards
        while (pageIndex >= 0) {
            endnotes = this.pages[pageIndex].endnoteWidget;
            // Break the loop if endnotes is null or undefined
            if (isNullOrUndefined(endnotes)) {
                break;
            }
            for (let i = 0; i < endnotes.bodyWidgets.length; i++) {
                // check if the endNote reference isn't continued from the previous page
                if (isNullOrUndefined(endnotes.bodyWidgets[i].previousSplitWidget)) {
                    const endnoteText = (endnotes.bodyWidgets[i]).footNoteReference;
                    if (inline.text === endnoteText.text) {
                        startPosition.setPositionParagraph(endnotes.bodyWidgets[i].childWidgets[0].childWidgets[0], 0);
                        endPosition.setPositionParagraph(endnotes.bodyWidgets[i].childWidgets[0].childWidgets[0], 0);
                        this.selection.selectRange(startPosition, endPosition);
                        break;
                    }
                }
            }
            pageIndex--;
        }
    }
    moveSelectedContent() {
        this.isDragStarted = false;
        let isDroppedInSameCell = false;
        let info = this.owner.editor.getSelectionInfo(true);
        let start = this.selection.getTextPosBasedOnLogicalIndex(info.start);
        let end = this.selection.getTextPosBasedOnLogicalIndex(info.end);
        if (!this.selection.isForward) {
            start = this.selection.getTextPosBasedOnLogicalIndex(info.end);
            end = this.selection.getTextPosBasedOnLogicalIndex(info.start);
        }
        let dropSelectionStartParaInfo = this.selection.getParagraphInfo(start);
        let dropSelectionEndParaInfo = this.selection.getParagraphInfo(end);
        let dropSelectionStartParaIndex = this.selection.getHierarchicalIndex(dropSelectionStartParaInfo.paragraph, dropSelectionStartParaInfo.offset.toString());
        let dropSelectionEndParaIndex = this.selection.getHierarchicalIndex(dropSelectionEndParaInfo.paragraph, dropSelectionEndParaInfo.offset.toString());
        let dropSelectionStartPos = this.selection.getTextPosBasedOnLogicalIndex(dropSelectionStartParaIndex);
        let dropSelectionEndPos = this.selection.getTextPosBasedOnLogicalIndex(dropSelectionEndParaIndex);
        let dragOnSelectionStartParaIndex = this.selection.getHierarchicalIndex(this.dragStartParaInfo.paragraph, this.dragStartParaInfo.offset.toString());
        let dragOnSelectionEndParaIndex = this.selection.getHierarchicalIndex(this.dragEndParaInfo.paragraph, this.dragEndParaInfo.offset.toString());
        let dragOnSelectionStartPos = this.selection.getTextPosBasedOnLogicalIndex(dragOnSelectionStartParaIndex);
        let dragOnSelectionEndPos = this.selection.getTextPosBasedOnLogicalIndex(dragOnSelectionEndParaIndex);
        let isDraggedInSamePara = false;
        if (dropSelectionStartParaInfo.paragraph === dragOnSelectionStartPos.paragraph) {
            isDraggedInSamePara = true;
        }
        if (this.owner.selection.start.paragraph.isInsideTable) {
            let droppedCell = dropSelectionStartPos.paragraph.associatedCell;
            if (this.selection.selectedWidgets.containsKey(droppedCell)) {
                isDroppedInSameCell = true;
            }
        }
        if ((!this.owner.selection.start.paragraph.isInsideTable &&
            (dropSelectionStartPos.isExistBefore(dragOnSelectionStartPos) ||
                dropSelectionEndPos.isExistAfter(dragOnSelectionEndPos))) ||
            (this.owner.selection.start.paragraph.isInsideTable && !isDroppedInSameCell)) {
            this.owner.editorModule.initComplexHistory('DragAndDropContent');
            this.selection.start = dragOnSelectionStartPos;
            this.selection.end = dragOnSelectionEndPos;
            let isEnableLocalPasteTrue = this.owner.enableLocalPaste;
            if (!isEnableLocalPasteTrue) {
                this.owner.enableLocalPaste = true;
            }
            let dropExtraOffset = this.dragEndParaInfo.paragraph.getLength();
            let hasNewLineChar = false;
            if (dropExtraOffset < this.dragEndParaInfo.offset
                || !this.dragStartParaInfo.paragraph.equals(this.dragEndParaInfo.paragraph)) {
                hasNewLineChar = true;
            }
            const hasEditRegions = this.isDocumentProtected && this.editRanges && this.editRanges.keys.length > 0;
            let sourceEditable = true;
            let targetEditable = true;
            let shouldCut = true;
            if (hasEditRegions) {
                sourceEditable = this.selection.checkSelectionIsAtEditRegion(dragOnSelectionStartPos, dragOnSelectionEndPos);
                targetEditable = this.selection.checkSelectionIsAtEditRegion(dropSelectionStartPos, dropSelectionEndPos);
                shouldCut = sourceEditable && targetEditable;
            }
            if (shouldCut) {
                this.owner.editorModule.cut();
            }
            else if (targetEditable) {
                this.owner.selection.copy();
            }
            if (shouldCut) {
                if (this.dragEndParaInfo.paragraph.equals(dropSelectionStartParaInfo.paragraph)
                    && this.dragEndParaInfo.offset < dropSelectionStartParaInfo.offset
                    && !this.owner.enableTrackChanges) {
                    dropExtraOffset -= this.dragEndParaInfo.paragraph.getLength();
                    dropSelectionStartParaInfo.offset -= dropExtraOffset;
                    dropSelectionEndParaInfo.offset -= dropExtraOffset;
                    dropSelectionStartParaIndex = this.selection.getHierarchicalIndex(dropSelectionStartParaInfo.paragraph, dropSelectionStartParaInfo.offset.toString());
                    dropSelectionEndParaIndex = this.selection.getHierarchicalIndex(dropSelectionEndParaInfo.paragraph, dropSelectionEndParaInfo.offset.toString());
                }
                if (!hasNewLineChar || !this.dragEndParaInfo.paragraph.equals(dropSelectionEndParaInfo.paragraph) && !isDraggedInSamePara) {
                    dropSelectionStartParaIndex = this.selection.getHierarchicalIndex(dropSelectionStartParaInfo.paragraph, dropSelectionStartParaInfo.offset.toString());
                    dropSelectionEndParaIndex = this.selection.getHierarchicalIndex(dropSelectionEndParaInfo.paragraph, dropSelectionEndParaInfo.offset.toString());
                }
            }
            dropSelectionStartPos = this.selection.getTextPosBasedOnLogicalIndex(dropSelectionStartParaIndex);
            dropSelectionEndPos = this.selection.getTextPosBasedOnLogicalIndex(dropSelectionEndParaIndex);
            this.selection.start = dropSelectionStartPos;
            this.selection.end = dropSelectionEndPos;
            if (targetEditable) {
                this.owner.editorModule.copiedTextContent = '';
                this.owner.editorModule.paste();
            }
            if (!isEnableLocalPasteTrue) {
                this.owner.enableLocalPaste = false;
            }
            this.owner.editorHistoryModule.updateComplexHistory();
        }
        else {
            this.owner.selectionModule.selectPosition(dragOnSelectionStartPos, dragOnSelectionEndPos);
        }
        this.dragStartParaInfo = undefined;
        this.dragEndParaInfo = undefined;
        this.selection.caret.classList.add("e-de-cursor-animation");
    }
    isSelectionInListText(cursorPoint) {
        let widget = this.getLineWidget(cursorPoint);
        if (!isNullOrUndefined(widget) && widget.children[0] instanceof ListTextElementBox) {
            let left = this.getLeftValue(widget);
            let width = widget.children[0].width;
            let height = widget.children[0].height;
            let paragraph = widget.paragraph;
            // if beforespacing value is applied for the paragraph, we need to add the value with line height to select the list text properly
            height += !isNullOrUndefined(paragraph.paragraphFormat) && !paragraph.paragraphFormat.contextualSpacing ? paragraph.paragraphFormat.beforeSpacing : 0;
            if (this.isInsideRect(left, widget.paragraph.y, width, height, cursorPoint)) {
                this.selectionLineWidget = widget;
                return true;
            }
        }
        return false;
    }
    isInShapeBorder(floatElement, cursorPoint) {
        if (!isNullOrUndefined(floatElement)) {
            let width = floatElement.width;
            let height = floatElement.height;
            if (this.isInsideRect(floatElement.x - floatElement.margin.left, floatElement.y - floatElement.margin.top, width, height, cursorPoint)) {
                // this.selectionLineWidget = this.getLineWidget(cursorPoint);
                if (floatElement instanceof ImageElementBox) {
                    return true;
                }
                else if (floatElement instanceof ShapeElementBox) {
                    let lineWidth = floatElement.lineFormat.weight;
                    if (!(this.isInsideRect(floatElement.x + lineWidth, floatElement.y + lineWidth + floatElement.textFrame.marginTop, width - (lineWidth * 2), height - ((lineWidth * 2) + floatElement.textFrame.marginTop + floatElement.textFrame.marginBottom), cursorPoint))) {
                        return true;
                    }
                }
                else if (floatElement instanceof GroupShapeElementBox) {
                    let widget = this.getWidgetFromGroup(floatElement, cursorPoint);
                    if (isNullOrUndefined(widget)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    getWidgetFromGroup(floatElement, cursorPoint) {
        let widget;
        for (var j = 0; j < floatElement.childWidgets.length; j++) {
            var childShapeElement = floatElement.childWidgets[j];
            if (cursorPoint.x < childShapeElement.x + childShapeElement.margin.left + childShapeElement.width &&
                cursorPoint.x > childShapeElement.x && cursorPoint.y < childShapeElement.y + childShapeElement.margin.top +
                childShapeElement.height && cursorPoint.y > childShapeElement.y) {
                if (childShapeElement instanceof ShapeElementBox) {
                    widget = this.selection.getLineWidgetBodyWidget(childShapeElement.textFrame, cursorPoint);
                }
                else if (childShapeElement instanceof GroupShapeElementBox) {
                    widget = this.getWidgetFromGroup(childShapeElement, cursorPoint);
                }
                if (!isNullOrUndefined(widget)) {
                    return widget;
                }
                break;
            }
        }
        return undefined;
    }
    /**
     * Check whether touch point is inside the rectangle or not.
     *
     * @private
     * @param {number} x - Specifies left position.
     * @param {number} y - Specifies top position.
     * @param {number} width - Specifies width.
     * @param {number} height - Specifies height
     * @param {Point} touchPoint - Specifies the point to check.
     * @returns {boolean} - Return true if points intersect.
     */
    isInsideRect(x, y, width, height, touchPoint) {
        if ((touchPoint.x > (x - this.resizerBoundaryWidth) && touchPoint.x <= x + width)
            && (touchPoint.y > y && touchPoint.y <= y + height)) {
            return true;
        }
        return false;
    }
    getLeftValue(widget) {
        let left = widget.paragraph.x;
        let paragraphFormat = widget.paragraph.paragraphFormat;
        if (this.selection.isParagraphFirstLine(widget)) {
            if (paragraphFormat.textAlignment === 'Right') {
                left -= HelperMethods.convertPointToPixel(paragraphFormat.firstLineIndent);
                left -= HelperMethods.convertPointToPixel(paragraphFormat.leftIndent);
            }
            else {
                left += HelperMethods.convertPointToPixel(paragraphFormat.firstLineIndent);
            }
        }
        let element = widget.children[0];
        if (element instanceof ListTextElementBox) {
            left += element.margin.left;
        }
        return left;
    }
    /**
     * Checks whether left mouse button is pressed or not.
     *
     * @param {MouseEvent} event - Specifies mouse event.
     * @returns {boolean} - Returns true if left mouse button is clicked.
     */
    isLeftButtonPressed(event) {
        this.isTouchInput = false;
        let button = event.type === 'mouseup' ? event.which || event.button : event.buttons || event.button;
        return button === 1;
    }
    updateSelectionOnTouch(point, touchPoint) {
        this.zoomX = undefined;
        this.zoomY = undefined;
        if (this.isMouseDown && !this.isSelectionChangedOnMouseMoved && !isNullOrUndefined(this.currentPage) && !isNullOrUndefined(this.owner.selectionModule.start)) {
            if (!isNullOrUndefined(this.currentSelectedComment) && this.owner.commentReviewPane
                && !this.owner.commentReviewPane.commentPane.isEditMode) {
                this.currentSelectedComment = undefined;
            }
            if (this.touchDownOnSelectionMark === 0) {
                this.updateTextPositionForSelection(new Point(touchPoint.x, touchPoint.y), this.tapCount);
                if (this.tapCount === 2) {
                    this.selection.checkAndEnableHeaderFooter(point, touchPoint);
                }
            }
            if (this.owner.selectionModule.isEmpty) {
                this.selection.updateCaretPosition();
            }
            this.selection.checkForCursorVisibility();
        }
    }
    /**
     * Gets touch offset value.
     *
     * @private
     * @param {TouchEvent} event - Specifies touch event
     * @returns {Point}  - Returns modified touch offset
     */
    getTouchOffsetValue(event) {
        let targetElement = this.viewerContainer;
        let offset = targetElement.getBoundingClientRect();
        let touchOffsetValues = event.touches[0];
        if (isNullOrUndefined(touchOffsetValues)) {
            touchOffsetValues = event.changedTouches[0];
        }
        let offsetX = touchOffsetValues.clientX - offset.left;
        let offsetY = touchOffsetValues.clientY - offset.top;
        return new Point(offsetX, offsetY);
    }
    /**
     * Fired on pinch zoom in.
     *
     * @private
     * @param {TouchEvent} event - Specifies touch event
     * @returns {void}
     */
    onPinchInInternal(event) {
        this.preZoomFactor = this.zoomFactor;
        let updatedZoomFactor = this.zoomFactor - 0.01;
        if (updatedZoomFactor < 5 && updatedZoomFactor > 2) {
            updatedZoomFactor = updatedZoomFactor - 0.01;
        }
        if (updatedZoomFactor < 0.1) {
            updatedZoomFactor = 0.1;
        }
        this.zoomFactor = updatedZoomFactor;
    }
    onPinchOutInternal(event) {
        this.preZoomFactor = this.zoomFactor;
        let updatedZoomFactor = this.zoomFactor + 0.01;
        if (updatedZoomFactor > 2) {
            updatedZoomFactor = updatedZoomFactor + 0.01;
        }
        if (updatedZoomFactor > 5) {
            updatedZoomFactor = 5;
        }
        this.zoomFactor = updatedZoomFactor;
    }
    getPageWidth(page) {
        let width = page.boundingRectangle.width;
        return width;
    }
    /**
     * Removes specified page.
     * @private
     * @param {Page} page - Specifies page to remove
     * @returns {void}
     */
    removePage(page) {
        if (this.currentPage === page) {
            this.currentPage = undefined;
        }
        if (page.headerWidgetIn) {
            page.headerWidgetIn.page = undefined;
        }
        if (page.footerWidgetIn) {
            page.footerWidgetIn.page = undefined;
        }
        if (page.headerWidget && page.headerWidget.page === page) {
            page.headerWidget.page = undefined;
        }
        if (page.footerWidget && page.footerWidget.page === page) {
            page.footerWidget.page = undefined;
        }
        let index = this.pages.indexOf(page);
        if (index > -1) {
            this.pages.splice(index, 1);
        }
        //this.removeRenderedPages();
        if (!isNullOrUndefined(this.owner.viewer.visiblePages)) {
            if ((this.owner.viewer.visiblePages).indexOf(page) > -1) {
                let pageIndex = (this.owner.viewer.visiblePages).indexOf(page);
                (this.owner.viewer.visiblePages).splice(pageIndex, 1);
            }
        }
        //(viewer as PageLayoutViewer).visiblePages.remove(page);
        let height = 0;
        for (let i = 0; i < this.pages.length; i++) {
            height = height + this.pages[i].boundingRectangle.height;
        }
        //Updates the vertical height.
        height -= page.boundingRectangle.height + 20;
        //ToDo:Update horizontal width, if removed page has max width.
        let top = 20;
        if (index > 0) {
            top += this.pages[index - 1].boundingRectangle.bottom;
        }
        if (index !== -1) {
            for (let i = index; i < this.pages.length; i++) {
                //Update bounding rectangle of next pages in collection.
                page = this.pages[i];
                page.boundingRectangle = new Rect(page.boundingRectangle.x, top, page.boundingRectangle.width, page.boundingRectangle.height);
                top = page.boundingRectangle.bottom + 20;
                if (page.bodyWidgets.length > 0 && !isNullOrUndefined(page.bodyWidgets[0].firstChild) && !(page.bodyWidgets[0].firstChild instanceof TableWidget && page.bodyWidgets[0].firstChild.header)) {
                    page.repeatHeaderRowTableWidget = false;
                }
            }
        }
    }
    // private removeRenderedPages(): void {
    //     for (let i: number = 0; i < this.pages.length; i++) {
    //         this.clearContainer(this.pages[i]);
    //     }
    // }
    /**
     * Updates viewer size on window resize.
     *
     * @private
     * @returns {void}
     */
    updateViewerSize() {
        let element = this.owner.getDocumentEditorElement();
        this.updateViewerSizeInternal(element);
        this.owner.viewer.updateScrollBars();
        if (this.owner.viewer instanceof WebLayoutViewer && (!isNullOrUndefined(this.owner)) && (!isNullOrUndefined(element))) {
            if (this.resizerTimer) {
                clearTimeout(this.resizerTimer);
            }
            /* eslint-disable @typescript-eslint/indent */
            this.resizerTimer = setTimeout(() => {
                if (!isNullOrUndefined(this.owner)) {
                    let currentVisibleWidth;
                    if (!isNullOrUndefined(this.visibleBounds)) {
                        currentVisibleWidth = this.visibleBounds.width;
                    }
                    else {
                        currentVisibleWidth = 0;
                    }
                    if (isNullOrUndefined(this.owner.viewer.preVisibleWidth)) {
                        this.owner.viewer.preVisibleWidth = 0;
                    }
                    if ((!isNullOrUndefined(this.visibleBounds) && (currentVisibleWidth !== this.owner.viewer.preVisibleWidth))) {
                        this.layout.layoutWholeDocument();
                        this.owner.viewer.preVisibleWidth = currentVisibleWidth;
                    }
                    if (this.resizerTimer) {
                        clearTimeout(this.resizerTimer);
                    }
                }
            }, 50);
        }
        if (!isNullOrUndefined(this.selection)) {
            this.selection.updateCaretPosition();
        }
        // if(!isNullOrUndefined(this.owner) && (!isNullOrUndefined(this.owner.hRuler && !isNullOrUndefined(this.owner.vRuler))))
        // {
        //      updateRuler(this.owner);
        // }
    }
    /**
     * @private
     */
    triggerAutoResizeInterval() {
        let timer = 0;
        let element = this.owner.element;
        let args = { cancel: false };
        this.owner.notify(beforeAutoResize, args);
        if (!isNullOrUndefined(args.element)) {
            element = args.element;
        }
        element.style.visibility = 'hidden';
        showSpinner(element);
        let counter = 0;
        let internal = this.owner.documentEditorSettings.autoResizeSettings.interval;
        if (this.isAutoResizeCanStart) {
            timer = setInterval(() => {
                counter++;
                let tempRect = this.owner.element.getBoundingClientRect();
                if (tempRect.width !== 0 && tempRect.height !== 0) {
                    this.isAutoResizeCanStart = false;
                    let args = { cancel: false };
                    this.owner.notify(internalAutoResize, args);
                    clearInterval(timer);
                    if (!args.cancel) {
                        this.owner.resize();
                    }
                    hideSpinner(element);
                    element.style.visibility = 'visible';
                }
                else if (counter > this.owner.documentEditorSettings.autoResizeSettings.iterationCount) {
                    clearInterval(timer);
                    hideSpinner(element);
                    element.style.visibility = 'visible';
                }
            }, internal);
        }
        else {
            hideSpinner(element);
            element.style.visibility = 'visible';
        }
    }
    updateViewerSizeInternal(element) {
        if (!isNullOrUndefined(element)) {
            let computedStyle = getComputedStyle(element);
            let rectHeight = parseFloat(computedStyle.height.replace('px', ''));
            let rectWidth = parseFloat(computedStyle.width.replace('px', ''));
            if (rectWidth === 0 && rectHeight === 0) {
                this.isAutoResizeCanStart = true;
            }
            else {
                this.isAutoResizeCanStart = false;
            }
            let width = 0;
            let height = 0;
            height = rectHeight > 0 ? rectHeight : 200;
            let restrictPaneRect = this.restrictEditingPane && this.restrictEditingPane.isShowRestrictPane ?
                this.getComputedWidth(this.restrictEditingPane.restrictPane) : undefined;
            let optionsRect = this.owner.optionsPaneModule && this.owner.optionsPaneModule.isOptionsPaneShow ?
                this.getComputedWidth(this.owner.optionsPaneModule.optionsPane) : undefined;
            let commentPane = 0;
            if (this.owner.commentReviewPane && this.owner.commentReviewPane.parentPaneElement) {
                commentPane = this.getComputedWidth(this.owner.commentReviewPane.parentPaneElement);
            }
            let xmlPaneRect = this.owner.xmlPaneModule && this.owner.xmlPaneModule.isXmlPaneShow ?
                this.getComputedWidth(this.owner.xmlPaneModule.element) : undefined;
            if (restrictPaneRect || optionsRect || commentPane || xmlPaneRect) {
                let paneWidth = restrictPaneRect ? restrictPaneRect : 0;
                paneWidth += optionsRect ? optionsRect : 0;
                paneWidth += commentPane ? commentPane : 0;
                paneWidth += xmlPaneRect ? xmlPaneRect : 0;
                width = (rectWidth - paneWidth) > 0 ? (rectWidth - paneWidth) : 200;
            }
            else {
                width = rectWidth > 0 ? rectWidth : 200;
            }
            this.viewerContainer.style.height = height.toString() + 'px';
            this.viewerContainer.style.width = Math.ceil(width) + 'px';
            this.visibleBoundsIn = new Rect(0, 0, width, height);
            this.containerCanvas.width = width;
            this.containerCanvas.height = height;
            this.containerCanvas.style.width = width + 'px';
            this.containerCanvas.style.height = height + 'px';
            this.selectionCanvas.width = width;
            this.selectionCanvas.height = height;
            this.selectionCanvas.style.width = width + 'px';
            this.selectionCanvas.style.height = height + 'px';
            this.measureScrollbarWidth(element);
        }
    }
    getComputedWidth(element) {
        const style = getComputedStyle(element);
        if (style.display === 'block') {
            return parseFloat(style.width.replace('px', ''));
        }
        return 0;
    }
    /**
     * Inserts page in specified index.
     *
     * @private
     * @param {number} index - Specifes index to insert page
     * @param {Page} page - Page to insert.
     * @returns {void}
     */
    insertPage(index, page) {
        let isPageMoved = false;
        if (this.pages.indexOf(page) !== index) {
            isPageMoved = true;
        }
        if (this.pages.indexOf(page) > -1) {
            this.pages.splice(this.pages.indexOf(page), 1);
        }
        this.pages.splice(index, 0, page);
        let top = 20;
        if (index > 0) {
            top += this.pages[index - 1].boundingRectangle.bottom;
        }
        for (let i = index; i < this.pages.length; i++) {
            //Update bounding rectangle of next pages in collection.
            page = this.pages[i];
            if (isPageMoved) {
                page.currentPageNum = 1;
            }
            page.boundingRectangle = new Rect(page.boundingRectangle.x, top, page.boundingRectangle.width, page.boundingRectangle.height);
            top = page.boundingRectangle.bottom + 20;
        }
    }
    updateTextPositionForSelection(cursorPoint, tapCount) {
        let widget = this.getLineWidget(cursorPoint);
        if (!isNullOrUndefined(widget)) {
            this.selection.updateTextPosition(widget, cursorPoint);
        }
        if (tapCount > 1) {
            this.isMouseDown = false;
            this.useTouchSelectionMark = false;
            if (this.pages.length === 0) {
                return;
            }
            //Double tap/triple tap selection
            if (!isNullOrUndefined(this.currentPage) && !isNullOrUndefined(this.owner.selectionModule.start)) {
                if (tapCount % 2 === 0) {
                    this.owner.selectionModule.selectCurrentWord();
                }
                else if (!this.isDragStarted) {
                    if (this.owner.selectionModule.start.paragraph.isInsideTable) {
                        let cell = this.owner.selectionModule.start.paragraph.associatedCell;
                        if (!isNullOrUndefined(this.owner.selectionModule.getLastParagraph(cell)) && this.owner.selectionModule.getLastParagraph(cell).lastChild === this.owner.selectionModule.start.paragraph.lastChild) {
                            this.owner.selectionModule.selectCell();
                        }
                        else {
                            this.owner.selectionModule.selectParagraph();
                        }
                    }
                    else {
                        this.owner.selectionModule.selectParagraph();
                    }
                }
            }
        }
    }
    scrollToPosition(startPosition, endPosition, skipCursorUpdate, isBookmark) {
        if (this.skipScrollToPosition || this.isWebPrinting || (this.owner.editorModule && this.owner.editorModule.isRemoteAction)) {
            this.skipScrollToPosition = false;
            return;
        }
        if (this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizing
            || this.isMouseDownInFooterRegion || this.isRowOrCellResizing) {
            return;
        }
        let lineWidget = this.selection.getLineWidgetInternal(endPosition.currentWidget, endPosition.offset, true);
        if (isNullOrUndefined(lineWidget)) {
            return;
        }
        let top = this.selection.getTop(lineWidget);
        if (this.isMouseDown) {
            let prevLineWidget = this.selection.getLineWidgetInternal(endPosition.currentWidget, endPosition.offset, false);
            let prevTop = this.selection.getTop(prevLineWidget);
            if (prevLineWidget !== lineWidget && endPosition.location.y >= prevTop) {
                lineWidget = prevLineWidget;
            }
        }
        let height = lineWidget.height;
        //Gets current page.
        let endPage = this.selection.getPage(lineWidget.paragraph);
        this.currentPage = endPage;
        let x = 0;
        let y = 0;
        let horizontalWidth = 0;
        let isPageLayout = this.owner.viewer instanceof PageLayoutViewer;
        let pageLayout = this.owner.viewer;
        if (isNullOrUndefined(endPage)) {
            return;
        }
        let pageWidth = endPage.boundingRectangle.width;
        x = (this.visibleBounds.width - pageWidth * this.zoomFactor) / 2;
        if (x < 30) {
            x = 30;
        }
        y = endPage.boundingRectangle.y * this.zoomFactor + (this.pages.indexOf(endPage) + 1) * this.owner.viewer.pageGap * (1 - this.zoomFactor);
        let scrollTop = this.viewerContainer.scrollTop;
        let scrollLeft = this.viewerContainer.scrollLeft;
        let pageHeight = this.visibleBounds.height;
        let caretInfo = this.selection.updateCaretSize(this.owner.selectionModule.end, true);
        let topMargin = caretInfo.topMargin;
        let caretHeight = caretInfo.height;
        x += (endPosition.location.x) * this.zoomFactor;
        y += (endPosition.location.y + topMargin) * this.zoomFactor;
        if (!isBookmark) {
            //vertical scroll bar update
            if ((scrollTop + 20) > y) {
                this.viewerContainer.scrollTop = (y - 10);
            }
            else if (scrollTop + pageHeight < y + caretHeight) {
                if (this.owner.rulerHelper && this.owner.hRuler) {
                    y += this.owner.rulerHelper.getRulerSize(this.owner).height;
                }
                this.viewerContainer.scrollTop = y + caretHeight - pageHeight + 10;
            }
        }
        else {
            // As per MS Word behaviour, update vertical scroll bar using static value while navigate bookmark
            this.viewerContainer.scrollTop = y - 96;
        }
        if (!skipCursorUpdate) {
            this.selection.updateCaretToPage(startPosition, endPage);
        }
        let scrollBarWidth = this.viewerContainer.offsetWidth - this.viewerContainer.clientWidth;
        if (scrollLeft > x) {
            this.viewerContainer.scrollLeft = x - (this.pageContainer.offsetWidth / 100) * 20;
        }
        else if (scrollLeft + this.visibleBounds.width < x + scrollBarWidth) {
            let currentLeft = scrollLeft + (this.pageContainer.offsetWidth / 100) * 15 + scrollBarWidth;
            this.viewerContainer.scrollLeft = currentLeft;
            while (x < this.owner.viewer.containerWidth && currentLeft + this.visibleBounds.width < x + scrollBarWidth) {
                currentLeft += (this.pageContainer.offsetWidth / 100) * 15 + scrollBarWidth;
                this.viewerContainer.scrollLeft = currentLeft;
                if (this.viewerContainer.scrollLeft === 0) {
                    break;
                }
            }
        }
    }
    getLineWidget(cursorPoint) {
        return this.getLineWidgetInternal(cursorPoint, false);
    }
    getLineWidgetInternal(cursorPoint, isMouseDragged) {
        let widget = undefined;
        if (!isNullOrUndefined(this.currentPage)) {
            let childWidgets;
            if (this.owner.enableHeaderAndFooter) {
                let page = this.currentPage;
                let pageBottom = page.boundingRectangle.height;
                let headerHeight = Math.max((page.headerWidget.y + page.headerWidget.height), HelperMethods.convertPointToPixel(page.bodyWidgets[0].sectionFormat.topMargin)) * this.zoomFactor;
                let footerDistance = HelperMethods.convertPointToPixel(page.bodyWidgets[0].sectionFormat.footerDistance);
                let footerHeight = (page.boundingRectangle.height -
                    Math.max(page.footerWidget.height + footerDistance, footerDistance * 2));
                if (isMouseDragged) {
                    if (this.isBlockInHeader(this.selection.start.paragraph)) {
                        childWidgets = this.currentPage.headerWidget;
                    }
                    else {
                        childWidgets = this.currentPage.footerWidget;
                    }
                }
                else {
                    if (cursorPoint.y <= pageBottom && cursorPoint.y >= footerHeight) {
                        childWidgets = this.currentPage.footerWidget;
                    }
                    else if ((cursorPoint.y) >= 0 && (cursorPoint.y) <= headerHeight) {
                        childWidgets = this.currentPage.headerWidget;
                    }
                }
                if (isNullOrUndefined(childWidgets)) {
                    return undefined;
                }
                let shapeElementInfo = this.checkFloatingItems(childWidgets, cursorPoint, isMouseDragged);
                if (shapeElementInfo.isShapeSelected) {
                    let isGroupChildShape = false;
                    if (shapeElementInfo.isInShapeBorder) {
                        return shapeElementInfo.element.line;
                    }
                    if (shapeElementInfo.element instanceof ShapeElementBox) {
                        widget = this.selection.getLineWidgetBodyWidget(shapeElementInfo.element.textFrame, cursorPoint);
                    }
                    else if (shapeElementInfo.element instanceof GroupShapeElementBox) {
                        widget = this.getWidgetFromGroup(shapeElementInfo.element, cursorPoint);
                        if (!isNullOrUndefined(widget)) {
                            isGroupChildShape = true;
                        }
                        if (!isGroupChildShape) {
                            for (let i = 0; i < this.currentPage.bodyWidgets.length; i++) {
                                if (i == this.currentPage.bodyWidgets.length - 1) {
                                    widget = this.selection.getLineWidgetBodyWidget(bodyWidget, cursorPoint, true);
                                    if (!isNullOrUndefined(widget) && widget.paragraph.y <= cursorPoint.y
                                        && (widget.paragraph.y + widget.paragraph.height) >= cursorPoint.y) {
                                        this.isFootnoteWidget = false;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    return widget;
                }
                else {
                    return this.selection.getLineWidgetBodyWidget(childWidgets, cursorPoint);
                }
            }
            else {
                let shapeInfo = undefined;
                let behindShapeInfo = undefined;
                let isGroupChildShape = false;
                if (!isNullOrUndefined(this.currentPage.bodyWidgets)) {
                    for (var i = 0; i < this.currentPage.bodyWidgets.length; i++) {
                        var bodyWidget = this.currentPage.bodyWidgets[i];
                        shapeInfo = this.checkFloatingItems(bodyWidget, cursorPoint, isMouseDragged, false);
                        behindShapeInfo = this.checkFloatingItems(bodyWidget, cursorPoint, isMouseDragged, true);
                        if (shapeInfo.isShapeSelected || behindShapeInfo.isShapeSelected) {
                            break;
                        }
                    }
                }
                if (shapeInfo && shapeInfo.isShapeSelected && !this.isEmptyShape(shapeInfo)) {
                    if (shapeInfo.isInShapeBorder) {
                        return shapeInfo.element.line;
                    }
                    if (shapeInfo.element instanceof ShapeElementBox) {
                        widget = this.selection.getLineWidgetBodyWidget(shapeInfo.element.textFrame, cursorPoint);
                    }
                    else if (shapeInfo.element instanceof GroupShapeElementBox) {
                        widget = this.getWidgetFromGroup(shapeInfo.element, cursorPoint);
                        if (!isNullOrUndefined(widget)) {
                            isGroupChildShape = true;
                        }
                        if (!isGroupChildShape) {
                            for (let i = 0; i < this.currentPage.bodyWidgets.length; i++) {
                                if (i == this.currentPage.bodyWidgets.length - 1) {
                                    widget = this.selection.getLineWidgetBodyWidget(bodyWidget, cursorPoint, true);
                                    if (!isNullOrUndefined(widget) && widget.paragraph.y <= cursorPoint.y
                                        && (widget.paragraph.y + widget.paragraph.height) >= cursorPoint.y) {
                                        this.isFootnoteWidget = false;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                else if (isMouseDragged && this.isFootnoteWidget) {
                    if (this.selection.start.paragraph.bodyWidget.footNoteReference !== undefined && this.selection.start.paragraph.bodyWidget.containerWidget instanceof FootNoteWidget && this.selection.start.paragraph.bodyWidget.containerWidget.footNoteType === 'Footnote') {
                        return this.selection.getLineWidgetBodyWidget(this.currentPage.footnoteWidget, cursorPoint);
                    }
                    else if (this.selection.start.paragraph.bodyWidget.footNoteReference !== undefined &&
                        this.selection.start.paragraph.bodyWidget.containerWidget instanceof FootNoteWidget
                        && this.selection.start.paragraph.bodyWidget.containerWidget.footNoteType === 'Endnote') {
                        return this.selection.getLineWidgetBodyWidget(this.currentPage.endnoteWidget, cursorPoint);
                    }
                }
                else {
                    if (!isMouseDragged && this.currentPage.footnoteWidget && this.isInFootnoteWidget(this.currentPage.footnoteWidget, cursorPoint)) {
                        widget = this.selection.getLineWidgetBodyWidget(this.currentPage.footnoteWidget, cursorPoint);
                        if (widget) {
                            this.isFootnoteWidget = true;
                        }
                    }
                    else if (!isMouseDragged && this.currentPage.endnoteWidget &&
                        this.isInFootnoteWidget(this.currentPage.endnoteWidget, cursorPoint)) {
                        widget = this.selection.getLineWidgetBodyWidget(this.currentPage.endnoteWidget, cursorPoint);
                        if (widget) {
                            this.isFootnoteWidget = true;
                        }
                    }
                    else {
                        if (!isNullOrUndefined(this.currentPage.bodyWidgets)) {
                            for (let i = 0; i < this.currentPage.bodyWidgets.length; i++) {
                                let bodyWidget = this.currentPage.bodyWidgets[i];
                                if (i < this.currentPage.bodyWidgets.length - 1) {
                                    if (cursorPoint.x <= bodyWidget.x + bodyWidget.width) {
                                        //let isGetFirstChild: boolean = i === this.currentPage.bodyWidgets.length - 1;
                                        widget = this.selection.getLineWidgetBodyWidget(bodyWidget, cursorPoint, true);
                                        if (!isNullOrUndefined(widget) && widget.paragraph.y <= cursorPoint.y
                                            && (widget.paragraph.y + widget.paragraph.height) >= cursorPoint.y) {
                                            this.isFootnoteWidget = false;
                                            break;
                                        }
                                    }
                                }
                                if (cursorPoint.x > bodyWidget.x + bodyWidget.width && this.layout.getNextWidgetHeight(bodyWidget) >= cursorPoint.y && bodyWidget.y <= cursorPoint.y) {
                                    if (isNullOrUndefined(bodyWidget.nextRenderedWidget) || !(this.layout.getNextWidgetHeight(bodyWidget.nextRenderedWidget) >= cursorPoint.y && bodyWidget.nextRenderedWidget.y <= cursorPoint.y)) {
                                        widget = this.selection.getLineWidgetBodyWidget(bodyWidget, cursorPoint, true);
                                        if (!isNullOrUndefined(widget) && widget.paragraph.y <= cursorPoint.y
                                            && (widget.paragraph.y + widget.paragraph.height) >= cursorPoint.y) {
                                            this.isFootnoteWidget = false;
                                            break;
                                        }
                                    }
                                }
                                if (i == this.currentPage.bodyWidgets.length - 1) {
                                    widget = this.selection.getLineWidgetBodyWidget(bodyWidget, cursorPoint, true);
                                    if (!isNullOrUndefined(widget) && widget.paragraph.y <= cursorPoint.y
                                        && (widget.paragraph.y + widget.paragraph.height) >= cursorPoint.y) {
                                        this.isFootnoteWidget = false;
                                        break;
                                    }
                                }
                                if (cursorPoint.x < bodyWidget.x && i < this.currentPage.bodyWidgets.length - 1) {
                                    widget = this.selection.getLineWidgetBodyWidget(bodyWidget, cursorPoint, true);
                                    if (!isNullOrUndefined(widget) && widget.paragraph.y <= cursorPoint.y
                                        && (widget.paragraph.y + widget.paragraph.height) >= cursorPoint.y) {
                                        this.isFootnoteWidget = false;
                                        break;
                                    }
                                    else if (!isNullOrUndefined(widget) && i === this.currentPage.bodyWidgets.length - 1) {
                                        this.isFootnoteWidget = false;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    let inlineShapeInfo = this.checkInlineShapeItems(widget, cursorPoint, isMouseDragged);
                    if (inlineShapeInfo.isShapeSelected) {
                        if (inlineShapeInfo.isInShapeBorder) {
                            return inlineShapeInfo.element.line;
                        }
                        if (inlineShapeInfo.element instanceof ShapeElementBox) {
                            widget = this.selection.getLineWidgetBodyWidget(inlineShapeInfo.element.textFrame, cursorPoint);
                        }
                        else if (inlineShapeInfo.element instanceof GroupShapeElementBox) {
                            widget = this.getWidgetFromGroup(inlineShapeInfo.element, cursorPoint);
                        }
                    }
                    else if (!this.checkPointIsInLine(widget, cursorPoint) && behindShapeInfo.isShapeSelected) {
                        if (behindShapeInfo.isInShapeBorder) {
                            return behindShapeInfo.element.line;
                        }
                        if (behindShapeInfo.element instanceof ShapeElementBox) {
                            widget = this.selection.getLineWidgetBodyWidget(behindShapeInfo.element.textFrame, cursorPoint);
                        }
                    }
                }
            }
        }
        return widget;
    }
    checkInlineShapeItems(widget, cursorPoint, isMouseDragged) {
        let isInShape = false;
        let isInShapeBorder = false;
        let floatingElement;
        let selectionInShape = this.selection.isInShape;
        let isMouseDraggedInShape = isMouseDragged && selectionInShape;
        if (!isNullOrUndefined(widget) && widget.children.length > 0) {
            if (isMouseDraggedInShape) {
                let textFrame = this.owner.selectionModule.getCurrentTextFrame();
                if (textFrame) {
                    floatingElement = textFrame.containerShape;
                    isInShape = true;
                }
            }
            else {
                for (let i = 0; i < widget.children.length; i++) {
                    if (!((widget.children[i] instanceof ShapeElementBox || widget.children[i] instanceof GroupShapeElementBox) && widget.children[i].textWrappingStyle === 'Inline')) {
                        continue;
                    }
                    floatingElement = widget.children[i];
                    let marginTop = floatingElement.margin.top;
                    if (floatingElement.textWrappingStyle === 'Inline') {
                        marginTop = 0;
                    }
                    if (cursorPoint.x < floatingElement.x + floatingElement.margin.left + floatingElement.width &&
                        cursorPoint.x > floatingElement.x && cursorPoint.y < floatingElement.y + marginTop +
                        floatingElement.height && cursorPoint.y > floatingElement.y) {
                        isInShape = true;
                        if (this.isInShapeBorder(floatingElement, cursorPoint)) {
                            isInShapeBorder = true;
                        }
                        break;
                    }
                }
                if (isMouseDragged && !selectionInShape) {
                    isInShape = false;
                }
            }
        }
        return {
            'element': floatingElement,
            'caretPosition': cursorPoint,
            'isInShapeBorder': isInShapeBorder,
            'isShapeSelected': isInShape
        };
    }
    /**
     * @private
     */
    checkPointIsInLine(widget, cursorPoint) {
        if (!isNullOrUndefined(widget) && widget.children.length > 0) {
            let element;
            let left = widget.paragraph.x;
            let top = this.selection.getTop(widget);
            for (let i = widget.children.indexOf(widget.children[0]); i < widget.children.length; i++) {
                element = widget.children[i];
                if (element instanceof ShapeBase && element.textWrappingStyle !== 'Inline') {
                    continue;
                }
                if (cursorPoint.x < left + element.margin.left + element.width + element.padding.left
                    && cursorPoint.x > left && cursorPoint.y < top + widget.height && cursorPoint.y > top) {
                    return true;
                }
                left += element.margin.left + element.width + element.padding.left;
            }
        }
        else if (!isNullOrUndefined(widget) && widget.children.length === 0) {
            let left = widget.paragraph.x;
            let top = this.selection.getTop(widget);
            if (cursorPoint.x < left + widget.width && cursorPoint.x > left && cursorPoint.y < top + widget.height && cursorPoint.y > top) {
                return true;
            }
        }
        return false;
    }
    isInFootnoteWidget(footnoteWidget, point) {
        for (let i = 0; i < footnoteWidget.bodyWidgets.length; i++) {
            for (let j = 0; j < footnoteWidget.bodyWidgets[i].childWidgets.length; j++) {
                let childWidget = footnoteWidget.bodyWidgets[i].childWidgets[j];
                if (childWidget instanceof Widget && childWidget.y <= point.y
                    && (childWidget.y + childWidget.height) >= point.y) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * @private
     */
    checkFloatingItems(blockContainer, cursorPoint, isMouseDragged, isBehind, isInline) {
        let isInShape = false;
        let isInShapeBorder = false;
        let floatElement;
        let selectionInShape = this.selection.isInShape;
        let isMouseDraggedInShape = isMouseDragged && selectionInShape;
        if (blockContainer.floatingElements.length > 0) {
            let page = this.currentPage;
            /* eslint-disable */
            if (!isInline) {
                blockContainer.floatingElements.sort(function (a, b) {
                    if (a instanceof TableWidget || b instanceof TableWidget) {
                        return 0;
                    }
                    else {
                        return a.zOrderPosition - b.zOrderPosition;
                    }
                });
            }
            if (isMouseDraggedInShape) {
                let textFrame = this.owner.selectionModule.getCurrentTextFrame();
                if (textFrame) {
                    floatElement = textFrame.containerShape;
                    isInShape = true;
                }
            }
            else {
                for (let i = blockContainer.floatingElements.length - 1; i >= 0; i--) {
                    if (blockContainer.floatingElements[i] instanceof TableWidget
                        || (!isNullOrUndefined(isBehind) && isBehind ? blockContainer.floatingElements[i].textWrappingStyle !== 'Behind' : blockContainer.floatingElements[i].textWrappingStyle === 'Behind') || (isInline && blockContainer.floatingElements[i].textWrappingStyle !== 'Inline')) {
                        continue;
                    }
                    floatElement = blockContainer.floatingElements[i];
                    let marginTop = floatElement.margin.top;
                    if (floatElement.textWrappingStyle === 'Inline') {
                        marginTop = 0;
                    }
                    if (cursorPoint.x < floatElement.x + floatElement.margin.left + floatElement.width &&
                        cursorPoint.x > floatElement.x && cursorPoint.y < floatElement.y + marginTop +
                        floatElement.height && cursorPoint.y > floatElement.y) {
                        isInShape = true;
                        if (this.isInShapeBorder(floatElement, cursorPoint)) {
                            isInShapeBorder = true;
                        }
                        break;
                    }
                }
                if (isMouseDragged && !selectionInShape) {
                    isInShape = false;
                }
            }
        }
        return {
            'element': floatElement,
            'caretPosition': cursorPoint,
            'isShapeSelected': isInShape,
            'isInShapeBorder': isInShapeBorder
        };
    }
    isBlockInHeader(block) {
        while (!(block.containerWidget instanceof HeaderFooterWidget)) {
            if (!block.containerWidget) {
                return false;
            }
            block = block.containerWidget;
            if (block instanceof TextFrame) {
                block = block.containerShape.paragraph;
            }
        }
        return block.containerWidget.headerFooterType.indexOf('Header') !== -1;
    }
    clearSelectionHighlight() {
        let canClear = true;
        canClear = (!this.isControlPressed || !this.isMouseDown);
        // if (this.owner.selection.selectionRanges.length > 0 && canClear) {
        if (this.owner.selectionModule.clearSelectionHighlightInSelectedWidgets()) {
            this.selectionContext.clearRect(0, 0, this.selectionCanvas.width, this.selectionCanvas.height);
        }
        // } else if (!isNullOrUndefined(this.owner.selection.currentSelectionRange) && this.isMouseDown) {
        //     this.owner.selection.currentSelectionRange.clearSelectionHighlight();
        // }
        //this.renderVisiblePages();
    }
    /**
     * @private
     * @returns {void}
     */
    removeEmptyPages(skipEndLayout) {
        let scrollToLastPage = false;
        let isLayoutEndnote = false;
        let pageIndex = this.selection.startPage - 1;
        for (let j = 0; j < this.pages.length; j++) {
            let page = this.pages[j];
            for (let i = 0; i < page.bodyWidgets.length; i++) {
                if (page.bodyWidgets.length === 0 || page.bodyWidgets[i].childWidgets.length === 0) {
                    if (page.bodyWidgets.length >= 1) {
                        let startindex = page.bodyWidgets.indexOf(page.bodyWidgets[i]);
                        page.bodyWidgets.splice(startindex, 1);
                        i--;
                    }
                }
            }
            if (page.bodyWidgets.length <= 0) {
                if (j === this.pages.length - 1 && this.owner.viewer instanceof PageLayoutViewer && this.owner.viewer.visiblePages.indexOf(this.pages[j]) !== -1) {
                    scrollToLastPage = true;
                }
                if (!isNullOrUndefined(page.endnoteWidget) && page.endnoteWidget.bodyWidgets.length > 0) {
                    const endnote = page.endnoteWidget;
                    const previousPage = page.previousPage;
                    if (!isNullOrUndefined(previousPage)) {
                        if (isNullOrUndefined(previousPage.endnoteWidget)) {
                            previousPage.endnoteWidget = new FootNoteWidget();
                            previousPage.endnoteWidget.footNoteType = 'Endnote';
                            previousPage.endnoteWidget.page = previousPage;
                        }
                        for (let k = 0; k < endnote.bodyWidgets.length; k++) {
                            let bodyWidget = endnote.bodyWidgets[k];
                            let isCombined = false;
                            if (previousPage.endnoteWidget.bodyWidgets.length > 0) {
                                const lastBodyWidget = previousPage.endnoteWidget.bodyWidgets[previousPage.endnoteWidget.bodyWidgets.length - 1];
                                if (bodyWidget.index === lastBodyWidget.index && bodyWidget.footNoteReference === lastBodyWidget.footNoteReference) {
                                    lastBodyWidget.combineWidget(this.owner.viewer);
                                    endnote.bodyWidgets.splice(k, 1);
                                    isCombined = true;
                                }
                            }
                            if (!isCombined) {
                                endnote.bodyWidgets.splice(k, 1);
                                bodyWidget.index = previousPage.endnoteWidget.bodyWidgets.length;
                                previousPage.endnoteWidget.bodyWidgets.push(bodyWidget);
                                bodyWidget.containerWidget = previousPage.endnoteWidget;
                                bodyWidget.page = previousPage;
                            }
                            k--;
                        }
                        if (!isNullOrUndefined(page.endnoteWidget) && page.endnoteWidget.bodyWidgets.length === 0) {
                            page.endnoteWidget = undefined;
                        }
                        isLayoutEndnote = true;
                        scrollToLastPage = false;
                    }
                }
                if (this.pages.indexOf(page) !== -1 && !isNullOrUndefined(this.pages[j])) {
                    this.removePage(this.pages[j]);
                }
                j--;
            }
        }
        if (!isNullOrUndefined(this.pages[pageIndex])) {
            let page = this.pages[pageIndex];
            if (page.headerWidget) {
                page.headerWidget.page = page;
            }
            if (page.footerWidget) {
                page.footerWidget.page = page;
            }
        }
        if (isLayoutEndnote && !skipEndLayout) {
            this.layout.reLayoutEndnote();
        }
        if (scrollToLastPage) {
            this.scrollToBottom();
        }
    }
    /**
     * @private
     * @returns {void}
     */
    scrollToBottom() {
        if (this.selection.start.paragraph && this.selection.start.paragraph.bodyWidget && this.selection.start.paragraph.bodyWidget.page) {
            let page = this.selection.start.paragraph.bodyWidget.page;
            let containerHeight = this.visibleBounds.height;
            this.viewerContainer.scrollTop = page.boundingRectangle.bottom - containerHeight;
        }
    }
    getFieldResult(fieldBegin, page) {
        if (!isNullOrUndefined(page) && !isNullOrUndefined(this.selection) && !isNullOrUndefined(fieldBegin)) {
            let fieldCode = this.selection.getFieldCode(fieldBegin);
            let fieldCodes = fieldCode.split('\*');
            let fieldCategory = fieldCodes[0].replace(/[^\w\s]/gi, '').trim().toLowerCase();
            let fieldPattern = '';
            if (fieldCodes.length > 1) {
                if (fieldCodes[1] !== ' MERGEFORMAT') {
                    fieldPattern = fieldCodes[1].replace(/[^\w\s]/gi, '').trim();
                }
            }
            if (fieldPattern == '') {
                fieldPattern = page.bodyWidgets[0].sectionFormat.pageNumberStyle;
            }
            if (fieldCategory.indexOf(' ') !== -1) {
                fieldCategory = fieldCategory.split(' ')[0];
            }
            switch (fieldCategory) {
                case 'page':
                    if (page.bodyWidgets[0].sectionFormat.restartPageNumbering && page.sectionIndex !== 0) {
                        let currentSectionIndex = page.sectionIndex;
                        let previousPage = page.previousPage;
                        this.isRestartNumbering = true;
                        if (currentSectionIndex !== previousPage.sectionIndex && previousPage.bodyWidgets[previousPage.bodyWidgets.length - 1].sectionIndex !== currentSectionIndex) {
                            page.currentPageNum = (page.bodyWidgets[0].sectionFormat.pageStartingNumber);
                            return this.getFieldText(fieldPattern, page.currentPageNum);
                        }
                        if (previousPage.currentPageNum === 1 && currentSectionIndex !== previousPage.sectionIndex ||
                            (currentSectionIndex === previousPage.sectionIndex &&
                                previousPage.footerWidget.headerFooterType === 'FirstPageFooter')) {
                            previousPage.currentPageNum = (page.bodyWidgets[0].sectionFormat.pageStartingNumber);
                        }
                        page.currentPageNum = previousPage.currentPageNum + 1;
                        return this.getFieldText(fieldPattern, page.currentPageNum);
                    }
                    else if (page.bodyWidgets[0].sectionFormat.restartPageNumbering && page.sectionIndex === 0) {
                        page.currentPageNum = page.bodyWidgets[0].sectionFormat.pageStartingNumber + page.index;
                        return this.getFieldText(fieldPattern, page.currentPageNum);
                    }
                    let previousPage = page.previousPage;
                    let pageStartIndex = -1;
                    if (previousPage && page.sectionIndex !== previousPage.sectionIndex
                        && previousPage.bodyWidgets[0].sectionFormat.restartPageNumbering && previousPage.currentPageNum === 1) {
                        while (previousPage) {
                            if (!isNullOrUndefined(previousPage.previousPage) && previousPage.sectionIndex === previousPage.previousPage.sectionIndex) {
                                previousPage = previousPage.previousPage;
                                pageStartIndex = previousPage.index;
                            }
                            else {
                                break;
                            }
                        }
                    }
                    if (pageStartIndex >= 0 && page.previousPage.bodyWidgets[0].sectionFormat.pageStartingNumber + (page.previousPage.index - pageStartIndex) !== page.previousPage.currentPageNum) {
                        page.currentPageNum = page.index + 1;
                    }
                    else if (!isNullOrUndefined(page.previousPage) && ((page.previousPage.bodyWidgets[0].sectionFormat.restartPageNumbering && page.previousPage.currentPageNum !== 1)
                        || (this.isRestartNumbering && page.previousPage.currentPageNum !== 1))) {
                        if (page.previousPage.bodyWidgets[0].sectionFormat.restartPageNumbering) {
                            this.isRestartNumbering = true;
                        }
                        page.currentPageNum = page.previousPage.currentPageNum + 1;
                    }
                    else {
                        if (!isNullOrUndefined(previousPage)) {
                            // Traverse backwards to locate the correct anchor page for numbering.
                            while (previousPage.previousPage) {
                                //If the previous page currentPageNum is 1 and the previous page's page number is not restarted. 
                                if (previousPage && previousPage.currentPageNum === 1 && !previousPage.bodyWidgets[0].sectionFormat.restartPageNumbering) {
                                    previousPage = previousPage.previousPage;
                                }
                                //If the the current page's page number is restarted. But, the current page section format is equal to previous page section format.
                                else if (previousPage.bodyWidgets[0].sectionFormat.restartPageNumbering && previousPage.bodyWidgets[0].sectionFormat === previousPage.previousPage.bodyWidgets[0].sectionFormat) {
                                    previousPage = previousPage.previousPage;
                                }
                                else {
                                    break;
                                }
                            }
                            //If previousPage exists, the previous page's page number is restarted and its currentPageNum is 1. 
                            if (previousPage && previousPage.bodyWidgets[0].sectionFormat.restartPageNumbering && previousPage.currentPageNum === 1) {
                                page.currentPageNum = previousPage.bodyWidgets[0].sectionFormat.pageStartingNumber + (page.index - previousPage.index);
                            }
                            //If previousPage exists, the previous page's currentPageNumber is not equal to 1.  
                            else if (previousPage && previousPage.currentPageNum !== 1) {
                                page.currentPageNum = previousPage.currentPageNum + (page.index - previousPage.index);
                            }
                            else {
                                page.currentPageNum = page.index + 1;
                            }
                        }
                        else {
                            page.currentPageNum = page.index + 1;
                        }
                    }
                    return this.getFieldText(fieldPattern, page.currentPageNum);
                case 'numpages':
                    return this.getFieldText(fieldPattern, page.documentHelper.pages.length);
                case 'sectionpages':
                    let currentSectionIndex = page.sectionIndex;
                    let currentPageCount = 0;
                    for (let i = 0; i < page.documentHelper.pages.length; i++) {
                        if (page.documentHelper.pages[i].sectionIndex === currentSectionIndex) {
                            currentPageCount++;
                        }
                        else if (currentPageCount !== 0) {
                            break;
                        }
                    }
                    return this.getFieldText(fieldPattern, currentPageCount);
                default:
                    break;
            }
        }
        return '';
    }
    getFieldText(pattern, value) {
        switch (pattern) {
            case 'ALPHABETIC':
                return this.layout.getAsLetter(value).toUpperCase();
            case 'alphabetic':
                return this.layout.getAsLetter(value).toLowerCase();
            case 'roman':
                return this.layout.getAsRoman(value).toLowerCase();
            case 'ROMAN':
                return this.layout.getAsRoman(value).toUpperCase();
            case 'RomanUpper':
                return this.layout.getAsRoman(value).toUpperCase();
            case 'RomanLower':
                return this.layout.getAsRoman(value).toLowerCase();
            case 'LetterUpper':
                return this.layout.getAsLetter(value).toUpperCase();
            case 'LetterLower':
                return this.layout.getAsLetter(value).toLowerCase();
            default:
                return value.toString();
        }
    }
    /**
     * @private
     */
    isEmptyShape(shape) {
        let isEmpty = true;
        if (shape.element instanceof ImageElementBox) {
            return isEmpty;
        }
        if (shape.element instanceof GroupShapeElementBox) {
            var childShape = undefined;
            for (var j = 0; j < shape.element.childWidgets.length; j++) {
                var childShapeElement = shape.element.childWidgets[j];
                if ((shape.caretPosition.x < childShapeElement.x + childShapeElement.margin.left + childShapeElement.width &&
                    shape.caretPosition.x > childShapeElement.x && shape.caretPosition.y < childShapeElement.y + childShapeElement.margin.top +
                    childShapeElement.height && shape.caretPosition.y > childShapeElement.y)) {
                    childShape = childShapeElement;
                    break;
                }
            }
            if (childShape instanceof GroupShapeElementBox) {
                const nestedShapeInfo = { 'element': childShape, 'caretPosition': shape.caretPosition, 'isShapeSelected': shape.isShapeSelected, 'isInShapeBorder': shape.isInShapeBorder };
                return this.isEmptyShape(nestedShapeInfo);
            }
            if (isNullOrUndefined(childShape)) {
                return true;
            }
            if (shape.element.childWidgets.length === 0 || isNullOrUndefined(childShape.textFrame) || childShape.textFrame.childWidgets.length === 0) {
                return isEmpty;
            }
            else {
                return false;
            }
        }
        let textFrame = shape.element.textFrame;
        if (textFrame.childWidgets.length === 0) {
            return isEmpty;
        }
        else {
            return false;
        }
    }
    /**
     * Destroys the internal objects maintained for control.
     *
     * @returns {void}
     */
    destroy() {
        // Clear the timeouts from the previous document load before destroying the control
        if (Object.keys(this.scheduledTimeouts).length !== 0) {
            this.clearScheduledTimeouts(this.currentDocumentLoadId);
        }
        if (!isNullOrUndefined(this.owner)) {
            this.unWireEvent();
        }
        if (this.vRuler) {
            this.vRuler.childNodes.forEach((element) => {
                this.vRuler.removeChild(element);
                element = null;
            });
            this.vRuler.innerHTML = '';
            this.vRuler.remove();
            this.vRuler = null;
        }
        if (this.hRuler) {
            this.hRuler.childNodes.forEach((element) => {
                this.hRuler.removeChild(element);
                element = null;
            });
            this.hRuler.innerHTML = '';
            this.hRuler.remove();
            this.hRuler = null;
        }
        if (this.markIndicator) {
            this.markIndicator.remove();
        }
        if (this.styles) {
            this.styles.destroy();
            this.styles = undefined;
        }
        if (this.stylesMap) {
            this.stylesMap.destroy();
            this.stylesMap = undefined;
        }
        if (this.characterFormat) {
            this.characterFormat.destroy();
            this.characterFormat = undefined;
        }
        if (this.themeFontLanguage) {
            this.themeFontLanguage.destroy();
            this.themeFontLanguage = undefined;
        }
        if (this.paragraphFormat) {
            this.paragraphFormat.destroy();
            this.paragraphFormat = undefined;
        }
        if (this.pages && this.pages.length > 0) {
            for (let i = 0; i < this.pages.length; i++) {
                let page = this.pages[i];
                page.componentDestroy();
            }
            this.pages = [];
        }
        this.pages = undefined;
        if (this.lists && this.lists.length > 0) {
            for (let i = 0; i < this.lists.length; i++) {
                let list = this.lists[i];
                list.destroy();
            }
            this.lists = [];
        }
        this.lists = undefined;
        if (this.formFillPopup) {
            this.formFillPopup.destroy();
            this.formFillPopup = undefined;
        }
        if (this.contentDropDown) {
            this.contentDropDown.destroy();
            this.contentDropDown = undefined;
        }
        this.L10n = undefined;
        this.currentPage = undefined;
        this.selectionStartPageIn = undefined;
        this.selectionEndPageIn = undefined;
        this.fieldStacks = [];
        this.fieldStacks = undefined;
        this.splittedCellWidgets = [];
        this.splittedCellWidgets = undefined;
        this.fields = [];
        this.fields = undefined;
        this.abstractLists = [];
        this.abstractLists = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.renderedLists.destroy();
        }
        this.renderedLists = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.authors.destroy();
        }
        this.authors = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.revisionsInternal.destroy();
        }
        this.revisionsInternal = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.preDefinedStyles.destroy();
        }
        this.preDefinedStyles = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.bookmarks.destroy();
        }
        this.bookmarks = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.editRanges.destroy();
        }
        this.editRanges = undefined;
        if (!isNullOrUndefined(this.owner)) {
            this.customXmlData.destroy();
        }
        if (!isNullOrUndefined(this.owner)) {
            this.images.destroy();
        }
        if (!isNullOrUndefined(this.owner)) {
            this.fontSubstitutionTable.destroy();
        }
        this.fontSubstitutionTable = undefined;
        this.customXmlData = undefined;
        this.images = undefined;
        this.blockToShift = undefined;
        this.cachedPages = [];
        this.cachedPages = undefined;
        if (this.comments && this.comments.length > 0) {
            for (let i = 0; i < this.comments.length; i++) {
                let comment = this.comments[i];
                comment.destroy();
            }
            this.comments = [];
        }
        this.comments = undefined;
        this.compositionEnd = undefined;
        this.compositionStart = undefined;
        this.compositionUpdated = undefined;
        this.contentControlCollection = [];
        this.contentControlCollection = undefined;
        this.renderedLevelOverrides = [];
        this.renderedLevelOverrides = undefined;
        this.headersFooters = [];
        this.headersFooters = undefined;
        this.listParagraphs = [];
        this.listParagraphs = undefined;
        this.formFields = [];
        this.formFields = undefined;
        this.fieldCollection = [];
        this.fieldCollection = undefined;
        this.userCollection = [];
        this.userCollection = undefined;
        if (this.footnotes) {
            this.footnotes.componentDestroy();
            this.footnotes = undefined;
        }
        if (this.endnotes) {
            this.endnotes.componentDestroy();
            this.endnotes = undefined;
        }
        if (this.zoomModule) {
            this.zoomModule.destroy();
            this.zoomModule = undefined;
        }
        this.footnoteCollection = [];
        this.footnoteCollection = undefined;
        this.endnoteCollection = [];
        this.endnoteCollection = undefined;
        if (this.restrictEditingPane) {
            this.restrictEditingPane.destroy();
            this.restrictEditingPane = undefined;
        }
        if (this.layout) {
            this.layout.destroy();
        }
        this.layout = undefined;
        if (!isNullOrUndefined(this.render)) {
            this.render.destroy();
        }
        this.render = undefined;
        if (this.dialogInternal) {
            this.dialogInternal.destroy();
        }
        this.dialogInternal = undefined;
        if (this.dialogInternal2) {
            this.dialogInternal2.destroy();
            this.dialogInternal2 = undefined;
        }
        if (this.dialogInternal3) {
            this.dialogInternal3.destroy();
            this.dialogInternal3 = undefined;
        }
        if (this.dialogTarget1 && this.dialogTarget1.parentElement) {
            this.dialogTarget1.parentElement.removeChild(this.dialogTarget1);
        }
        this.dialogTarget1 = undefined;
        if (this.dialogTarget2 && this.dialogTarget2.parentElement) {
            this.dialogTarget2.parentElement.removeChild(this.dialogTarget2);
        }
        this.dialogTarget2 = undefined;
        if (this.dialogTarget3 && this.dialogTarget3.parentElement) {
            this.dialogTarget3.parentElement.removeChild(this.dialogTarget3);
        }
        this.dialogTarget3 = undefined;
        if (!isNullOrUndefined(this.touchStart)) {
            this.touchStart.innerHTML = '';
            if (!isNullOrUndefined(this.touchStart.parentElement)) {
                this.touchStart.parentElement.removeChild(this.touchStart);
            }
        }
        this.touchStart = undefined;
        if (this.textHelper) {
            this.textHelper.destroy();
        }
        this.textHelper = undefined;
        if (!isNullOrUndefined(this.touchEnd)) {
            this.touchEnd.innerHTML = '';
            if (!isNullOrUndefined(this.touchEnd.parentElement)) {
                this.touchEnd.parentElement.removeChild(this.touchEnd);
            }
        }
        this.touchEnd = undefined;
        if (!isNullOrUndefined(this.containerCanvasIn)) {
            this.containerCanvasIn.innerHTML = '';
            if (!isNullOrUndefined(this.containerCanvasIn.parentElement)) {
                this.containerCanvasIn.parentElement.removeChild(this.containerCanvasIn);
            }
        }
        this.containerCanvasIn = undefined;
        if (!isNullOrUndefined(this.selectionCanvasIn)) {
            this.selectionCanvasIn.innerHTML = '';
            if (!isNullOrUndefined(this.selectionCanvasIn.parentElement)) {
                this.selectionCanvasIn.parentElement.removeChild(this.selectionCanvasIn);
            }
        }
        this.selectionCanvasIn = undefined;
        if (!isNullOrUndefined(this.editableDiv)) {
            this.editableDiv.innerHTML = '';
            if (!isNullOrUndefined(this.editableDiv.parentElement)) {
                this.editableDiv.parentElement.removeChild(this.editableDiv);
            }
        }
        this.editableDiv = undefined;
        if (!isNullOrUndefined(this.pageContainer)) {
            this.pageContainer.innerHTML = '';
            if (!isNullOrUndefined(this.pageContainer.parentElement)) {
                this.pageContainer.parentElement.removeChild(this.pageContainer);
            }
        }
        this.pageContainer = undefined;
        if (!isNullOrUndefined(this.viewerContainer)) {
            this.viewerContainer.innerHTML = '';
            if (!isNullOrUndefined(this.viewerContainer.parentElement)) {
                this.viewerContainer.parentElement.removeChild(this.viewerContainer);
            }
        }
        if (!isNullOrUndefined(this.iframe)) {
            this.iframe.innerHTML = '';
            if (!isNullOrUndefined(this.iframe.parentElement)) {
                this.iframe.parentElement.removeChild(this.iframe);
            }
            this.iframe = undefined;
        }
        if (this.optionsPaneContainer) {
            this.optionsPaneContainer.innerHTML = '';
            if (!isNullOrUndefined(this.optionsPaneContainer.parentElement)) {
                this.optionsPaneContainer.parentElement.removeChild(this.optionsPaneContainer);
            }
        }
        this.optionsPaneContainer = undefined;
        this.visibleBoundsIn = undefined;
        this.mouseDownOffset = undefined;
        this.viewerContainer = undefined;
        this.currentPage = undefined;
        this.selectionStartPageIn = undefined;
        this.selectionEndPageIn = undefined;
        this.currentSelectedCommentInternal = undefined;
        this.currentSelectedRevisionInternal = undefined;
        this.owner = undefined;
        this.heightInfoCollection = undefined;
        this.isRestartNumbering = false;
        this.currentDocumentLoadId = 0;
    }
    /**
     * Un-Wires events and methods
     *
     * @returns {void}
     */
    unWireEvent() {
        this.viewerContainer.removeEventListener('scroll', this.scrollHandler);
        this.viewerContainer.removeEventListener('mousedown', this.onMouseDownInternal);
        this.viewerContainer.removeEventListener('mousemove', this.onMouseMoveInternal);
        if (!Browser.isDevice) {
            this.editableDiv.removeEventListener('keypress', this.onKeyPressInternal);
            if (Browser.info.name === 'chrome') {
                this.editableDiv.removeEventListener('textInput', this.onTextInput);
            }
        }
        else {
            this.editableDiv.removeEventListener('input', this.onTextInputInternal);
        }
        this.editableDiv.removeEventListener('paste', this.onPaste);
        this.viewerContainer.removeEventListener('contextmenu', this.onContextMenu);
        this.editableDiv.removeEventListener('blur', this.onFocusOut);
        this.editableDiv.removeEventListener('keydown', this.onKeyDownInternal);
        this.editableDiv.removeEventListener('keyup', this.onViewerKeyUpInternal);
        this.editableDiv.removeEventListener('compositionstart', this.compositionStart);
        this.editableDiv.removeEventListener('compositionupdate', this.compositionUpdated);
        this.editableDiv.removeEventListener('compositionend', this.compositionEnd);
        this.viewerContainer.removeEventListener('mouseup', this.onMouseUpInternal);
        if (!isNullOrUndefined(this.iframe)) {
            this.iframe.removeEventListener('load', this.onIframeLoad);
        }
        this.viewerContainer.removeEventListener('dblclick', this.onDoubleTap);
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('keyup', this.onKeyUpInternal);
        window.removeEventListener('mouseup', this.onImageResizer);
        window.removeEventListener('touchend', this.onImageResizer);
        window.removeEventListener('copy', this.onCopy);
        window.removeEventListener("mousemove", this.onWindowMouseMoveInternal);
        if (navigator !== undefined && navigator.userAgent.match('Firefox')) {
            this.viewerContainer.removeEventListener('DOMMouseScroll', this.zoomModule.onMouseWheelInternal);
        }
        this.viewerContainer.removeEventListener('mousewheel', this.zoomModule.onMouseWheelInternal);
    }
    updateCursor(event) {
        let hyperlinkField = undefined;
        let footnoteElement = undefined;
        let div = this.viewerContainer;
        let point = new Point(event.offsetX, event.offsetY);
        let touchPoint = this.owner.viewer.findFocusedPage(point, true);
        let widget = this.getLineWidget(touchPoint);
        let widgetInfo;
        let left;
        let top;
        let editor = !this.owner.isReadOnlyMode ? this.owner.editorModule : undefined;
        let isRowResize = editor ? editor.tableResize.isInRowResizerArea(touchPoint) : false;
        let isCellResize = editor ? editor.tableResize.isInCellResizerArea(touchPoint) : false;
        let floatItemInfo = this.selection.checkAllFloatingElements(widget, touchPoint);
        let resizePosition = '';
        if (this.owner.enableImageResizerMode) {
            let resizeObj = this.owner.imageResizerModule.getImagePoint(touchPoint);
            this.owner.imageResizerModule.selectedResizeElement = resizeObj.selectedElement;
            resizePosition = resizeObj.resizePosition;
        }
        let lineLeft = 0;
        let formField = undefined;
        let referenceField = undefined;
        let isInInline = this.checkPointIsInLine(widget, touchPoint);
        if (!isNullOrUndefined(widget)) {
            lineLeft = this.selection.getLineStartLeft(widget);
            hyperlinkField = this.selection.getHyperLinkFieldInCurrentSelection(widget, touchPoint);
            if (isNullOrUndefined(hyperlinkField)) {
                formField = this.selection.getHyperLinkFieldInCurrentSelection(widget, touchPoint, true);
            }
            if (!isNullOrUndefined(hyperlinkField)) {
                let code = this.selection.getFieldCode(hyperlinkField);
                if (code.toLowerCase().indexOf('ref ') === 0 && !code.match('\\h')) {
                    hyperlinkField = undefined;
                }
            }
            widgetInfo = this.selection.updateTextPositionIn(widget, undefined, 0, touchPoint, true);
            left = this.selection.getLeft(widget);
            top = this.selection.getTop(widget);
            if (isNullOrUndefined(hyperlinkField) && !isNullOrUndefined(formField) && this.isDocumentProtected &&
                this.protectionType === 'FormFieldsOnly' && !this.isFormFilling) {
                this.selection.setHyperlinkContentToToolTip(formField, widget, touchPoint.x, true);
            }
            else {
                this.selection.setHyperlinkContentToToolTip(hyperlinkField, widget, touchPoint.x, false);
            }
            if (formField) {
                let isInlineFormFillMode = (formField.formFieldData instanceof TextFormField) && formField.formFieldData.type === 'Text';
                if (this.owner.documentEditorSettings.formFieldSettings.formFillingMode === 'Inline' && isInlineFormFillMode) {
                    //Update text cursor in text form field.
                    formField = undefined;
                }
            }
            if (this.owner.enableLockAndEdit) {
                let isLocked = false;
                let block = widget.paragraph;
                if (block.isInsideTable) {
                    block = this.layout.getParentTable(block);
                }
                if (block.locked && block.lockedBy !== this.owner.currentUser) {
                    isLocked = true;
                }
                let sectionFormat = widget.paragraph.bodyWidget.sectionFormat;
                let pageWidth = sectionFormat.pageWidth - sectionFormat.rightMargin - sectionFormat.leftMargin;
                pageWidth = HelperMethods.convertPointToPixel(pageWidth) * this.zoomFactor;
                if (this.viewer instanceof WebLayoutViewer) {
                    pageWidth = (this.visibleBounds.width - (this.viewer.padding.right * 5)) / this.zoomFactor;
                }
                if (isLocked && touchPoint.x >= lineLeft && touchPoint.x < lineLeft + pageWidth) {
                    this.selection.setLockInfoTooptip(widget, touchPoint.x, block.lockedBy);
                }
                else {
                    this.selection.setLockInfoTooptip(undefined, touchPoint.x, '');
                }
            }
        }
        if (!isNullOrUndefined(widget)) {
            if (isNullOrUndefined(footnoteElement) && this.owner.layoutType == 'Pages') {
                footnoteElement = this.selection.getFootNoteElementInCurrentSelection(widget, touchPoint);
                if (footnoteElement instanceof FootnoteElementBox) {
                    this.selection.setFootnoteContentToToolTip(footnoteElement, widget, touchPoint.x);
                }
            }
        }
        let isCtrlkeyPressed = this.isIosDevice ? event.metaKey : event.ctrlKey;
        if ((!isNullOrUndefined(hyperlinkField) && (isCtrlkeyPressed &&
            this.owner.useCtrlClickToFollowHyperlink || !this.owner.useCtrlClickToFollowHyperlink)) || formField) {
            if (!isNullOrUndefined(formField)) {
                if (this.isFormFillProtectedMode) {
                    div.style.cursor = 'default';
                }
            }
            else {
                div.style.cursor = 'pointer';
            }
            return;
        }
        else if (touchPoint.x >= lineLeft &&
            event.offsetX < (this.visibleBounds.width - (this.visibleBounds.width - this.viewerContainer.clientWidth)) &&
            event.offsetY < (this.visibleBounds.height - (this.visibleBounds.height - this.viewerContainer.clientHeight))) {
            if (this.selection.isEmpty) {
                div.style.cursor = 'text';
            }
            else {
                div.style.cursor = this.selection.checkCursorIsInSelection(widget, touchPoint) ? 'default' : 'text';
            }
        }
        else {
            div.style.cursor = 'default';
        }
        if (!isNullOrUndefined(resizePosition) && resizePosition !== '') {
            if (!this.owner.imageResizerModule.isShapeResize || this.owner.imageResizerModule.isShapeResize && resizePosition !== 'move') {
                div.style.cursor = resizePosition;
            }
        }
        else if (!isNullOrUndefined(widgetInfo) && widgetInfo.isImageSelected && left < touchPoint.x && top < touchPoint.y &&
            left + widget.width > touchPoint.x && top + widget.height > touchPoint.y) {
            div.style.cursor = 'move';
        }
        if (isRowResize) {
            div.style.cursor = 'row-resize';
        }
        else if (isCellResize) {
            div.style.cursor = 'col-resize';
        }
        // currently we doesn't provide drag support for shapes, so we commented this line.
        // if (floatItemInfo.isInShapeBorder && !isInInline) {
        //     div.style.cursor = 'all-scroll';
        // }
    }
    /**
     * @private
     */
    updateDialogTabHeight(dialogElement, targetElement) {
        const header = dialogElement.getElementsByClassName('e-dlg-header-content')[0];
        const contentElement = dialogElement.getElementsByClassName('e-dlg-content')[0];
        const footer = dialogElement.getElementsByClassName('e-footer-content')[0];
        const contentStyle = getComputedStyle(contentElement);
        const dialogStyle = getComputedStyle(dialogElement);
        const paddingTop = parseInt(contentStyle.paddingTop, 10);
        const paddingBottom = parseInt(contentStyle.paddingBottom, 10);
        const paddingVertical = (isNaN(paddingTop) ? 0 : paddingTop) + (isNaN(paddingBottom) ? 0 : paddingBottom);
        const borderTop = parseInt(dialogStyle.borderTop, 10);
        const borderBottom = parseInt(dialogStyle.borderBottom, 10);
        const borderVertical = (isNaN(borderTop) ? 0 : borderTop) + (isNaN(borderBottom) ? 0 : borderBottom);
        const contentHeight = dialogElement.offsetHeight - (header.offsetHeight + footer.offsetHeight + paddingVertical + borderVertical);
        targetElement.style.height = contentHeight + 'px';
        const paddingLeft = parseInt(contentStyle.paddingLeft, 10);
        const paddingRight = parseInt(contentStyle.paddingRight, 10);
        const paddingHorizontal = (isNaN(paddingLeft) ? 0 : paddingLeft) + (isNaN(paddingRight) ? 0 : paddingRight);
        const borderLeft = parseInt(dialogStyle.borderLeft, 10);
        const borderRight = parseInt(dialogStyle.borderRight, 10);
        const borderHorizontal = (isNaN(borderLeft) ? 0 : borderLeft) + (isNaN(borderRight) ? 0 : borderRight);
        const contentWidth = dialogElement.offsetWidth - (paddingHorizontal + borderHorizontal);
        return contentWidth;
    }
    /**
     *
     * @private
     */
    canRenderBorder(paragraph) {
        let skipTopBorder = false;
        let skipBottomBorder = false;
        let isSameTopBorder;
        let isSameBottomBorder;
        let isSameLeftBorder;
        let isSameRightBorder;
        let previousBlock = paragraph.previousRenderedWidget;
        let nextBlock = paragraph.nextRenderedWidget;
        const previousSplitWidget = paragraph.previousSplitWidget;
        if (!isNullOrUndefined(previousBlock) && !isNullOrUndefined(previousSplitWidget) && previousBlock === previousSplitWidget) {
            skipTopBorder = true;
        }
        const nextSplitWidget = paragraph.nextSplitWidget;
        if (!isNullOrUndefined(nextBlock) && !isNullOrUndefined(nextSplitWidget) && nextBlock === nextSplitWidget) {
            skipBottomBorder = true;
        }
        if ((skipTopBorder && skipBottomBorder) ||
            (skipTopBorder && isNullOrUndefined(nextBlock)) ||
            (skipBottomBorder && isNullOrUndefined(previousBlock))) {
            return { skipTopBorder, skipBottomBorder };
        }
        let paragraphX = this.getParagraphLeftPosition(paragraph);
        let previousBlockX = 0;
        let nextBlockX = 0;
        if (!skipTopBorder && !isNullOrUndefined(previousBlock) && previousBlock instanceof ParagraphWidget) {
            previousBlockX = this.getParagraphLeftPosition(previousBlock);
        }
        if (!skipBottomBorder && !isNullOrUndefined(nextBlock) && nextBlock instanceof ParagraphWidget) {
            nextBlockX = this.getParagraphLeftPosition(nextBlock);
        }
        const topBorder = paragraph.paragraphFormat.borders.top;
        const bottomBorder = paragraph.paragraphFormat.borders.bottom;
        const leftBorder = paragraph.paragraphFormat.borders.left;
        const rightBorder = paragraph.paragraphFormat.borders.right;
        if (!skipTopBorder && !isNullOrUndefined(previousBlock) && previousBlock instanceof ParagraphWidget && paragraphX === previousBlockX) {
            isSameTopBorder = this.checkEqualBorder(topBorder, previousBlock.paragraphFormat.borders.top);
            isSameBottomBorder = this.checkEqualBorder(bottomBorder, previousBlock.paragraphFormat.borders.bottom);
            isSameLeftBorder = this.checkEqualBorder(leftBorder, previousBlock.paragraphFormat.borders.left);
            isSameRightBorder = this.checkEqualBorder(rightBorder, previousBlock.paragraphFormat.borders.right);
            const horizontalBorder = previousBlock.paragraphFormat.borders.horizontal;
            if (isSameTopBorder && isSameBottomBorder && isSameLeftBorder && isSameRightBorder
                && !isNullOrUndefined(horizontalBorder) && horizontalBorder.lineStyle === 'None') {
                skipTopBorder = true;
            }
        }
        if (!skipBottomBorder && !isNullOrUndefined(nextBlock) && nextBlock instanceof ParagraphWidget && (paragraphX === nextBlockX || (this.owner.documentHelper.layout.isInitialLoad && this.skipBottomBorder(paragraph, nextBlock)))) {
            isSameTopBorder = this.checkEqualBorder(topBorder, nextBlock.paragraphFormat.borders.top);
            isSameBottomBorder = this.checkEqualBorder(bottomBorder, nextBlock.paragraphFormat.borders.bottom);
            isSameLeftBorder = this.checkEqualBorder(leftBorder, nextBlock.paragraphFormat.borders.left);
            isSameRightBorder = this.checkEqualBorder(rightBorder, nextBlock.paragraphFormat.borders.right);
            if (isSameBottomBorder && isSameTopBorder && isSameLeftBorder && isSameRightBorder) {
                skipBottomBorder = true;
            }
        }
        return {
            'skipTopBorder': skipTopBorder,
            'skipBottomBorder': skipBottomBorder
        };
    }
    checkEqualBorder(source, dest) {
        if (!isNullOrUndefined(source) && !isNullOrUndefined(dest)) {
            return source.isEqualFormat(dest);
        }
        else {
            if (isNullOrUndefined(source) && isNullOrUndefined(dest)) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    /**
    * @private
    */
    getParagraphLeftPosition(paragraphWidget) {
        let hangingIndent = 0;
        let startX = 0;
        const firstLineIndent = paragraphWidget.paragraphFormat.firstLineIndent;
        if (firstLineIndent < 0) {
            hangingIndent = HelperMethods.convertPointToPixel(Math.abs(firstLineIndent));
            hangingIndent = parseFloat(hangingIndent.toFixed(5));
        }
        const textAlignment = paragraphWidget.paragraphFormat.textAlignment;
        if (paragraphWidget.isEmpty() && ((textAlignment !== 'Left' && textAlignment !== 'Justify')
            || (textAlignment === 'Justify' && paragraphWidget.paragraphFormat.bidi))) {
            startX = paragraphWidget.clientX > hangingIndent ? paragraphWidget.clientX - hangingIndent : paragraphWidget.clientX;
            return startX;
        }
        else {
            startX = paragraphWidget.x > hangingIndent ? paragraphWidget.x - hangingIndent : paragraphWidget.x;
            return startX;
        }
    }
    /**
  * @private
  */
    skipBottomBorder(paragraph, nextWidget) {
        let currentIndent = 0;
        let previousIndent = 0;
        if (paragraph.paragraphFormat.leftIndent === nextWidget.paragraphFormat.leftIndent) {
            return true;
        }
        else {
            currentIndent = paragraph.paragraphFormat.firstLineIndent < 0 ? Math.abs(paragraph.paragraphFormat.firstLineIndent) : 0;
            previousIndent = nextWidget.paragraphFormat.firstLineIndent < 0 ? Math.abs(nextWidget.paragraphFormat.firstLineIndent) : 0;
            currentIndent = paragraph.paragraphFormat.leftIndent > currentIndent ? paragraph.paragraphFormat.leftIndent - currentIndent : 0;
            previousIndent = nextWidget.paragraphFormat.leftIndent > previousIndent ? nextWidget.paragraphFormat.leftIndent - previousIndent : 0;
            if (currentIndent === previousIndent) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    /**
     * @private
     */
    isPageInVisibleBound(page, pageTop) {
        let height = this.visibleBounds.height;
        let vertical = this.viewerContainer.scrollTop;
        let pageH = page.boundingRectangle.height * this.zoomFactor;
        let isTopFit = pageTop >= vertical && pageTop <= vertical + height;
        let isBottomFit = pageTop + pageH >= vertical && pageTop + pageH <= vertical + height;
        let isMiddleFit = pageTop <= vertical && pageTop + pageH >= vertical + height;
        return isTopFit || isBottomFit || isMiddleFit;
    }
    /**
     * Get first paragraph in cell
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getFirstParagraphInCell(cell) {
        const firstBlock = cell.childWidgets[0];
        if (firstBlock instanceof ParagraphWidget) {
            return firstBlock;
        }
        else {
            return this.getFirstParagraphInFirstCell(firstBlock);
        }
    }
    /**
     * Get first paragraph in first cell
     *
     * @private
     * @returns {TableWidget}
     */
    getFirstParagraphInFirstCell(table) {
        if (!isNullOrUndefined(table.childWidgets) && table.childWidgets.length > 0) {
            const firstRow = table.childWidgets[0];
            const cell = firstRow.childWidgets[0];
            const block = cell.childWidgets[0];
            return this.getFirstParagraphBlock(block);
        }
        return undefined;
    }
    /**
     * Get last paragraph in last cell
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getLastParagraphInLastCell(table) {
        if (!isNullOrUndefined(table.childWidgets) && table.childWidgets.length > 0) {
            const lastrow = table.lastChild;
            const lastcell = lastrow.lastChild;
            const lastBlock = lastcell.lastChild;
            return this.getLastParagraphBlock(lastBlock);
        }
        return undefined;
    }
    /**
     * Get first paragraph in block
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getFirstParagraphBlock(block) {
        if (block instanceof ParagraphWidget) {
            return block;
        }
        else if (block instanceof TableWidget) {
            return this.getFirstParagraphInFirstCell(block);
        }
        return undefined;
    }
    /**
     * Get last paragraph in block
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getLastParagraphBlock(block) {
        if (block instanceof ParagraphWidget) {
            return block;
        }
        else if (block instanceof TableWidget) {
            return this.getLastParagraphInLastCell(block);
        }
        return undefined;
    }
    /**
     * Get last paragraph in first row
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getLastParagraphInFirstRow(table) {
        if (table.childWidgets.length > 0) {
            const row = table.firstChild;
            const lastcell = row.lastChild;
            const lastBlock = lastcell.lastChild;
            return this.getLastParagraphBlock(lastBlock);
        }
        return undefined;
    }
    /**
     * Get first paragraph in last row
     *
     * @private
     */
    getFirstParagraphInLastRow(table) {
        if (table.childWidgets.length > 0) {
            const lastRow = table.childWidgets[table.childWidgets.length - 1];
            const lastCell = lastRow.childWidgets[0];
            const lastBlock = lastCell.childWidgets[0];
            return this.getFirstParagraphBlock(lastBlock);
        }
        return undefined;
    }
    /**
     * Add the given WStyle Object ot stylesMap Dictionary
     *
     * @private
     */
    /* eslint-disable  */
    addToStylesMap(style) {
        const returnStyle = {};
        const returnStyleObject = {};
        const paraIcon = 'e-list-icon e-de-listview-icon e-de-e-paragraph-style-mark e-icons';
        const charIcon = 'e-list-icon e-de-listview-icon e-de-e-character-style-mark e-icons';
        const linkedIcon = 'e-list-icon e-de-listview-icon e-de-e-linked-style-mark e-icons';
        // StyleName for the dropDownItem
        if (!isNullOrUndefined(style)) {
            const styleName = this.owner ? this.L10n.getConstant(style.name) : style.name;
            returnStyle.StyleName = (styleName === '') ? style.name : styleName;
            if (style.type == "Paragraph") {
                returnStyleObject.paragraphFormat = {};
                HelperMethods.writeParagraphFormat(returnStyleObject.paragraphFormat, true, style.paragraphFormat);
            }
            returnStyleObject.characterFormat = {};
            HelperMethods.writeCharacterFormat(returnStyleObject.characterFormat, true, style.characterFormat);
            // CSS Style for dropDownItem
            returnStyle.Style = this.parseStyle(JSON.stringify(returnStyleObject));
            // Setting type for segregating and adding iconcss
            if (!isNullOrUndefined(style.type)) {
                returnStyle.type = style.type;
                if (returnStyle.type == "Paragraph" && !isNullOrUndefined(style.link)) {
                    returnStyle.type = "Linked";
                }
            }
            // Adding IconCss to the dropDownItem
            if (returnStyle.type == "Paragraph") {
                returnStyle.IconClass = paraIcon;
            }
            else if (returnStyle.type == "Character") {
                returnStyle.IconClass = charIcon;
            }
            else {
                returnStyle.IconClass = linkedIcon;
            }
            if (this.stylesMap.get(returnStyle.type)) {
                this.stylesMap.get(returnStyle.type).push(returnStyle);
            }
            else {
                this.stylesMap.add(returnStyle.type, [returnStyle]);
            }
        }
    }
    parseStyle(style) {
        let domStyle = '';
        const styleObj = JSON.parse(style);
        let textDecoration = '';
        if (!isNullOrUndefined(styleObj.characterFormat.baselineAlignment) && styleObj.characterFormat.baselineAlignment !== 'Normal') {
            let vAlign = '';
            switch (styleObj.characterFormat.baselineAlignment) {
                case 'Superscript':
                    vAlign = 'super';
                    break;
                case 'Subscript':
                    vAlign = 'sub';
                    break;
            }
            if (vAlign.length > 1) {
                domStyle += 'vertical-align:' + vAlign + ';';
            }
        }
        if (!isNullOrUndefined(styleObj.characterFormat.underline) && styleObj.characterFormat.underline !== 'None') {
            textDecoration += 'underline ';
        }
        if (!isNullOrUndefined(styleObj.characterFormat.strikethrough) && styleObj.characterFormat.strikethrough !== 'None') {
            textDecoration += 'line-through ';
        }
        if (!isNullOrUndefined(styleObj.characterFormat.fontSize)) {
            domStyle += 'font-size:' + styleObj.characterFormat.fontSize + 'px;';
        }
        if (!isNullOrUndefined(styleObj.characterFormat.fontFamily)) {
            domStyle += 'font-family:' + styleObj.characterFormat.fontFamily + ';';
        }
        if (!isNullOrUndefined(styleObj.characterFormat.bold) && styleObj.characterFormat.bold) {
            domStyle += 'font-weight:bold;';
        }
        if (!isNullOrUndefined(styleObj.characterFormat.italic) && styleObj.characterFormat.italic) {
            domStyle += 'font-style:italic;';
        }
        // if (!isNullOrUndefined(styleObj.characterFormat.fontColor)) {
        //     domStyle += 'color: ' + styleObj.characterFormat.fontColor + ';';
        // }
        if (textDecoration.length > 1) {
            domStyle += 'text-decoration:' + textDecoration + ';';
        }
        return domStyle;
    }
    /**
     * Get next valid element
     *
     * @private
     */
    getNextValidElement(inline) {
        let nextValidInline = undefined;
        if (inline instanceof BookmarkElementBox && inline.bookmarkType === 1) {
            return inline;
        }
        while (inline instanceof FieldElementBox) {
            if (inline.fieldType === 0 && !isNullOrUndefined(inline.fieldEnd)) {
                return isNullOrUndefined(nextValidInline) ? inline : nextValidInline;
            }
            else if (inline.fieldType === 1 && !isNullOrUndefined(inline.fieldBegin)) {
                nextValidInline = inline;
            }
            inline = inline.nextNode;
        }
        return (isNullOrUndefined(nextValidInline) ? inline : nextValidInline);
    }
    /**
     * @private
     */
    getNextValidElementForField(firstInline) {
        if (firstInline instanceof FieldElementBox && firstInline.fieldType === 0
            && HelperMethods.isLinkedFieldCharacter(firstInline)) {
            const fieldBegin = firstInline;
            if (isNullOrUndefined(fieldBegin.fieldSeparator)) {
                firstInline = fieldBegin.fieldEnd;
            }
            else {
                firstInline = fieldBegin.fieldSeparator;
            }
        }
        let nextValidInline = undefined;
        if (!isNullOrUndefined(firstInline.nextNode)) {
            nextValidInline = this.getNextValidElement(firstInline.nextNode);
        }
        return nextValidInline;
    }
    /**
     * @private
     */
    combineSection() {
        let sections = [];
        let nextSection = this.pages[0].bodyWidgets[0];
        if (!isNullOrUndefined(this.owner.selectionModule)) {
            this.removeEmptyPages(true);
        }
        do {
            nextSection = this.combineSectionChild(nextSection, sections, false);
        } while (nextSection);
        for (let j = 0; j < this.pages.length; j++) {
            this.pages[j].destroy();
            j--;
        }
        return sections;
    }
    /**
     * @private
     */
    combineSectionChild(bodyWidget, sections, destoryPage) {
        let previousBodyWidget = bodyWidget;
        let temp = new BodyWidget();
        let emptyBody = false;
        temp.sectionFormat = bodyWidget.sectionFormat;
        temp.index = previousBodyWidget.index;
        do {
            emptyBody = false;
            previousBodyWidget = bodyWidget;
            if (bodyWidget.lastChild) {
                bodyWidget.lastChild.combineWidget(this.owner.viewer);
                if (this.layout.isMultiColumnDoc) {
                    this.removeEmptyPages();
                }
            }
            bodyWidget = bodyWidget.nextRenderedWidget;
            for (let j = 0; j < previousBodyWidget.childWidgets.length; j++) {
                let block = previousBodyWidget.childWidgets[j];
                if (block instanceof TableWidget) {
                    this.layout.clearTableWidget(block, true, true, true);
                }
                else {
                    block.x = 0;
                    block.y = 0;
                    block.width = 0;
                    block.height = 0;
                }
                temp.childWidgets.push(block);
                previousBodyWidget.childWidgets.splice(j, 1);
                j--;
                block.containerWidget = temp;
            }
            for (let i = 0; i < previousBodyWidget.page.bodyWidgets.length; i++) {
                if (previousBodyWidget.page.bodyWidgets[i].childWidgets.length === 0) {
                    emptyBody = true;
                }
                else {
                    emptyBody = false;
                    break;
                }
            }
            if (emptyBody && destoryPage) {
                previousBodyWidget.page.destroy();
            }
            // this.documentHelper.pages.splice(previousBodyWidget.page.index, 1);
        } while (bodyWidget && previousBodyWidget.index === bodyWidget.index);
        sections.push(temp);
        return bodyWidget;
    }
}
/**
 * @private
 */
export class LayoutViewer {
    constructor(owner) {
        /**
         * @private
         */
        this.visiblePages = [];
        /**
         * @private
         */
        this.padding = new Padding(10, 10, 30, 10);
        /**
         * @private
         */
        this.textWrap = true;
        /**
         * @private
         */
        this.pageFitTypeIn = 'None';
        /**
         * @private
         */
        this.containerTop = 0;
        /**
         * @private
         */
        this.containerWidth = 0;
        /**
         * @private
         */
        this.containerLeft = 0;
        /**
         * @private
         */
        this.zoomType = 'None';
        this.owner = owner;
        this.columnLayoutArea = new ColumnLayout(this);
    }
    get documentHelper() {
        return this.owner.documentHelper;
    }
    /**
     * Gets or sets page fit type.
     * @private
     */
    get pageFitType() {
        return this.pageFitTypeIn;
    }
    set pageFitType(value) {
        this.pageFitTypeIn = value;
        this.onPageFitTypeChanged(this.pageFitTypeIn);
    }
    updateClientArea(bodyWidget, page, isReLayout) {
        let sectionFormat;
        if (!isNullOrUndefined(bodyWidget)) {
            sectionFormat = bodyWidget.sectionFormat;
            this.columnLayoutArea.setColumns(sectionFormat);
        }
        let width = 0;
        let height = 0;
        if (this instanceof WebLayoutViewer) {
            let top = 0;
            width = (this.documentHelper.visibleBounds.width - (this.padding.right * 4) - (this.padding.left * 2)) / this.documentHelper.zoomFactor;
            if (width < 0) {
                width = 0;
            }
            height = Number.POSITIVE_INFINITY;
            this.clientArea = new Rect(this.padding.left / this.documentHelper.zoomFactor, top, width, height);
            this.clientActiveArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
        }
        else {
            let top = 0;
            let headerDistance = 48;
            let footerDistance = 48;
            let pageHeight = HelperMethods.convertPointToPixel(sectionFormat.pageHeight);
            let bottomMargin = HelperMethods.convertPointToPixel(sectionFormat.bottomMargin);
            if (!isNullOrUndefined(sectionFormat)) {
                top = HelperMethods.convertPointToPixel(sectionFormat.topMargin);
                headerDistance = HelperMethods.convertPointToPixel(sectionFormat.headerDistance);
                footerDistance = HelperMethods.convertPointToPixel(sectionFormat.footerDistance);
            }
            let isEmptyWidget = false;
            if (!isNullOrUndefined(page.headerWidget)) {
                isEmptyWidget = page.headerWidget.isEmpty;
                if (top >= 0) {
                    if (!isEmptyWidget || isEmptyWidget && this.owner.enableHeaderAndFooter) {
                        // For Word 2013, header can able to placed beyond 40% of page height.
                        if (this.documentHelper.compatibilityMode === 'Word2013') {
                            top = Math.max(headerDistance + page.headerWidget.height, top);
                        }
                        else {
                            top = Math.min(Math.max(headerDistance + page.headerWidget.height, top), pageHeight / 100 * 40);
                        }
                    }
                }
                else {
                    top = Math.abs(top);
                }
            }
            let bottom = 0.667 + bottomMargin;
            if (!isNullOrUndefined(page.footerWidget)) {
                isEmptyWidget = page.footerWidget.isEmpty;
                let footnoteHeight = !isNullOrUndefined(page.footnoteWidget) ? page.footnoteWidget.height : 0;
                footnoteHeight = Math.min(footnoteHeight, ((pageHeight - top - bottom) / 100 * 90));
                if (bottom >= 0) {
                    if (!isEmptyWidget || isEmptyWidget && this.owner.enableHeaderAndFooter) {
                        bottom = 0.667 + Math.min(pageHeight / 100 * 40, Math.max(footerDistance + page.footerWidget.height, bottomMargin));
                    }
                }
                else {
                    bottom = Math.abs(bottom);
                }
                bottom += footnoteHeight;
            }
            if (!isNullOrUndefined(sectionFormat)) {
                width = HelperMethods.convertPointToPixel(sectionFormat.pageWidth - sectionFormat.leftMargin - sectionFormat.rightMargin);
                height = pageHeight - top - bottom;
            }
            if (width < 0) {
                width = 0;
            }
            let clientArea = new Rect(HelperMethods.convertPointToPixel(sectionFormat.leftMargin), top, width, pageHeight - top - bottom);
            if (page.footnoteWidget && isReLayout && !this.documentHelper.owner.editorModule.isFootNote) {
                if (page.footnoteWidget.y !== 0 && this.clientArea.y + this.clientArea.height > page.footnoteWidget.y) {
                    let sub = (this.clientArea.y + this.clientArea.height - page.footnoteWidget.y);
                    this.clientArea.height -= sub / 2;
                }
            }
            if (bodyWidget.page.bodyWidgets[0].columnIndex !== 0) {
                this.owner.editorModule.updateColumnIndex(bodyWidget, false);
            }
            this.setClientArea(bodyWidget, clientArea);
            this.clientActiveArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
        }
    }
    setClientArea(bodyWidget, clientArea) {
        this.clientArea = this.columnLayoutArea.getColumnBoundsByBodyWidget(bodyWidget, clientArea);
        bodyWidget.x = this.clientArea.x;
        bodyWidget.width = this.clientArea.width;
    }
    updateClientAreaTopOrLeft(tableWidget, beforeLayout) {
        if (beforeLayout) {
            this.clientActiveArea.y = this.clientActiveArea.y + tableWidget.topBorderWidth;
            this.clientActiveArea.x = this.clientActiveArea.x + tableWidget.leftBorderWidth;
        }
    }
    updateClientAreaForTable(tableWidget) {
        this.clientActiveArea.x = this.clientArea.x = tableWidget.x;
        this.clientActiveArea.width = this.clientArea.width = tableWidget.width;
    }
    updateClientAreaForRow(row, beforeLayout) {
        let tableWidget = row.ownerTable;
        if (beforeLayout) {
        }
        else {
            this.clientActiveArea.x = this.clientArea.x = tableWidget.x;
            this.clientActiveArea.width = this.clientArea.width = tableWidget.width;
            this.clientArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
            this.clientActiveArea = new Rect(this.clientActiveArea.x, this.clientActiveArea.y, this.clientActiveArea.width, this.clientActiveArea.height);
        }
    }
    updateClientAreaForCell(cell, beforeLayout) {
        let rowWidget = cell.ownerRow;
        let cellWidget = cell;
        if (beforeLayout) {
            this.clientActiveArea.x = this.clientArea.x = cellWidget.x;
            this.clientActiveArea.y = cellWidget.y;
            this.clientActiveArea.width = this.clientArea.width = cellWidget.width > 0 ? cellWidget.width : 0;
            if (this instanceof PageLayoutViewer) {
                this.clientActiveArea.height = Number.POSITIVE_INFINITY;
            }
            this.clientArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
            this.clientActiveArea = new Rect(this.clientActiveArea.x, this.clientActiveArea.y, this.clientActiveArea.width, this.clientActiveArea.height);
        }
        else {
            this.clientActiveArea.x = this.clientArea.x = cellWidget.x + cellWidget.width + cellWidget.margin.right;
            if (rowWidget.x + rowWidget.width - this.clientArea.x < 0) {
                this.clientActiveArea.width = this.clientArea.width = 0;
            }
            else {
                this.clientActiveArea.width = this.clientArea.width = rowWidget.x + rowWidget.width - this.clientArea.x;
            }
            this.clientActiveArea.y = cellWidget.y - cellWidget.margin.top - HelperMethods.convertPointToPixel(cell.ownerTable.tableFormat.cellSpacing);
            if (!cell.ownerTable.isInsideTable) {
                this.clientActiveArea.height = this.clientArea.bottom - rowWidget.y > 0 ? this.clientArea.bottom - rowWidget.y : 0;
                if (!cell.ownerTable.wrapTextAround && this.documentHelper.layout.existFootnoteHeight > 0) {
                    let updateHeight = this.clientActiveArea.height - this.documentHelper.layout.existFootnoteHeight;
                    this.clientActiveArea.height = updateHeight < 0 ? 0 : updateHeight;
                }
            }
            this.clientArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
            this.clientActiveArea = new Rect(this.clientActiveArea.x, this.clientActiveArea.y, this.clientActiveArea.width, this.clientActiveArea.height);
        }
    }
    updateClientAreaForTextBoxShape(textBox, beforeLayout, shiftNextWidget) {
        if (textBox.textWrappingStyle === 'Inline' && !shiftNextWidget && isNullOrUndefined(textBox.containerShape)) {
            textBox.y = this.clientActiveArea.y;
            textBox.x = this.clientActiveArea.x;
        }
        if (beforeLayout) {
            let marginLeft = textBox.textFrame.marginLeft;
            let marginRight = textBox.textFrame.marginRight;
            let marginTop = textBox.textFrame.marginTop;
            let marginBottom = textBox.textFrame.marginBottom;
            let width = textBox.width;
            let height = Number.POSITIVE_INFINITY;
            this.clientArea = new Rect(textBox.x + marginLeft, textBox.y + marginTop, width - marginLeft - marginRight, height - marginTop - marginBottom);
            this.clientActiveArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
        }
    }
    updateClientAreaByWidgetFootNote(widget) {
        this.clientArea.x = widget.x;
        this.clientArea.y = widget.y;
        this.clientActiveArea.x = widget.x;
        this.clientActiveArea.y = widget.y;
    }
    /**
     * @private
     */
    updateClientAreaForTextWrap(area) {
        this.clientActiveArea = new Rect(area.x, area.y, area.width, area.height);
    }
    updateBoundsBasedOnTextWrap(bottom) {
        let diff = bottom - this.clientActiveArea.y;
        this.clientActiveArea.y = bottom;
        this.clientActiveArea.height = this.clientActiveArea.height - diff;
    }
    updateBoundsBasedOnTextWrapTable(bottom) {
        let diff = bottom - this.clientArea.y;
        this.clientArea.y = bottom;
        this.clientArea.height = this.clientArea.height - diff;
        this.clientActiveArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
    }
    updateClientAreaByWidget(widget) {
        this.clientArea.x = widget.x;
        this.clientArea.y = widget.y;
        this.clientActiveArea.x = widget.x;
        this.clientActiveArea.y = widget.y;
    }
    updateClientAreaLocation(widget, area) {
        widget.x = area.x;
        widget.y = area.y;
        widget.width = area.width;
    }
    updateClientAreaForBlock(block, beforeLayout, tableCollection, updateYPosition, updateXPosition) {
        let leftIndent = HelperMethods.convertPointToPixel(block.leftIndent);
        let rightIndent = HelperMethods.convertPointToPixel(block.rightIndent);
        let bidi = block.bidi;
        let width = 0;
        if (beforeLayout) {
            if (block instanceof TableWidget && tableCollection) {
                let tableWidget = tableCollection[0];
                if (block.bodyWidget.sectionFormat.columns.length <= 1) {
                    this.clientActiveArea.x = this.clientArea.x = tableWidget.x;
                    this.clientActiveArea.width = this.clientArea.width = tableWidget.width;
                    if (updateXPosition && this.documentHelper.getFirstParagraphInFirstCell(block)) {
                        this.updateTableXPositionBasedOnTextWrap(block);
                    }
                }
                //Updates the location of last item.
                tableWidget = tableCollection[tableCollection.length - 1];
                tableWidget.x = this.clientActiveArea.x;
                tableWidget.y = this.clientActiveArea.y;
            }
            else {
                if (block instanceof TableWidget && !isNullOrUndefined(block.tableFormat)) {
                    if (!block.isGridUpdated) {
                        block.buildTableColumns();
                        block.isGridUpdated = true;
                    }
                    let tableAlignment = this.tableAlignmentForBidi(block, bidi);
                    if (tableAlignment !== 'Left') {
                        let tableWidth = 0;
                        // If the grid is calculated, we can direclty get the width from the grid.
                        // Otherwise, calculate the width.
                        tableWidth = HelperMethods.convertPointToPixel(block.tableHolder.getTotalWidth(0));
                        tableWidth = tableWidth === 0 ? block.tableHolder.tableWidth === 0 ?
                            block.getTableClientWidth(block.getOwnerWidth(false)) : block.tableHolder.tableWidth : tableWidth;
                        if (tableAlignment === 'Center') {
                            if (!this.documentHelper.isRowOrCellResizing) {
                                tableWidth = block.getTableCellWidth();
                            }
                            if (this.owner.viewer instanceof PageLayoutViewer) {
                                leftIndent = (this.clientArea.width - tableWidth) / 2;
                            }
                        }
                        else {
                            leftIndent = this.clientArea.width - tableWidth;
                        }
                        if (bidi) {
                            leftIndent = leftIndent - HelperMethods.convertPointToPixel(block.leftIndent);
                            rightIndent = leftIndent;
                        }
                        if (!block.isInsideTable) {
                            //leftIndent = (block.tableFormat.horizontalPositionAbs === 'Left') ? block.tableFormat.horizontalPosition : leftIndent;
                        }
                        this.documentHelper.tableLefts.push(leftIndent);
                    }
                }
                width = this.clientArea.width - (leftIndent + HelperMethods.convertPointToPixel(block.rightIndent));
                let x = this.clientArea.x + (bidi ? rightIndent : leftIndent);
                width = width > 0 ? width : 0;
                this.clientActiveArea.x = this.clientArea.x = x;
                this.clientActiveArea.width = this.clientArea.width = width;
                if (updateYPosition) {
                    this.updateParagraphYPositionBasedonTextWrap(block, new Rect(this.clientActiveArea.x, this.clientActiveArea.y, this.clientActiveArea.width, this.clientActiveArea.height));
                }
                if (updateXPosition) {
                    if (block instanceof ParagraphWidget) {
                        this.updateParagraphXPositionBasedOnTextWrap(block);
                    }
                    else {
                        this.updateTableXPositionBasedOnTextWrap(block);
                    }
                }
            }
        }
        else {
            // Clears table left for table with right or center alignment.
            if (block instanceof TableWidget && !isNullOrUndefined(block.tableFormat)) {
                let tableAlignment = this.tableAlignmentForBidi(block, bidi);
                if (!block.isGridUpdated) {
                    block.buildTableColumns();
                    block.isGridUpdated = true;
                }
                if (tableAlignment !== 'Left' && this.documentHelper.tableLefts.length > 0) {
                    leftIndent = this.documentHelper.tableLefts.pop();
                    if (bidi) {
                        rightIndent = leftIndent;
                    }
                }
            }
            width = this.clientArea.width + leftIndent + HelperMethods.convertPointToPixel(block.rightIndent);
            let x = this.clientArea.x - (bidi ? rightIndent : leftIndent);
            width = width > 0 ? width : 0;
            this.clientActiveArea.x = this.clientArea.x = x;
            this.clientActiveArea.width = this.clientArea.width = width;
        }
        this.clientArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
        this.clientActiveArea = new Rect(this.clientActiveArea.x, this.clientActiveArea.y, this.clientActiveArea.width, this.clientActiveArea.height);
    }
    updateParagraphYPositionBasedonTextWrap(block, rect) {
        let bodyWidget = block.bodyWidget;
        let clientLayoutArea = this.clientActiveArea;
        if (bodyWidget && bodyWidget.floatingElements.length > 0 && block instanceof ParagraphWidget && !(block.containerWidget instanceof TextFrame)
            && !block.isInsideTable && !(block.containerWidget instanceof FootNoteWidget)) {
            let isWord2013 = this.documentHelper.compatibilityMode === 'Word2013';
            let paragraph = block;
            let isEmptyPara = paragraph.isEmpty();
            let paragraphHeight = paragraph.height;
            if (paragraphHeight === 0) {
                paragraphHeight = this.documentHelper.textHelper.getParagraphMarkSize(paragraph.characterFormat).Height;
            }
            //Update Layout area based on text wrap
            if (((!paragraph.isInHeaderFooter || paragraph.isInsideTable)
                || isWord2013)) {
                let yposition = rect.y;
                // As per Microsoft Word behavior, need to update bottom position of first inline item to floating item bottom,
                // when first inline item of page intersects in-between two adjacent floating items parallel in vertical
                // for Word document lower than Microsoft Word 2013 version.
                // To do: Currently this behavior handled for bottom position update based on Y position,
                // need to handle this behavior for bottom position update based on X position in UpdateParagraphXPositionBasedOnTextWrap method.
                let isFirstItemBottomPositionUpdated = false;
                //Need to handle sorting floating items.
                // Sort based on Y position
                bodyWidget.floatingElements.sort(function (a, b) { return a.y - b.y; });
                // Sort based on X position
                bodyWidget.floatingElements.sort(function (a, b) { return a.x - b.x; });
                let previousItem = paragraph.previousRenderedWidget;
                if (previousItem && (previousItem instanceof TableWidget) && previousItem.wrapTextAround
                    && !isEmptyPara && !paragraph.isContainsShapeAlone() && isWord2013 && rect.y < previousItem.y) {
                    rect.y = previousItem.y;
                }
                for (let i = 0; i < bodyWidget.floatingElements.length; i++) {
                    let floatingItem = bodyWidget.floatingElements[i];
                    let isInsideHeaderFooter = false;
                    if (floatingItem instanceof ShapeBase) {
                        isInsideHeaderFooter = floatingItem.paragraph.isInHeaderFooter;
                    }
                    else {
                        isInsideHeaderFooter = floatingItem.bodyWidget instanceof HeaderFooterWidget ? true : false;
                    }
                    if (paragraph.isInsideTable) {
                        if (floatingItem instanceof TableWidget && !floatingItem.isInsideTable) {
                            continue;
                        }
                    }
                    let textWrappingBounds = this.getTextWrappingBound(floatingItem);
                    let textWrappingStyle = floatingItem instanceof TableWidget ? 'Square' : floatingItem.textWrappingStyle;
                    let textWrappingType = floatingItem instanceof TableWidget ? 'Both' : floatingItem.textWrappingType;
                    let minimumWidthRequired = 24;
                    if (!(clientLayoutArea.x > (textWrappingBounds.right + minimumWidthRequired) || clientLayoutArea.right < textWrappingBounds.x - minimumWidthRequired)) {
                        if ((((rect.y + (floatingItem instanceof TableWidget && !isEmptyPara && paragraph.floatingElements.length === 0 ? paragraphHeight : paragraph.height) > textWrappingBounds.y
                            || isFirstItemBottomPositionUpdated) && rect.y < (textWrappingBounds.bottom))) && textWrappingStyle !== 'Inline'
                            && textWrappingStyle !== 'TopAndBottom' && textWrappingStyle !== 'InFrontOfText'
                            && textWrappingStyle !== 'Behind') {
                            let rightIndent = 0;
                            let paragarphRightIndent = HelperMethods.convertPointToPixel(paragraph.paragraphFormat.rightIndent);
                            let firstLineIndent = HelperMethods.convertPointToPixel(paragraph.paragraphFormat.firstLineIndent);
                            firstLineIndent = ((!isEmptyPara && paragraph.childWidgets[0].isFirstLine()) && firstLineIndent > 0) ? firstLineIndent : 0;
                            if (rect.x >= textWrappingBounds.x && textWrappingType !== 'Left') {
                                rightIndent = paragarphRightIndent;
                            }
                            // Gets the value from right indent when it is negative, otherwise sets the value as zero.
                            rightIndent = rightIndent < 0 ? rightIndent : 0;
                            if (rect.x < textWrappingBounds.x && rect.x > textWrappingBounds.x && textWrappingType !== 'Left') {
                                if (rect.right > textWrappingBounds.x) {
                                    rect.width = rect.width - (rect.right - textWrappingBounds.right);
                                }
                                if (rect.width < minimumWidthRequired) {
                                    //Skip to wrap the immediate paragraph of floating table based on corresponding floating table. 
                                    if (isWord2013 || !((floatingItem instanceof TableWidget) && previousItem === floatingItem)) {
                                        this.updateBoundsBasedOnTextWrap(textWrappingBounds.bottom);
                                        rect = this.clientActiveArea;
                                    }
                                    if ((!isEmptyPara && paragraph.childWidgets[0].isFirstLine() || isEmptyPara) && isWord2013 ? true : !isInsideHeaderFooter) {
                                        paragraph.y = this.clientActiveArea.y;
                                    }
                                }
                                else {
                                    rect.x = textWrappingBounds.right;
                                }
                            }
                            else if (rect.x >= textWrappingBounds.x && rect.x < textWrappingBounds.right) {
                                rect.width = rect.width - (textWrappingBounds.right - rect.x) - rightIndent;
                                //checks minimum width
                                if (rect.width < minimumWidthRequired || isFirstItemBottomPositionUpdated) {
                                    rect.width = this.clientActiveArea.right - textWrappingBounds.right - rightIndent;
                                    let isPositionsUpdated = false;
                                    if (rect.width < minimumWidthRequired || isFirstItemBottomPositionUpdated) {
                                        // If left side of floating item has minimum width to layout the paragraph, then find the minimum bottom among the floating items to the left side of current floating item.
                                        // Then update the Y position to that bottom.
                                        if (this.clientActiveArea.x + minimumWidthRequired < textWrappingBounds.x) {
                                            let tempBounds = this.getIntersectingItemBounds(bodyWidget.floatingElements, floatingItem, yposition);
                                            if (!isNullOrUndefined(tempBounds) && tempBounds.bottom <= textWrappingBounds.bottom) {
                                                this.updateBoundsBasedOnTextWrap(tempBounds.bottom);
                                                rect = this.clientActiveArea;
                                                isPositionsUpdated = true;
                                                //When we update the client area to the bottom of floating item, we also need to updtae the X position. 
                                                //To-Do: Some more X position updating cases also need to handle.
                                                paragraph.x = tempBounds.x;
                                            }
                                        }
                                        // Skip to wrap the immediate paragraph of floating table based on corresponding floating table.
                                        if ((isWord2013) && !isPositionsUpdated) {
                                            if (floatingItem instanceof TableWidget && previousItem === floatingItem) {
                                                this.updateBoundsBasedOnTextWrapTable(textWrappingBounds.bottom);
                                            }
                                            else {
                                                this.updateBoundsBasedOnTextWrap(textWrappingBounds.bottom);
                                            }
                                            rect = this.clientActiveArea;
                                        }
                                        if ((!isEmptyPara && paragraph.childWidgets[0].isFirstLine() || isEmptyPara) && isWord2013 ? true : !isInsideHeaderFooter) {
                                            paragraph.y = this.clientActiveArea.y;
                                        }
                                    }
                                    else {
                                        rect.x = textWrappingBounds.right;
                                    }
                                }
                                else {
                                    rect.x = textWrappingBounds.right;
                                }
                            }
                            else if (textWrappingBounds.x > rect.x && rect.right > textWrappingBounds.x) {
                                rect.width = textWrappingBounds.x - rect.x;
                                //checks minimum width
                                if (rect.width < minimumWidthRequired) {
                                    rect.width = this.clientActiveArea.right - textWrappingBounds.right - rightIndent;
                                    if (rect.width < minimumWidthRequired) {
                                        //Skip to wrap the immediate paragraph of floating table based on corresponding floating table. 
                                        if (isWord2013 || !((floatingItem instanceof TableWidget) && previousItem === floatingItem)) {
                                            this.updateBoundsBasedOnTextWrap(textWrappingBounds.bottom);
                                            rect = this.clientActiveArea;
                                        }
                                        if ((!isEmptyPara && paragraph.childWidgets[0].isFirstLine() || isEmptyPara) && isWord2013 ? true : !isInsideHeaderFooter) {
                                            paragraph.y = this.clientActiveArea.y;
                                        }
                                    }
                                    else {
                                        rect.x = textWrappingBounds.right;
                                    }
                                }
                            }
                        }
                        else if ((bodyWidget.floatingElements.length > 0 && ((rect.y >= (textWrappingBounds.y) && rect.y < (textWrappingBounds.bottom))
                            || ((rect.y + paragraphHeight >= textWrappingBounds.y) && (rect.y + paragraphHeight < (textWrappingBounds.bottom))))
                            && textWrappingStyle === 'TopAndBottom')) {
                            //Skip to wrap the immediate paragraph of floating table based on corresponding floating table. 
                            if (isWord2013 || !((floatingItem instanceof TableWidget) && previousItem === floatingItem)) {
                                const width = this.documentHelper.textHelper.getParagraphMarkWidth(paragraph.characterFormat);
                                if (this.documentHelper.compatibilityMode === 'Word2007' && isEmptyPara && !paragraph.bidi &&
                                    !isNullOrUndefined(paragraph.paragraphFormat) && paragraph.paragraphFormat.textAlignment !== 'Left'
                                    && paragraph.paragraphFormat.textAlignment !== 'Center' && this.clientActiveArea.x + width < textWrappingBounds.x) {
                                    continue;
                                }
                                this.updateBoundsBasedOnTextWrap(textWrappingBounds.bottom);
                                // Sets true to update bottom position of first inline item in page
                                // when this item's bottom position already updated based on previous floating item.
                                if (!isWord2013 && (!isEmptyPara && paragraph.childWidgets[0].isFirstLine() || isEmptyPara)) {
                                    isFirstItemBottomPositionUpdated = true;
                                }
                            }
                            if ((!isEmptyPara && paragraph.childWidgets[0].isFirstLine() || isEmptyPara) && isWord2013 ? true : !isInsideHeaderFooter) {
                                paragraph.y = this.clientActiveArea.y;
                            }
                        }
                    }
                    // //Reset the floating item bounds to original position
                    // ResetXPositionForRTLLayouting(i, ref textWrappingBounds, floatingItemXPosition);
                }
                //Update the wrapping difference value.
                // if (isFirstItem && yValue < rect.Y) {
                //     (m_lcOperator as Layouter).WrappingDifference = (float)(rect.Y - (m_lcOperator as Layouter).PageTopMargin);
                // }
            }
        }
    }
    /**
     * @private
     */
    updateParagraphXPositionBasedOnTextWrap(block) {
        // #region textwrap
        let yValue = 0;
        let isFirstItem = false;
        let isWord2013 = this.documentHelper.compatibilityMode === 'Word2013';
        let bodyWidget = block.containerWidget;
        let clientLayoutArea = this.clientActiveArea;
        // if (!(m_lcOperator as Layouter).IsLayoutingHeaderFooter &&
        //     (m_lcOperator as Layouter).WrappingDifference === Number.MIN_VALUE &&
        //     Math.round(yPosition, 2) === Math.round((m_lcOperator as Layouter).PageTopMargin, 2)) {
        //     yValue = yPosition;
        //     isFirstItem = true;
        // }
        if (this instanceof PageLayoutViewer && !isNullOrUndefined(bodyWidget) && block instanceof ParagraphWidget && !isNullOrUndefined(bodyWidget.page) && !isNullOrUndefined(bodyWidget.page.headerWidget)) {
            let floatingItems = bodyWidget.page.headerWidget.floatingElements;
            if (floatingItems.length > 0 &&
                (!block.isInHeaderFooter || block.isInsideTable ||
                    isWord2013) &&
                !(block.containerWidget instanceof FootNoteWidget) && !(block.bodyWidget instanceof TextFrame)) {
                // const clientLayoutArea: RectangleF = (m_lcOperator as Layouter).ClientLayoutArea;
                // clientLayoutArea.X = xPosition;
                // clientLayoutArea.Y = yPosition;
                //let cellPadings: number = 0;
                let paragraph = block;
                //if (paragraph.isInsideTable) {
                //const cellLayoutInfo: CellLayoutInfo = ((paragraph.GetOwnerEntity() as WTableCell) as IWidget).LayoutInfo as CellLayoutInfo;
                //cellPadings = cellLayoutInfo.Paddings.Left + cellLayoutInfo.Paddings.Right;
                // }
                // let defMinWidth: number = minimumWidthRequired - cellPadings;
                // const size: SizeF = (paragraph as IWidget).LayoutInfo.Size;
                for (let i = 0; i < floatingItems.length; i++) {
                    let floatingItem = floatingItems[i];
                    // if (paragraph.IsInCell && floatingItems[i].allowOverlap &&
                    //     (paragraph.associatedCell.ownerRow.ownerTable.tableFormat.positioning.allowOverlap) {
                    if (paragraph.isInsideTable) {
                        if (floatingItem instanceof TableWidget && !floatingItem.isInsideTable) {
                            continue;
                        }
                    }
                    // }
                    let textWrappingBounds = this.getTextWrappingBound(floatingItem);
                    let textWrappingStyle = floatingItem instanceof TableWidget ? 'Square' : floatingItem.textWrappingStyle;
                    let textWrappingType = floatingItem instanceof TableWidget ? 'Both' : floatingItem.textWrappingType;
                    //let ownerBody: BodyWidget = undefined;
                    //As per Microsoft Word behavior, when floating item and paragraph in cell means,
                    //then, wrap the bounds for the items in same cell only.                 
                    //Skip, if it is in different cell.
                    // let ownerBody: BodyWidget = undefined
                    // if (!this.isInSameTextBody(paragraph, floatingItem, ownerBody) &&
                    //     paragraph.isInsideTable && bodyWidget instanceof TableCellWidget) {
                    //     continue;
                    // }
                    // if (this.IsInFrame((m_lcOperator as Layouter).FloatingItems[i].FloatingEntity as WParagraph) &&
                    //     this.IsOwnerCellInFrame(paragraph)) {
                    //     continue;
                    // }
                    // if (paragraph.ParagraphFormat.Bidi &&
                    //     (this.IsInSameTextBody(paragraph, (m_lcOperator as Layouter).FloatingItems[i], ownerBody) &&
                    //         paragraph.IsInCell && ownerBody instanceof WTableCell)) {
                    //     this.ModifyXPositionForRTLLayouting(i, textWrappingBounds, (m_layoutArea as any).ClientArea);
                    // } else if (paragraph.ParagraphFormat.Bidi) {
                    //     this.ModifyXPositionForRTLLayouting(i, textWrappingBounds, (m_lcOperator as Layouter).ClientLayoutArea);
                    // }
                    let minimumWidthRequired = 24;
                    // if (textWrappingStyle === TextWrappingStyle.Tight || textWrappingStyle === TextWrappingStyle.Through) {
                    //     minimumWidthRequired = paragraph.Document.Settings.CompatibilityMode === CompatibilityMode.Word2013 ?
                    //         DEF_MIN_WIDTH_2013_TIGHTANDTHROW : DEF_MIN_WIDTH_TIGHTANDTHROW;
                    // }
                    // minimumWidthRequired -= cellPadings;
                    // defMinWidth = minimumWidthRequired;
                    // if (textWrappingStyle === TextWrappingStyle.Tight || textWrappingStyle === TextWrappingStyle.Through &&
                    //     (m_lcOperator as Layouter).FloatingItems[i].IsDoesNotDenotesRectangle) {
                    //     const temp: RectangleF = this.AdjustTightAndThroughBounds(
                    //         (m_lcOperator as Layouter).FloatingItems[i], clientLayoutArea, size.Height);
                    //     if (temp.X !== 0) {
                    //         textWrappingBounds = temp;
                    //         defMinWidth = size.Width;
                    //     }
                    // }
                    if (!paragraph.isInsideTable &&
                        (!(clientLayoutArea.x > textWrappingBounds.right + minimumWidthRequired ||
                            clientLayoutArea.right < textWrappingBounds.x - minimumWidthRequired))) {
                        if (floatingItems.length > 0 &&
                            (clientLayoutArea.y + paragraph.height > textWrappingBounds.y && clientLayoutArea.y < textWrappingBounds.bottom) &&
                            textWrappingStyle !== "Inline" &&
                            textWrappingStyle !== "TopAndBottom" &&
                            textWrappingStyle !== "InFrontOfText" &&
                            textWrappingStyle !== "Behind") {
                            const rightIndent = HelperMethods.convertPointToPixel(paragraph.paragraphFormat.rightIndent);
                            if (paragraph.paragraphFormat.textAlignment != "Left" && (clientLayoutArea.x < textWrappingBounds.x && clientLayoutArea.x + paragraph.width > textWrappingBounds.x)) {
                                paragraph.x = clientLayoutArea.x;
                            }
                            else if (clientLayoutArea.x >= textWrappingBounds.x && clientLayoutArea.x < textWrappingBounds.right && !paragraph.paragraphFormat.bidi) {
                                clientLayoutArea.width = clientLayoutArea.width - (textWrappingBounds.right - clientLayoutArea.x) - rightIndent;
                                if (clientLayoutArea.width < minimumWidthRequired) {
                                    clientLayoutArea.width = this.clientActiveArea.right - textWrappingBounds.right - rightIndent;
                                    if (clientLayoutArea.width < minimumWidthRequired) {
                                        const remainingHeightOfFloatingItem = textWrappingBounds.bottom > clientLayoutArea.y ? textWrappingBounds.bottom - clientLayoutArea.y : 0;
                                        const updatedHeight = clientLayoutArea.height - remainingHeightOfFloatingItem;
                                        paragraph.x = clientLayoutArea.x;
                                        clientLayoutArea.width = this.clientArea.width;
                                        clientLayoutArea.height = updatedHeight < 0 ? 0 : updatedHeight;
                                        clientLayoutArea.y = textWrappingBounds.bottom;
                                    }
                                    else {
                                        clientLayoutArea.x = textWrappingBounds.right;
                                    }
                                }
                                else if (this.documentHelper.compatibilityMode === "Word2007" ||
                                    clientLayoutArea.y <= textWrappingBounds.bottom) {
                                    // if (this.IsNeedToUpdateParagraphYPosition(clientLayoutArea.Y, textWrappingStyle,
                                    //     paragraph, clientLayoutArea.Y + size.Height + paragraph.ParagraphFormat.AfterSpacing, textWrappingBounds.Bottom)) {
                                    //     paragraph.x = clientLayoutArea.x;
                                    //     clientLayoutArea.width = clientLayoutArea.width;
                                    //     clientLayoutArea.y = textWrappingBounds.bottom;
                                    //     clientLayoutArea.height = clientLayoutArea.height -
                                    //         (textWrappingBounds.bottom - clientLayoutArea.y);
                                    //     this.updateBoundsBasedOnTextWrap(textWrappingBounds.bottom);
                                    // } else {
                                    //const paraInfo: ParagraphLayoutInfo = paragraph.m_layoutInfo as ParagraphLayoutInfo;
                                    const leftIndent = HelperMethods.convertPointToPixel(paragraph.paragraphFormat.leftIndent);
                                    const firstLineIndent = HelperMethods.convertPointToPixel(paragraph.paragraphFormat.firstLineIndent);
                                    if (leftIndent + firstLineIndent + clientLayoutArea.x < textWrappingBounds.right) {
                                        // paragraph.x = textWrappingBounds.right;
                                        clientLayoutArea.x = textWrappingBounds.right;
                                        if (isWord2013) {
                                            //this.documentHelper.layout.IsXpositionUpated = true;
                                        }
                                    }
                                    // }
                                }
                            }
                            else if ((textWrappingBounds.x - minimumWidthRequired > clientLayoutArea.x && clientLayoutArea.right > textWrappingBounds.x) ||
                                (clientLayoutArea.x > textWrappingBounds.x && clientLayoutArea.x > textWrappingBounds.right)) {
                                paragraph.x = clientLayoutArea.x;
                            }
                            // else if (clientLayoutArea.x > textWrappingBounds.x - minimumWidthRequired && clientLayoutArea.x < textWrappingBounds.right) {
                            //     const width: number = clientLayoutArea.width + (clientLayoutArea.x - textWrappingBounds.right);
                            //     if (width < minimumWidthRequired) {
                            //         clientLayoutArea.y = textWrappingBounds.bottom;
                            //     } else {
                            //         paragraph.x = textWrappingBounds.right;
                            //     }
                            // } 
                            // else if (this.IsNeedToUpdateParagraphYPosition(clientLayoutArea.Y, textWrappingStyle,
                            //     paragraph, clientLayoutArea.Y + size.Height + paragraph.ParagraphFormat.AfterSpacing, textWrappingBounds.Bottom)) {
                            //     (paragraph.m_layoutInfo as ParagraphLayoutInfo).XPosition = clientLayoutArea.X;
                            //     clientLayoutArea.Width = (m_lcOperator as Layouter).ClientLayoutArea.Width;
                            //     clientLayoutArea.Y = textWrappingBounds.Bottom;
                            //     clientLayoutArea.Height = (m_lcOperator as Layouter).ClientLayoutArea.Height -
                            //         (textWrappingBounds.Bottom - (m_lcOperator as Layouter).ClientLayoutArea.Y);
                            //     (m_layoutArea as any).UpdateBoundsBasedOnTextWrap(textWrappingBounds.Bottom);
                            // }
                        }
                    }
                    //this.ResetXPositionForRTLLayouting(i, textWrappingBounds, floatingItemXPosition);
                }
            }
            // if (m_widget instanceof WParagraph) {
            //     const sortYPosition: FloatingItem[] = (m_lcOperator as Layouter).FloatingItems.slice(0);
            //     FloatingItem.SortFloatingItems(sortYPosition, SortPosition.Y);
            //     this.UpdateXYPositionBasedOnAdjacentFloatingItems(sortYPosition, clientLayoutArea, size,
            //         m_widget as WParagraph, false);
            // }
            // if (isFirstItem && yValue < yPosition) {
            //     (m_lcOperator as Layouter).WrappingDifference = yPosition - (m_lcOperator as Layouter).PageTopMargin;
            // }
        }
    }
    /**
     * @private
     */
    updateTableXPositionBasedOnTextWrap(block) {
        // Get the first row width
        let firstRowWidth = HelperMethods.convertPointToPixel(block.childWidgets[0].getFirstRowWidth());
        let bodyWidget = block.bodyWidget;
        if (this instanceof PageLayoutViewer && !isNullOrUndefined(bodyWidget) && !isNullOrUndefined(bodyWidget.page) && !isNullOrUndefined(bodyWidget.page.headerWidget)) {
            let floatingItems = bodyWidget.page.headerWidget.floatingElements;
            // textwrap
            // Update Layout area based on text wrap and ignore the yposition update while 
            // wrapping bounds already added to the collection
            if (floatingItems.length > 0 && (!block.isInHeaderFooter || !block.isInsideTable || this.documentHelper.compatibilityMode === 'Word2013')
                && !(block.containerWidget instanceof TextFrame)) {
                let rect = this.clientActiveArea;
                //let wrapItemIndex: number = -1;
                // sort the list items based on y position,
                // Call Sort on the list. This will use the  
                // default comparer, which is the Compare method  
                // implemented on FloatingItem.
                //FloatingItem.sortFloatingItems(this.m_lcOperator.floatingItems, SortPosition.Y);
                for (let i = 0; i < floatingItems.length; i++) {
                    let floatingItem = floatingItems[i];
                    let textWrappingBounds = this.getTextWrappingBound(floatingItem);
                    let textWrappingStyle = floatingItem instanceof TableWidget ? 'Square' : floatingItem.textWrappingStyle;
                    let allowOverlap = floatingItem instanceof TableWidget ? floatingItem.positioning.allowOverlap : floatingItem.allowOverlap;
                    // if (this.isAdjustTightAndThroughBounds(textWrappingStyle, i)) {
                    //     let temp: RectangleF = this.adjustTightAndThroughBounds(this.m_lcOperator.floatingItems[i], rect, size.height);
                    //     textWrappingBounds = temp;
                    // }
                    // let ownerBody: WTextBody = null;
                    // // As per Microsoft Word behavior, when floating item and table in cell means,
                    // // then, wrap the bounds for the items in same cell only.                 
                    // // Skip, if it is in different cell.
                    // if (!this.isInSameTextBody(this.m_table, this.m_lcOperator.floatingItems[i], ownerBody)
                    //     && this.m_table.isInCell && ownerBody instanceof WTableCell)
                    //     continue;
                    // // Skip if the current table is in different frame
                    // if (this.isInFrame(this.m_lcOperator.floatingItems[i].floatingEntity as WParagraph) && this.m_table.isFrame)
                    //     continue;
                    // // Adjusts the text wrapping bounds based on distance from text values when floating table intersects with another floating item.
                    // textWrappingBounds = this.adjustTextWrappingBounds(this.m_lcOperator.floatingItems[i], clientLayoutArea, size,
                    //     wrapItemIndex, i, rect, textWrappingBounds, textWrappingStyle, allowOverlap);
                    let minimumWidthRequired = 24;
                    let paragarph = this.documentHelper.getFirstParagraphInFirstCell(block);
                    let height = this.documentHelper.textHelper.getParagraphMarkSize(paragarph.characterFormat).Height;
                    let rowHeight = block.childWidgets[0] instanceof TableRowWidget ? block.childWidgets[0].height : 0;
                    if (rowHeight > height) {
                        height = rowHeight;
                    }
                    let width = HelperMethods.convertPointToPixel(block.getTableClientWidth(block.getContainerWidth()));
                    if (!(this.clientArea.x > textWrappingBounds.right + minimumWidthRequired || this.clientArea.right < textWrappingBounds.x - minimumWidthRequired)) {
                        if (this.isFloatingItemIntersect(block, rect, textWrappingBounds, textWrappingStyle, allowOverlap, height, width)) {
                            if (rect.x >= textWrappingBounds.x && rect.x < textWrappingBounds.right) {
                                rect.width = rect.width - (textWrappingBounds.right - rect.x);
                                //checks minimum width
                                if (rect.width < minimumWidthRequired || (rect.width < firstRowWidth && firstRowWidth > 0)) {
                                    rect.width = this.clientActiveArea.right - textWrappingBounds.right;
                                    //Check if the client active area width is lesser than table width to update the y position
                                    if (rect.width < minimumWidthRequired || ((rect.width < firstRowWidth && firstRowWidth > 0) &&
                                        this.clientArea.right <= firstRowWidth + textWrappingBounds.right)) {
                                        //When the table y position is lesser than the text wrapping bottom position then 
                                        //difference of these two should be subtracted from the table client height instead of the floating item height.
                                        let remainingHeightOfFloatingItem = (textWrappingBounds.bottom > rect.y) ? textWrappingBounds.bottom - rect.y : 0;
                                        rect.y = textWrappingBounds.bottom;
                                        rect.width = this.clientArea.width;
                                        rect.height = rect.height - remainingHeightOfFloatingItem;
                                        this.updateClientAreaForTextWrap(rect);
                                    }
                                    else {
                                        rect.x = textWrappingBounds.right;
                                        // if (textWrappingStyle == TextWrappingStyle.Through
                                        //     && this.m_lcOperator.floatingItems[i].isDoesNotDenotesRectangle) {
                                        //     textWrappingBounds = this.adjustTightAndThroughBounds(this.m_lcOperator.floatingItems[i], rect, size.height);
                                        //     if (textWrappingBounds.x != 0)
                                        //         rect.width = textWrappingBounds.x - rect.x;
                                        // }
                                        this.updateClientAreaForTextWrap(rect);
                                    }
                                }
                                else {
                                    rect.x = textWrappingBounds.right;
                                    // if (textWrappingStyle == TextWrappingStyle.Through
                                    //     && this.m_lcOperator.floatingItems[i].isDoesNotDenotesRectangle) {
                                    //     textWrappingBounds = this.adjustTightAndThroughBounds(this.m_lcOperator.floatingItems[i], rect, size.height);
                                    //     if (textWrappingBounds.x != 0)
                                    //         rect.width = textWrappingBounds.x - rect.x;
                                    // }
                                    this.updateClientAreaForTextWrap(rect);
                                }
                            }
                            // else if ((rect.right - textWrappingBounds.right) > 0
                            //     && (rect.right - textWrappingBounds.right) < rect.width
                            //     && (rect.y >= textWrappingBounds.y
                            //         || (rect.y + size.height) >= textWrappingBounds.y)) {
                            //     //If the table is intersect with  another floating item from the top ,then we need to consider distance from text with respect to relative margin position.
                            //     if (rect.x < textWrappingBounds.x && rect.right > textWrappingBounds.x) {
                            //         if (this.m_table.tableFormat.positioning.horizPositionAbs == HorizontalPosition.Left)
                            //             rect.x += this.m_table.tableFormat.positioning.distanceFromLeft;
                            //         else if (this.m_table.tableFormat.positioning.horizPositionAbs == HorizontalPosition.Right)
                            //             rect.x -= this.m_table.tableFormat.positioning.distanceFromRight;
                            //     }
                            //     //When the table y position is lesser than the text wrapping bottom position then 
                            //     //difference of these two should be subtracted from the table client height instead of the floating item height.
                            //     let remainingHeightOfFloatingItem = (textWrappingBounds.bottom > rect.y) ? textWrappingBounds.bottom - rect.y : 0;
                            //     rect.y = textWrappingBounds.bottom;
                            //     rect.height = rect.height - remainingHeightOfFloatingItem;
                            //     this.createLayoutArea(rect);
                            // }
                            // else if (textWrappingBounds.x > rect.x && rect.right > textWrappingBounds.x) {
                            //     rect.width = textWrappingBounds.x - rect.x;
                            //     //checks minimum width
                            //     if (rect.width < DEF_MIN_WIDTH || (rect.width < firstRowWidth && firstRowWidth > 0)) {
                            //         rect.width = this.m_layoutArea.clientActiveArea.right - textWrappingBounds.right;
                            //         if (rect.width < DEF_MIN_WIDTH || (rect.width < firstRowWidth && firstRowWidth > 0)) {
                            //             //Check if the client active area width is greater than table width to update the x position
                            //             if (this.m_layoutArea.clientArea.right < this.m_lcOperator.clientLayoutArea.right
                            //                 && textWrappingBounds.right < this.m_lcOperator.clientLayoutArea.right
                            //                 && this.m_lcOperator.clientLayoutArea.right - textWrappingBounds.right > DEF_MIN_WIDTH
                            //                 && Math.round(this.m_layoutArea.clientActiveArea.width, 2) > Math.round(firstRowWidth, 2)) {
                            //                 rect.width = this.m_lcOperator.clientLayoutArea.right - textWrappingBounds.right;
                            //                 rect.x = textWrappingBounds.right;
                            //                 if (textWrappingStyle == TextWrappingStyle.Through
                            //                     && this.m_lcOperator.floatingItems[i].isDoesNotDenotesRectangle) {
                            //                     textWrappingBounds = this.adjustTightAndThroughBounds(this.m_lcOperator.floatingItems[i], rect, size.height);
                            //                     if (textWrappingBounds.x != 0)
                            //                         rect.width = textWrappingBounds.x - rect.x;
                            //                 }
                            //             }
                            //             else {
                            //                 //When the table y position is lesser than the text wrapping bottom position then 
                            //                 //difference of these two should be subtracted from the table client height instead of the floating item height.
                            //                 let remainingHeightOfFloatingItem = (textWrappingBounds.bottom > rect.y) ? textWrappingBounds.bottom - rect.y : 0;
                            //                 rect.y = textWrappingBounds.bottom;
                            //                 rect.height = rect.height - remainingHeightOfFloatingItem;
                            //             }
                            //             this.createLayoutArea(rect);
                            //         }
                            //     }
                            //     else
                            //         this.createLayoutArea(rect);
                            // }
                            // else if (rect.x > textWrappingBounds.x && rect.x > textWrappingBounds.right) {
                            //     rect.width = this.m_layoutArea.clientArea.width;
                            //     this.createLayoutArea(rect);
                            // }
                            // else if (rect.x > textWrappingBounds.x && rect.x < textWrappingBounds.right) {
                            //     rect.width = rect.width - (textWrappingBounds.right - rect.x);
                            //     rect.x = textWrappingBounds.right;
                            //     if (textWrappingStyle == TextWrappingStyle.Through
                            //         && this.m_lcOperator.floatingItems[i].isDoesNotDenotesRectangle) {
                            //         textWrappingBounds = this.adjustTightAndThroughBounds(this.m_lcOperator.floatingItems[i], rect, size.height);
                            //         if (textWrappingBounds.x != 0)
                            //             rect.width = textWrappingBounds.x - rect.x;
                            //     }
                            //     this.createLayoutArea(rect);
                            // }
                        }
                    }
                }
            }
        }
    }
    isFloatingItemIntersect(table, rect, textWrappingBounds, textWrappingStyle, allowOverlap, height, width) {
        return ((Math.round(rect.y + height) >= Math.round(textWrappingBounds.y)
            && Math.round(rect.y) < Math.round(textWrappingBounds.bottom))
            //Checks whether the bottom of the table intersects with floating item.
            || Math.round(rect.y + height) <= Math.round(textWrappingBounds.bottom)
                && Math.round(rect.y + height) >= Math.round(textWrappingBounds.y))
            && textWrappingStyle !== "Inline"
            && textWrappingStyle !== "TopAndBottom"
            && textWrappingStyle !== "InFrontOfText"
            && textWrappingStyle !== "Behind"
            && !(allowOverlap && (table.tableFormat !== null && table.wrapTextAround && table.positioning.allowOverlap));
    }
    getIntersectingItemBounds(floatingElements, intersectedfloatingItem, yPosition) {
        let floatingItem = this.getMinBottomFloatingItem(floatingElements, this.getIntersectingFloatingItems(floatingElements, intersectedfloatingItem, yPosition));
        if (!isNullOrUndefined(floatingItem)) {
            let floatingItemBound = this.getTextWrappingBound(floatingItem);
            return floatingItemBound;
        }
        return undefined;
    }
    getMinBottomFloatingItem(floatingElements, fItems) {
        let minBottomItemIndex = -1;
        let minBottom = Number.MAX_VALUE;
        let skippedCount = 0;
        // Sort based on X position
        floatingElements.sort(function (a, b) { return a.x - b.x; });
        for (let i = 0; i < fItems.length; i++) {
            let floatingItem = floatingElements[i];
            let item = this.getTextWrappingBound(floatingItem);
            if (minBottom > item.bottom) {
                // Need to ignore if floating items preserved in same frame.
                if (floatingItem && fItems.indexOf(floatingItem) + 1 < fItems.length) {
                    skippedCount++;
                }
                else {
                    minBottom = item.bottom;
                    minBottomItemIndex = fItems.indexOf(floatingItem);
                }
            }
        }
        //If floating item which has minimum bottom is first item (no items preserved left side of this item).
        //Then return current item Other cases need to handle.
        return minBottomItemIndex - skippedCount == 0 ? fItems[minBottomItemIndex] : null;
    }
    getIntersectingFloatingItems(floatingElements, intersectedfloatingItem, yPosition) {
        let fItems = [];
        //Get all the items which preserved left side of the current floating item.
        for (let i = 0; i < floatingElements.length; i++) {
            {
                let floatingItem = floatingElements[i];
                let itemTextWrapBound = this.getTextWrappingBound(floatingItem);
                let intersectItemTextWrapBound = this.getTextWrappingBound(intersectedfloatingItem);
                if (yPosition <= itemTextWrapBound.bottom
                    && intersectItemTextWrapBound.bottom >= itemTextWrapBound.bottom
                    && itemTextWrapBound.right > this.clientActiveArea.x
                    && itemTextWrapBound.x < intersectItemTextWrapBound.x)
                    fItems.push(floatingItem);
            }
        }
        return fItems;
    }
    getTextWrappingBound(floatingItem) {
        let distanceLeft = 0;
        let distanceTop = 0;
        let distanceRight = 0;
        let distanceBottom = 0;
        let width = 0;
        if (floatingItem instanceof ShapeBase) {
            distanceLeft = floatingItem.distanceLeft;
            distanceTop = floatingItem.distanceTop;
            distanceRight = floatingItem.distanceRight;
            distanceBottom = floatingItem.distanceBottom;
            width = floatingItem.width;
        }
        else {
            width = floatingItem.getTableCellWidth();
            distanceLeft = floatingItem.positioning.distanceLeft;
            distanceTop = floatingItem.positioning.distanceTop;
            distanceRight = floatingItem.positioning.distanceRight;
            distanceBottom = floatingItem.positioning.distanceBottom;
        }
        let textWrappingBounds = new Rect(floatingItem.x - distanceLeft, floatingItem.y - distanceTop, width + distanceLeft + distanceRight, floatingItem.height + distanceTop + distanceBottom);
        return textWrappingBounds;
    }
    tableAlignmentForBidi(block, bidi) {
        let tableAlignment = block.tableFormat.tableAlignment;
        if (bidi) {
            if (tableAlignment === 'Left') {
                tableAlignment = 'Right';
            }
            else if (tableAlignment === 'Right') {
                tableAlignment = 'Left';
            }
        }
        return tableAlignment;
    }
    cutFromLeft(x) {
        if (x < this.clientActiveArea.x) {
            x = this.clientActiveArea.x;
        }
        if (x > this.clientActiveArea.right && this.textWrap) {
            x = this.clientActiveArea.right;
        }
        this.clientActiveArea.width = this.clientActiveArea.right > x ? this.clientActiveArea.right - x : 0;
        this.clientActiveArea.x = x;
    }
    cutFromTop(y) {
        if (y < this.clientActiveArea.y) {
            y = this.clientActiveArea.y;
        }
        if (y > this.clientActiveArea.bottom) {
            y = this.clientActiveArea.bottom;
        }
        this.clientActiveArea.height = this.clientActiveArea.bottom - y;
        this.clientActiveArea.x = this.clientArea.x;
        this.clientActiveArea.width = this.clientArea.width;
        this.clientActiveArea.y = y;
    }
    updateClientWidth(width) {
        this.clientActiveArea.x -= width;
        if (this.clientActiveArea.width + width > 0) {
            this.clientActiveArea.width += width;
        }
        else {
            this.clientActiveArea.width = 0;
        }
    }
    findFocusedPage(currentPoint, updateCurrentPage, updateHeaderFooterPage, ispageUpAndDown) {
        let point = new Point(currentPoint.x, currentPoint.y);
        point.x += this.documentHelper.viewerContainer.scrollLeft;
        point.y += this.documentHelper.viewerContainer.scrollTop;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            let page = this.documentHelper.pages[i];
            let pageTop = (page.boundingRectangle.y - this.pageGap * (i + 1)) * this.documentHelper.zoomFactor + this.pageGap * (i + 1);
            let pageHeight = (page.boundingRectangle.height * this.documentHelper.zoomFactor) + this.pageGap;
            let pageLeft = page.boundingRectangle.x;
            let pageRight;
            if (this instanceof PageLayoutViewer) {
                pageRight = ((page.boundingRectangle.right - pageLeft) * this.documentHelper.zoomFactor) + pageLeft;
            }
            else {
                pageRight = page.boundingRectangle.right + pageLeft;
            }
            if (pageTop <= point.y && pageTop + pageHeight >= point.y) {
                if (updateCurrentPage) {
                    this.documentHelper.currentPage = page;
                    if (updateHeaderFooterPage) {
                        if (!isNullOrUndefined(page.headerWidget)) {
                            page.headerWidget.page = page;
                        }
                        if (!isNullOrUndefined(page.footerWidget)) {
                            page.footerWidget.page = page;
                        }
                    }
                }
                point.y = (point.y - (pageTop)) / this.documentHelper.zoomFactor;
                if (point.x > pageRight) {
                    point.x = page.boundingRectangle.right;
                }
                else if (point.x < pageLeft) {
                    point.x = 0;
                }
                else {
                    point.x = (point.x - pageLeft) / this.documentHelper.zoomFactor;
                }
                if (ispageUpAndDown && page.bodyWidgets.length > 0 && page.bodyWidgets[0].childWidgets.length > 0) {
                    const widget = page.bodyWidgets[0].childWidgets[0];
                    if (point.y < widget.y && widget) {
                        this.documentHelper.selection.updateYPointPosition(widget, point);
                    }
                }
                return point;
            }
        }
        return point;
    }
    getPageHeightAndWidth(height, width, viewerWidth, viewerHeight) {
        height = 0;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            height = height + this.documentHelper.pages[i].boundingRectangle.height;
        }
        width = 0;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            if (width < this.documentHelper.pages[i].boundingRectangle.width) {
                width = this.documentHelper.pages[i].boundingRectangle.width;
            }
        }
        //this.documentHelper.visibleBoundsIn = new Rect(0, 0, width, height);
        viewerWidth = this.documentHelper.visibleBounds.width;
        viewerHeight = this.documentHelper.visibleBounds.height;
        return {
            'height': height,
            'width': width,
            'viewerWidth': viewerWidth,
            'viewerHeight': viewerHeight
        };
    }
    renderVisiblePages() {
        if (isNullOrUndefined(this.visiblePages) || this.visiblePages.length < 1) {
            return;
        }
        this.documentHelper.clearContent();
        for (let i = 0; i < this.visiblePages.length; i++) {
            let page = this.visiblePages[i];
            let width = page.boundingRectangle.width * this.documentHelper.zoomFactor;
            let height = page.boundingRectangle.height * this.documentHelper.zoomFactor;
            let x = page.boundingRectangle.x;
            let y = (page.boundingRectangle.y - this.pageGap * (i + 1)) * this.documentHelper.zoomFactor + this.pageGap * (i + 1);
            this.owner.viewer.renderPage(page, x, y, width, height);
        }
    }
    /* eslint-disable  */
    handleZoom() {
        let prevScaleFactor = this.documentHelper.preZoomFactor;
        let page = null;
        let verticalHeight = 0;
        let scrollToPosition = false;
        if (this.documentHelper.selection && isNullOrUndefined(this.documentHelper.zoomX && isNullOrUndefined(this.documentHelper.zoomY))) {
            let x = 0;
            let y = 0;
            let endPage = this.documentHelper.selection.getPage(this.documentHelper.selection.end.currentWidget.paragraph);
            x = (this.documentHelper.visibleBounds.width - endPage.boundingRectangle.width * prevScaleFactor) / 2;
            if (x < 30) {
                x = 30;
            }
            y = endPage.boundingRectangle.y * prevScaleFactor + (this.documentHelper.pages.indexOf(endPage) + 1) * this.pageGap * (1 - prevScaleFactor);
            let caretInfo = this.documentHelper.selection.updateCaretSize(this.owner.selectionModule.end, true);
            let topMargin = caretInfo.topMargin;
            let caretHeight = caretInfo.height;
            x += (this.documentHelper.selection.end.location.x) * prevScaleFactor;
            y += (this.documentHelper.selection.end.location.y + topMargin) * prevScaleFactor;
            if (x >= this.containerLeft && x <= this.documentHelper.visibleBounds.width &&
                y >= this.containerTop && y <= this.containerTop + this.documentHelper.visibleBounds.height) {
                scrollToPosition = true;
            }
        }
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            verticalHeight = verticalHeight + this.documentHelper.pages[i].boundingRectangle.height;
        }
        let horizontalWidth = 0;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            if (horizontalWidth < this.documentHelper.pages[i].boundingRectangle.width) {
                horizontalWidth = this.documentHelper.pages[i].boundingRectangle.width;
            }
        }
        let height = (verticalHeight * this.documentHelper.zoomFactor + (this.documentHelper.pages.length + 1) * this.pageGap * (1 - this.documentHelper.zoomFactor)) - this.documentHelper.visibleBounds.height;
        let horWidth = horizontalWidth * this.documentHelper.zoomFactor - this.documentHelper.visibleBounds.width;
        if (this.documentHelper.visibleBounds.width - horizontalWidth * this.documentHelper.zoomFactor < 60) {
            horWidth += 60;
        }
        //Update Vertical Scroll bar
        if (height > 0) {
            let value = this.containerTop;
            if (this.visiblePages.length > 0) {
                page = this.visiblePages[0];
                let prevPageTop = (page.boundingRectangle.y - (page.index + 1) * this.pageGap) * prevScaleFactor + (page.index + 1) * this.pageGap;
                let zoomY = this.documentHelper.zoomY;
                if (isNullOrUndefined) {
                    zoomY = this.documentHelper.visibleBounds.height / 2;
                }
                let prevY = value + zoomY;
                let pageIndex = page.index + 1;
                while (prevY > prevPageTop + (page.boundingRectangle.height * prevScaleFactor)) {
                    pageIndex = page.index + 1;
                    if (pageIndex === this.documentHelper.pages.length) {
                        break;
                    }
                    page = this.documentHelper.pages[pageIndex];
                    prevPageTop = (page.boundingRectangle.y - (page.index + 1) * this.pageGap) * prevScaleFactor + (page.index + 1) * this.pageGap;
                }
                let currentY = (page.boundingRectangle.y - (page.index + 1) * this.pageGap) * this.documentHelper.zoomFactor + (page.index + 1) * this.pageGap
                    + ((prevY - prevPageTop) < 0 ? prevY - prevPageTop : (prevY - prevPageTop) * (this.documentHelper.zoomFactor / prevScaleFactor));
                value = currentY - zoomY - (this.documentHelper.zoomFactor * this.pageGap * pageIndex);
                zoomY = this.documentHelper.visibleBounds.height / 2;
            }
            this.documentHelper.viewerContainer.scrollTop = value;
        }
        else {
            this.documentHelper.viewerContainer.scrollTop = 0;
        }
        // update Horizontal Scroll Bar
        if (horWidth > 0) {
            let value = this.containerLeft;
            if (this.visiblePages.length > 0) {
                if (page === null) {
                    page = this.visiblePages[0];
                }
                let zoomX = this.documentHelper.zoomX;
                if (isNullOrUndefined(zoomX)) {
                    zoomX = this.documentHelper.visibleBounds.width / 2;
                }
                let prevValue = (page.boundingRectangle.width * prevScaleFactor) / page.boundingRectangle.width;
                let prevX = value + zoomX;
                let currentX = page.boundingRectangle.x
                    + ((prevX - page.boundingRectangle.x) < 0 ? prevX - page.boundingRectangle.x : (prevX - page.boundingRectangle.x) * (this.documentHelper.zoomFactor / prevValue));
                value = currentX - zoomX;
                zoomX = this.documentHelper.visibleBounds.width / 2;
            }
            this.documentHelper.viewerContainer.scrollLeft = value;
        }
        else {
            this.documentHelper.viewerContainer.scrollLeft = 0;
        }
        this.updateScrollBars();
        if (scrollToPosition) {
            this.documentHelper.scrollToPosition(this.documentHelper.selection.start, this.documentHelper.selection.end);
            // When ZoomIn/Zoomout using mouse wheel based on the selection scrolltop will be updated. So updating container top also.
            // So that second time position will be updated correctly based on the scroll top..
            this.containerTop = this.documentHelper.viewerContainer.scrollTop;
        }
        if (this instanceof WebLayoutViewer) {
            this.documentHelper.layout.layoutWholeDocument();
        }
    }
    updateCanvasWidthAndHeight(viewerWidth, viewerHeight, containerHeight, containerWidth, width, height) {
        if (this instanceof PageLayoutViewer) {
            if (this.documentHelper.visibleBounds.width !== this.documentHelper.viewerContainer.clientWidth) {
                viewerWidth -= (this.documentHelper.visibleBounds.width - this.documentHelper.viewerContainer.clientWidth);
            }
            else if (containerHeight > viewerHeight) {
                viewerWidth -= this.documentHelper.viewerContainer.offsetWidth - this.documentHelper.viewerContainer.clientWidth;
            }
        }
        else {
            if (containerHeight > viewerHeight) {
                viewerWidth -= this.documentHelper.scrollbarWidth;
                containerWidth -= this.documentHelper.scrollbarWidth;
            }
        }
        if (containerWidth > viewerWidth) {
            viewerHeight -= this.documentHelper.scrollbarWidth;
        }
        width = containerWidth > viewerWidth ? containerWidth : viewerWidth;
        height = containerHeight > viewerHeight ? containerHeight : viewerHeight;
        if (parseInt(this.documentHelper.pageContainer.style.width.replace('px', ''), 10) !== width ||
            parseInt(this.documentHelper.pageContainer.style.height.replace('px', ''), 10) !== width) {
            this.documentHelper.pageContainer.style.width = width.toString() + 'px';
            this.documentHelper.pageContainer.style.height = height.toString() + 'px';
        }
        // if (!isNullOrUndefined(this.selection) && !this.selection.isEmpty) {
        //     this.selectionContext.clearRect(0, 0, this.selectionCanvas.width, this.selectionCanvas.height);
        let displayPixelRatio = Math.max(1, window.devicePixelRatio || 1);
        if (this.documentHelper.containerCanvas.width !== Math.floor(viewerWidth * displayPixelRatio)
            || this.documentHelper.containerCanvas.height !== Math.floor(viewerHeight * displayPixelRatio)) {
            this.documentHelper.containerCanvas.width = viewerWidth * displayPixelRatio;
            this.documentHelper.containerCanvas.height = viewerHeight * displayPixelRatio;
            this.documentHelper.containerCanvas.style.width = viewerWidth + 'px';
            this.documentHelper.containerCanvas.style.height = viewerHeight + 'px';
            this.documentHelper.containerContext.scale(displayPixelRatio, displayPixelRatio);
            this.documentHelper.selectionCanvas.width = viewerWidth * displayPixelRatio;
            this.documentHelper.selectionCanvas.height = viewerHeight * displayPixelRatio;
            this.documentHelper.selectionCanvas.style.width = viewerWidth + 'px';
            this.documentHelper.selectionCanvas.style.height = viewerHeight + 'px';
            this.documentHelper.selectionContext.scale(displayPixelRatio, displayPixelRatio);
        }
        return {
            'height': height,
            'width': width,
            'viewerWidth': viewerWidth,
            'viewerHeight': viewerHeight,
            'containerHeight': containerHeight,
            'containerWidth': containerWidth
        };
    }
    updateScrollBarPosition(containerWidth, containerHeight, viewerWidth, viewerHeight, width, height) {
        this.owner.viewer.containerTop = this.documentHelper.viewerContainer.scrollTop;
        this.owner.viewer.containerWidth = containerWidth;
        this.documentHelper.containerCanvas.style.position = 'absolute';
        this.documentHelper.containerCanvas.style.top = this.owner.viewer.containerTop.toString() + 'px';
        this.documentHelper.selectionCanvas.style.position = 'absolute';
        this.documentHelper.selectionCanvas.style.top = this.owner.viewer.containerTop.toString() + 'px';
        this.owner.viewer.containerLeft = this.documentHelper.viewerContainer.scrollLeft;
        this.documentHelper.containerCanvas.style.left = this.owner.viewer.containerLeft + 'px';
        this.documentHelper.selectionCanvas.style.left = this.owner.viewer.containerLeft + 'px';
    }
    destroy() {
        this.clientArea = undefined;
        this.clientActiveArea = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     */
    componentDestroy() {
        this.clientArea = undefined;
        this.clientActiveArea = undefined;
        this.owner = undefined;
    }
}
/**
 * @private
 */
export class PageLayoutViewer extends LayoutViewer {
    /**
     * Initialize the constructor of PageLayoutViewer
     */
    constructor(owner) {
        super(owner);
        this.pageLeft = 30;
        // if (isNullOrUndefined(owner) || isNullOrUndefined(owner.element)) {
        //     return;
        // }
        this.owner = owner;
    }
    /**
     * @private
     */
    get pageGap() {
        return this.owner.pageGap;
    }
    get documentHelper() {
        return this.owner.documentHelper;
    }
    createNewPage(section, index) {
        let viewer = this;
        let yPos = this.pageGap;
        if (this.documentHelper.pages.length > 0) {
            yPos = this.documentHelper.pages[this.documentHelper.pages.length - 1].boundingRectangle.bottom + this.pageGap;
        }
        let page = new Page(this.documentHelper);
        this.updatePageBoundingRectangle(section, page, yPos);
        if (isNullOrUndefined(index)) {
            this.documentHelper.pages.push(page);
        }
        else {
            this.documentHelper.pages.splice(index, 0, page);
        }
        page.bodyWidgets.push(section);
        page.bodyWidgets[page.bodyWidgets.length - 1].page = page;
        this.updateClientArea(section, page);
        this.documentHelper.layout.layoutHeaderFooter(section, viewer, page);
        this.updateClientArea(section, page);
        this.documentHelper.layout.footnoteHeight = 0;
        return page;
    }
    updatePageBoundingRectangle(section, page, yPosition) {
        //page.viewer = this;
        let pageWidth = !isNullOrUndefined(section.sectionFormat) ? HelperMethods.convertPointToPixel(section.sectionFormat.pageWidth) : 816;
        let pageHeight = !isNullOrUndefined(section.sectionFormat) ? HelperMethods.convertPointToPixel(section.sectionFormat.pageHeight) : 1056;
        let xPos = (this.documentHelper.visibleBounds.width - pageWidth * this.documentHelper.zoomFactor) / 2;
        if (xPos < this.pageLeft) {
            xPos = this.pageLeft;
        }
        page.boundingRectangle = new Rect(xPos, yPosition, pageWidth, pageHeight);
    }
    onPageFitTypeChanged(pageFitType) {
        let width = this.documentHelper.visibleBounds.width;
        let height = this.documentHelper.visibleBounds.height;
        let section = this.visiblePages[0].bodyWidgets[0];
        let pageWidth = HelperMethods.convertPointToPixel(section.sectionFormat.pageWidth);
        let pageHeight = HelperMethods.convertPointToPixel(section.sectionFormat.pageHeight);
        switch (pageFitType) {
            case 'FitOnePage':
                if (height > 0 && pageHeight > 0) {
                    let zoomFactor = (this.documentHelper.visibleBounds.height - 2 * this.pageGap - (this.pageGap - 2)) / pageHeight;
                    if (zoomFactor === this.documentHelper.zoomFactor) {
                        if (!isNullOrUndefined(this.owner.selectionModule) && !isNullOrUndefined(this.owner.selectionModule.start) &&
                            !isNullOrUndefined(this.owner.selectionModule.end)) {
                            this.documentHelper.scrollToPosition(this.owner.selectionModule.start, this.owner.selectionModule.end);
                        }
                    }
                    else {
                        this.documentHelper.zoomFactor = zoomFactor;
                    }
                }
                break;
            case 'FitPageWidth':
                if (width > 0 && pageWidth > 0) {
                    this.documentHelper.zoomFactor = (this.documentHelper.visibleBounds.width - 80) / pageWidth;
                }
                break;
            default:
                this.documentHelper.zoomFactor = 100 / 100;
                break;
        }
    }
    getCurrentPageHeaderFooter(section, isHeader) {
        return this.getCurrentHeaderFooter(this.getHeaderFooterType(section, isHeader), section.index);
    }
    getHeaderFooterType(section, isHeader) {
        let type;
        type = isHeader ? 'OddHeader' : 'OddFooter';
        let page = section.page;
        if (section.sectionFormat.differentFirstPage && (isNullOrUndefined(page.previousPage) || (!isNullOrUndefined(page.previousPage) && page.sectionIndex !== page.previousPage.sectionIndex && page.previousPage.bodyWidgets[page.previousPage.bodyWidgets.length - 1].sectionIndex !== page.bodyWidgets[0].sectionIndex))) {
            type = isHeader ? 'FirstPageHeader' : 'FirstPageFooter';
        }
        else if (section.sectionFormat.differentOddAndEvenPages && (page.index + 1) % 2 === 0) {
            type = isHeader ? 'EvenHeader' : 'EvenFooter';
        }
        return type;
    }
    getCurrentHeaderFooter(type, sectionIndex) {
        if (this.documentHelper.headersFooters[sectionIndex]) {
            let index = this.getHeaderFooter(type);
            let headerFooter = this.documentHelper.headersFooters[sectionIndex][index];
            if (!headerFooter) {
                let currentSecIndex = sectionIndex > 0 ? sectionIndex - 1 : sectionIndex;
                while (!headerFooter && currentSecIndex !== -1) {
                    headerFooter = this.documentHelper.headersFooters[currentSecIndex][index];
                    currentSecIndex--;
                }
                if (!headerFooter) {
                    headerFooter = this.createHeaderFooterWidget(type);
                    headerFooter.isEmpty = true;
                }
                if (sectionIndex == 0) {
                    this.documentHelper.headersFooters[sectionIndex][index] = headerFooter;
                }
            }
            return headerFooter;
        }
        else if (sectionIndex > 0) {
            return this.getCurrentHeaderFooter(type, sectionIndex - 1);
        }
        return undefined;
    }
    createHeaderFooterWidget(type) {
        const headerFooter = new HeaderFooterWidget(type);
        const paragraph = new ParagraphWidget();
        paragraph.childWidgets.push(new LineWidget(paragraph));
        let style;
        if (type.indexOf('Header') !== -1) {
            style = this.documentHelper.styles.findByName('Header');
        }
        else {
            style = this.documentHelper.styles.findByName('Footer');
        }
        paragraph.paragraphFormat.baseStyle = style;
        paragraph.paragraphFormat.listFormat.baseStyle = style;
        headerFooter.childWidgets.push(paragraph);
        paragraph.containerWidget = headerFooter;
        return headerFooter;
    }
    getHeaderFooter(type) {
        switch (type) {
            case 'OddHeader':
                return 0;
            case 'OddFooter':
                return 1;
            case 'EvenHeader':
                return 2;
            case 'EvenFooter':
                return 3;
            case 'FirstPageHeader':
                return 4;
            case 'FirstPageFooter':
                return 5;
        }
    }
    updateHFClientArea(sectionFormat, isHeader) {
        let width = HelperMethods.convertPointToPixel(sectionFormat.pageWidth - sectionFormat.leftMargin - sectionFormat.rightMargin);
        if (width < 0) {
            width = 0;
        }
        if (isHeader) {
            this.clientArea = new Rect(HelperMethods.convertPointToPixel(sectionFormat.leftMargin), HelperMethods.convertPointToPixel(sectionFormat.headerDistance), width, Number.POSITIVE_INFINITY);
        }
        else {
            this.clientArea = new Rect(HelperMethods.convertPointToPixel(sectionFormat.leftMargin), HelperMethods.convertPointToPixel(sectionFormat.pageHeight - sectionFormat.footerDistance), width, Number.POSITIVE_INFINITY);
        }
        this.clientActiveArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, this.clientArea.height);
    }
    updateHeaderFooterClientAreaWithTop(sectionFormat, isHeader, page) {
        this.updateHFClientArea(sectionFormat, isHeader);
        if (!isHeader) {
            if (page.footerWidget.y < this.clientActiveArea.y) {
                this.clientActiveArea.y = page.footerWidget.y;
                this.clientActiveArea.height = Number.POSITIVE_INFINITY;
            }
        }
    }
    updateFootnoteClientArea(sectionFormat, footnote, footNoteType, para) {
        let width = HelperMethods.convertPointToPixel(sectionFormat.pageWidth - sectionFormat.leftMargin - sectionFormat.rightMargin);
        let left = HelperMethods.convertPointToPixel(sectionFormat.leftMargin);
        let bottomMargin = HelperMethods.convertPointToPixel(sectionFormat.bottomMargin);
        let footerDistance = HelperMethods.convertPointToPixel(sectionFormat.footerDistance);
        let top = HelperMethods.convertPointToPixel(sectionFormat.pageHeight) - Math.max(footerDistance + footnote.page.footerWidget.height, bottomMargin);
        this.clientArea = new Rect(left, top, width, Number.POSITIVE_INFINITY);
        this.clientActiveArea = new Rect(this.clientArea.x, this.clientArea.y, this.clientArea.width, Number.POSITIVE_INFINITY);
    }
    scrollToPage(pageIndex) {
        let top = 0;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            top = (this.documentHelper.pages[i].boundingRectangle.y * (this.documentHelper.zoomFactor > 1 ? this.documentHelper.zoomFactor : 1)) - (this.pageGap / 2);
            if (i === pageIndex) {
                break;
            }
        }
        this.documentHelper.viewerContainer.scrollTop = top;
        this.updateScrollBars();
    }
    updateScrollBars() {
        let updatePositionObj;
        updatePositionObj = this.getPageHeightAndWidth(0, 0, 0, 0);
        let containerWidth = (updatePositionObj.width * this.documentHelper.zoomFactor) + (this.pageLeft * 2);
        let containerHeight = (updatePositionObj.height * this.documentHelper.zoomFactor) + (this.documentHelper.pages.length + 1) * this.pageGap;
        let updateObj;
        updateObj = this.updateCanvasWidthAndHeight(updatePositionObj.viewerWidth, updatePositionObj.viewerHeight, containerHeight, containerWidth, updatePositionObj.width, updatePositionObj.height);
        containerHeight = updateObj.containerHeight;
        containerWidth = updateObj.containerWidth;
        this.documentHelper.containerContext.globalAlpha = 1;
        this.documentHelper.selectionContext.globalAlpha = 0.4;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            let left = (updateObj.width - this.documentHelper.pages[i].boundingRectangle.width * this.documentHelper.zoomFactor) / 2;
            if (left > this.pageLeft) {
                this.documentHelper.pages[i].boundingRectangle = new Rect(left, this.documentHelper.pages[i].boundingRectangle.y, this.documentHelper.pages[i].boundingRectangle.width, this.documentHelper.pages[i].boundingRectangle.height);
            }
            else {
                this.documentHelper.pages[i].boundingRectangle = new Rect(this.pageLeft, this.documentHelper.pages[i].boundingRectangle.y, this.documentHelper.pages[i].boundingRectangle.width, this.documentHelper.pages[i].boundingRectangle.height);
            }
        }
        this.updateScrollBarPosition(containerWidth, containerHeight, updateObj.viewerWidth, updateObj.viewerHeight, updateObj.width, updateObj.height);
        this.updateVisiblePages();
        this.documentHelper.isScrollToSpellCheck = false;
    }
    updateVisiblePages() {
        // Clears the container first.
        this.visiblePages = [];
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            let page = this.documentHelper.pages[i];
            let y = (page.boundingRectangle.y - this.pageGap * (i + 1)) * this.documentHelper.zoomFactor + this.pageGap * (i + 1);
            let left = page.boundingRectangle.x;
            //UI Virtualization
            if (this.documentHelper.isPageInVisibleBound(page, y)) {
                this.addVisiblePage(page, left, y);
            }
        }
    }
    addVisiblePage(page, x, y) {
        let width = page.boundingRectangle.width * this.documentHelper.zoomFactor;
        let height = page.boundingRectangle.height * this.documentHelper.zoomFactor;
        if (this.owner.enableImageResizerMode && this.owner.imageResizerModule.currentPage !== undefined && this.owner.imageResizerModule.currentPage === page && this.owner.imageResizerModule.isImageResizerVisible) {
            this.owner.imageResizerModule.setImageResizerPositions(x, y, width, height);
        }
        const pictureElement = this.owner.element.querySelector('#' + this.owner.element.id + 'PICTURE_CONTENT_CONTROL');
        if (!isNullOrUndefined(pictureElement) && pictureElement.style.display !== 'none') {
            this.owner.setPictureContentControlPositions(pictureElement);
        }
        this.visiblePages.push(page);
        if (this.documentHelper.owner.isSpellCheck && this.documentHelper.owner.spellCheckerModule.enableOptimizedSpellCheck && (this.owner.documentHelper.triggerElementsOnLoading || this.owner.documentHelper.isScrollHandler) && (this.documentHelper.cachedPages.indexOf(page.index) < 0 || this.owner.editorModule.isPasteContentCheck)) {
            this.owner.documentHelper.cachedPages.push(page.index);
            let content;
            if (this.owner.editorModule.isPasteContentCheck) {
                content = !isNullOrUndefined(this.owner.editorModule.copiedTextContent) ? this.owner.editorModule.copiedTextContent : '';
            }
            else {
                content = this.documentHelper.owner.spellCheckerModule.getPageContent(page);
            }
            if (content.trim().length > 0) {
                page.allowNextPageRendering = false;
                if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.owner.spellCheckerModule)) {
                    this.owner.spellCheckerModule.updateUniqueWords(HelperMethods.getSpellCheckData(content));
                }
                /* eslint-disable @typescript-eslint/no-explicit-any */
                this.owner.spellCheckerModule.callSpellChecker(this.owner.spellCheckerModule.languageID, content, true, false, false, true).then((data) => {
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    let jsonObject = JSON.parse(data);
                    if (!isNullOrUndefined(this.owner)) {
                        if (!isNullOrUndefined(this.owner.spellCheckerModule)) {
                            this.owner.spellCheckerModule.updateUniqueWords(jsonObject.SpellCollection);
                        }
                        if (!isNullOrUndefined(page)) {
                            page.allowNextPageRendering = true;
                        }
                        if (!isNullOrUndefined(this.documentHelper)) {
                            this.documentHelper.triggerElementsOnLoading = true;
                            this.documentHelper.triggerSpellCheck = true;
                            this.documentHelper.triggerElementsOnLoading = true;
                            this.renderPage(page, x, y, width, height);
                            this.documentHelper.triggerSpellCheck = false;
                            this.documentHelper.triggerElementsOnLoading = false;
                        }
                    }
                })
                    .catch();
                {
                    if (!isNullOrUndefined(page)) {
                        page.allowNextPageRendering = true;
                    }
                }
            }
            else {
                this.renderPage(page, x, y, width, height);
            }
        }
        else {
            this.renderPage(page, x, y, width, height);
        }
    }
    renderPage(page, x, y, width, height) {
        // When redering the page if the spell check is enabled, then get the unique words from local storage and after rendring, again add it to the local storage.
        // This is done to avoid the performance issue while rendering the page. Becuase for element we serializing and parsing from local storage cause performance issue.
        // So we are doing this to avoid the performance issue.
        if (this.documentHelper.owner.isSpellCheck) {
            this.documentHelper.owner.spellCheckerModule.getUniqueWordsFromLocalStorage();
        }
        this.documentHelper.render.renderWidgets(page, x - this.owner.viewer.containerLeft, y - this.owner.viewer.containerTop, width, height);
        if (this.documentHelper.owner.isSpellCheck) {
            this.documentHelper.owner.spellCheckerModule.addUniqueWordsToLocalStorage();
        }
    }
}
export class WebLayoutViewer extends LayoutViewer {
    constructor(owner) {
        super(owner);
        /**
         * @private
         */
        this.visiblePages = [];
        /* if (isNullOrUndefined(owner) || isNullOrUndefined(owner.element)) {
             return;
         }*/
        this.owner = owner;
    }
    get documentHelper() {
        try {
            return this.owner.documentHelper;
        }
        catch (_a) {
            return undefined;
        }
    }
    /**
     * @private
     */
    get pageGap() {
        return 0;
    }
    /**
     * Creates new page.
     * @private
     */
    createNewPage(section, index) {
        let page;
        let yPos = 0;
        let x = 10;
        if (this.documentHelper.pages.length > 0) {
            yPos = this.documentHelper.pages[this.documentHelper.pages.length - 1].boundingRectangle.bottom;
        }
        page = new Page(this.documentHelper);
        if (this.documentHelper.pages.length === 0) {
            page.boundingRectangle = new Rect(x, yPos, this.documentHelper.visibleBounds.width, this.documentHelper.visibleBounds.height);
        }
        else {
            page.boundingRectangle = new Rect(x, yPos - 20, this.documentHelper.visibleBounds.width, this.documentHelper.visibleBounds.height);
        }
        this.documentHelper.pages.push(page);
        this.updateClientArea(undefined, page);
        page.bodyWidgets.push(section);
        page.bodyWidgets[page.bodyWidgets.length - 1].page = page;
        return page;
    }
    onPageFitTypeChanged(pageFitType) {
        this.documentHelper.zoomFactor = 1;
    }
    scrollToPage(pageIndex) {
        this.updateScrollBars();
    }
    getContentHeight() {
        let height = 0;
        let boundingRectHeight = 0;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            let page = this.documentHelper.pages[i];
            if (i === 0) {
                height += this.padding.top;
                page.boundingRectangle.y = this.padding.top;
            }
            else {
                page.boundingRectangle.y = this.documentHelper.pages[i - 1].boundingRectangle.bottom;
            }
            for (let j = 0; j < page.bodyWidgets.length; j++) {
                height += page.bodyWidgets[j].height;
                boundingRectHeight += page.bodyWidgets[j].height;
            }
            page.boundingRectangle.height = boundingRectHeight;
            if (i === this.documentHelper.pages.length - 1) {
                height += this.padding.bottom;
            }
        }
        return height;
    }
    /**
     * @private
     */
    getContentWidth() {
        let width = this.documentHelper.visibleBounds.width;
        let currentWidth = width;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            let page = this.documentHelper.pages[i];
            for (let j = 0; j < page.bodyWidgets[0].childWidgets.length; j++) {
                if (page.bodyWidgets[0].childWidgets[j] instanceof TableWidget) {
                    let tableWidget = page.bodyWidgets[0].childWidgets[j];
                    let tableWidth = HelperMethods.convertPointToPixel(tableWidget.getTableWidth()) *
                        this.documentHelper.zoomFactor + this.padding.left * 4 + this.padding.right * 4
                        + page.boundingRectangle.x;
                    if (currentWidth < tableWidth) {
                        width = tableWidth;
                        currentWidth = tableWidth;
                    }
                }
            }
            page.boundingRectangle.width = width;
        }
        return width;
    }
    updateScrollBars() {
        let updatePositionObj;
        updatePositionObj = this.getPageHeightAndWidth(0, 0, 0, 0);
        let containerWidth = this.getContentWidth() * this.documentHelper.zoomFactor;
        let containerHeight = this.getContentHeight() * this.documentHelper.zoomFactor + this.padding.top + this.padding.bottom;
        let updateObj;
        updateObj = this.updateCanvasWidthAndHeight(updatePositionObj.viewerWidth, updatePositionObj.viewerHeight, containerHeight, containerWidth, updatePositionObj.width, updatePositionObj.height);
        this.documentHelper.containerContext.globalAlpha = 1;
        this.documentHelper.selectionContext.globalAlpha = 0.4;
        this.updateScrollBarPosition(containerWidth, containerHeight, updateObj.viewerWidth, updateObj.viewerHeight, updateObj.width, updateObj.height);
        this.updateVisiblePages();
        this.documentHelper.isScrollToSpellCheck = false;
    }
    updateVisiblePages() {
        this.visiblePages = [];
        let page;
        let y;
        let height = this.documentHelper.visibleBounds.height;
        let vertical = this.documentHelper.viewerContainer.scrollTop;
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            page = this.documentHelper.pages[i];
            y = (page.boundingRectangle.y) * this.documentHelper.zoomFactor;
            let pageH = page.boundingRectangle.height * this.documentHelper.zoomFactor;
            let isTopFit = y >= vertical && y <= vertical + height;
            let isBottomFit = y + pageH >= vertical && y + pageH <= vertical + height;
            let isMiddleFit = y <= vertical && y + pageH >= vertical + height;
            //UI Virtualization
            if (isTopFit || isBottomFit || isMiddleFit) {
                this.addVisiblePage(page, this.padding.left, y);
            }
        }
    }
    addVisiblePage(page, x, y) {
        let width = this.getContentWidth();
        let height = this.getContentHeight() * this.documentHelper.zoomFactor + this.padding.top + this.padding.bottom;
        if (this.owner.enableImageResizerMode && this.owner.imageResizerModule.currentPage !== undefined && this.owner.imageResizerModule.currentPage === page && this.owner.imageResizerModule.isImageResizerVisible) {
            this.owner.imageResizerModule.setImageResizerPositions(x, y, width, height);
        }
        const pictureElement = this.owner.element.querySelector('#' + this.owner.element.id + 'PICTURE_CONTENT_CONTROL');
        if (!isNullOrUndefined(pictureElement) && pictureElement.style.display !== 'none') {
            this.owner.setPictureContentControlPositions(pictureElement);
        }
        this.visiblePages.push(page);
        if (this.documentHelper.owner.isSpellCheck && this.documentHelper.owner.spellCheckerModule.enableOptimizedSpellCheck && (this.owner.documentHelper.triggerElementsOnLoading || this.owner.documentHelper.isScrollHandler) && (this.documentHelper.cachedPages.indexOf(page.index) < 0 || this.owner.editorModule.isPasteContentCheck)) {
            this.owner.documentHelper.cachedPages.push(page.index);
            let contentlen;
            if (this.owner.editorModule.isPasteContentCheck) {
                contentlen = !isNullOrUndefined(this.owner.editorModule.copiedTextContent) ? this.owner.editorModule.copiedTextContent : '';
            }
            else {
                contentlen = this.documentHelper.owner.spellCheckerModule.getPageContent(page);
            }
            if (contentlen.trim().length > 0) {
                page.allowNextPageRendering = false;
                if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.owner.spellCheckerModule)) {
                    this.owner.spellCheckerModule.updateUniqueWords(HelperMethods.getSpellCheckData(contentlen));
                }
                /* eslint-disable @typescript-eslint/no-explicit-any */
                this.owner.spellCheckerModule.callSpellChecker(this.owner.spellCheckerModule.languageID, contentlen, true, false, false, true).then((data) => {
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    let jsonObj = JSON.parse(data);
                    if (!isNullOrUndefined(this.owner)) {
                        if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.owner.spellCheckerModule)) {
                            this.owner.spellCheckerModule.updateUniqueWords(jsonObj.SpellCollection);
                        }
                        page.allowNextPageRendering = true;
                        if (!isNullOrUndefined(this.documentHelper)) {
                            this.documentHelper.triggerSpellCheck = true;
                            this.documentHelper.triggerElementsOnLoading = true;
                            this.renderPage(page, x, y, width, height);
                            this.documentHelper.triggerSpellCheck = false;
                            this.documentHelper.triggerElementsOnLoading = false;
                        }
                    }
                })
                    .catch();
                {
                    if (!isNullOrUndefined(page)) {
                        page.allowNextPageRendering = true;
                    }
                }
            }
            else {
                this.renderPage(page, x, y, width, height);
            }
        }
        else {
            this.renderPage(page, x, y, width, height);
        }
    }
    /**
     * @private
     */
    renderPage(page, x, y, width, height) {
        // When redering the page if the spell check is enabled, then get the unique words from local storage and after rendring, again add it to the local storage.
        // This is done to avoid the performance issue while rendering the page. Becuase for element we serializing and parsing from local storage cause performance issue.
        // So we are doing this to avoid the performance issue.
        if (this.documentHelper.owner.isSpellCheck) {
            this.documentHelper.owner.spellCheckerModule.getUniqueWordsFromLocalStorage();
        }
        this.documentHelper.render.renderWidgets(page, x - this.owner.viewer.containerLeft, y - this.owner.viewer.containerTop, width, height);
        if (this.documentHelper.owner.isSpellCheck) {
            this.documentHelper.owner.spellCheckerModule.addUniqueWordsToLocalStorage();
        }
    }
}
/**
 * @private
 */
export class ColumnLayout {
    get currentIndex() {
        return this.currentIndexIn;
    }
    set currentIndex(value) {
        if (value >= 0) {
            this.currentIndexIn = value;
        }
    }
    /**
     * Initialize the constructor of Column Layout Settings
     */
    constructor(viewer) {
        this.viewerIn = viewer;
        this.clear();
    }
    get columnCount() {
        let colCount;
        if (!isNullOrUndefined(this.columnIn)) {
            colCount = this.numberOfColumnsIn;
        }
        colCount = colCount > 0 ? colCount : 1;
        return colCount;
    }
    /**
     * @private
     * @param sectionFormat
     */
    setColumns(sectionFormat) {
        this.pageWidth = HelperMethods.convertPointToPixel(sectionFormat.pageWidth - sectionFormat.leftMargin - sectionFormat.rightMargin);
        this.numberOfColumnsIn = sectionFormat.numberOfColumns;
        if (!isNullOrUndefined(sectionFormat.columns)) {
            let columns = sectionFormat.columns;
            let columnList = [];
            for (let i = 0; i < sectionFormat.numberOfColumns; i++) {
                let space = this.defaultSpaceIn;
                let width = 0;
                if (!isNullOrUndefined(columns) && columns.length > 0) {
                    space = columns[i].space;
                    width = columns[i].width;
                }
                let col = this.getColumnObj(width, space, sectionFormat.numberOfColumns, sectionFormat.equalWidth);
                col.index = i;
                columnList.push(col);
            }
            this.columnIn = columnList;
        }
    }
    /**
     * @private
     */
    clear() {
        this.currentIndexIn = 0;
        this.defaultSpaceIn = 36;
        this.columnIn = null;
        this.pageWidth = 0;
    }
    reset() {
        this.currentIndex = 0;
    }
    /**
     * @private
     * @param bodyWidget
     * @param clientArea
     * @returns
     */
    getColumnBounds(bodyWidget, clientArea) {
        let colIndex = this.currentIndexIn;
        return this.getColumnBoundsByIndex(colIndex, clientArea);
    }
    /**
     * @private
     * @param bodyWidget
     * @param clientArea
     * @returns
     */
    getColumnBoundsByBodyWidget(bodyWidget, clientArea) {
        let colIndex = bodyWidget.columnIndex;
        return this.getColumnBoundsByIndex(colIndex, clientArea);
    }
    /**
     * @private
     * @param bodyWidget
     * @param clientArea
     * @returns
     */
    getNextColumnByBodyWidget(bodyWidget) {
        let colIndex = bodyWidget.columnIndex;
        let nextColumn = this.getColumnByIndex(colIndex + 1);
        return nextColumn;
    }
    getColumnByIndex(index) {
        if (index >= 0 && index < this.columnCount && !isNullOrUndefined(this.columnIn) && this.columnIn.length > 0) {
            return this.columnIn[index];
        }
        return undefined;
    }
    getColumnObj(colWidth, colSpace, noOfCols, isEqualWidth) {
        let totalSpace = (noOfCols - 1) * colSpace;
        let colObj = new WColumnFormat();
        if ((isEqualWidth || colWidth === 0) && !isNullOrUndefined(this.pageWidth)) {
            colWidth = (this.pageWidth - totalSpace) / noOfCols;
        }
        colObj.width = colWidth;
        colObj.space = colSpace;
        return colObj;
    }
    getColumnBoundsByIndex(colIndex, clientArea) {
        let colRect = new Rect(clientArea.x, clientArea.y, clientArea.width, clientArea.height);
        if (colIndex >= 0 && this.columnIn.length > 0) {
            let curColumn;
            let prevColumn;
            if (!isNullOrUndefined(this.columnIn[colIndex])) {
                curColumn = this.getColumnByIndex(colIndex);
                colRect.width = curColumn.width;
                for (let i = 0; i < colIndex; i++) {
                    prevColumn = this.columnIn[i];
                    colRect.x += prevColumn.width;
                    colRect.x += prevColumn.space;
                }
            }
        }
        return colRect;
    }
}
